import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  Long: { input: number; output: number; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
  /** Represents NULL values */
  Void: { input: null; output: null; }
};

export type Account = {
  accountType: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['NonEmptyString']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<AccountPreferences>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<AccountSocialLinks>;
};

export type AccountPreferences = {
  __typename?: 'AccountPreferences';
  /** Yes, I would like Kijiji and its corporate family members to contact me about events, new features, and other promotional information. */
  contactMe: Scalars['Boolean']['output'];
  /** Hide the visit counter on my ads (Only you will be able to see the visits number using My Ads). */
  hideVisit: Scalars['Boolean']['output'];
  /** Send me Bump Up and other feature notification emails. */
  pushNotification: Scalars['Boolean']['output'];
  /** Read Receipts enabled (others will see when I've read their messages). */
  readReciepts: Scalars['Boolean']['output'];
};

export type AccountSocialLinks = {
  __typename?: 'AccountSocialLinks';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type Ad = MoveAd | OrganicAd;

export type AdCommon = {
  categoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Price>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdData = {
  __typename?: 'AdData';
  adId: Scalars['ID']['output'];
};

export type AdDataPair = {
  __typename?: 'AdDataPair';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AdFeedbackSource {
  MarkAsSold = 'MARK_AS_SOLD',
  MyKijiji = 'MY_KIJIJI',
  Svip = 'SVIP'
}

export type AdLocation = {
  __typename?: 'AdLocation';
  distance?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export enum AdSource {
  Cas = 'CAS',
  Move = 'MOVE',
  Organic = 'ORGANIC',
  ProvTopAd = 'PROV_TOP_AD',
  TopAd = 'TOP_AD',
  VerticalAutos = 'VERTICAL_AUTOS'
}

export enum AdSourceType {
  A = 'A',
  C = 'C',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Z = 'Z'
}

export enum AdType {
  None = 'NONE',
  Offer = 'OFFER',
  Wanted = 'WANTED'
}

export enum AdditionalFlags {
  Carproof = 'CARPROOF',
  CategorySpecificBadge = 'CATEGORY_SPECIFIC_BADGE',
  Cpo = 'CPO',
  FinancingAvailable = 'FINANCING_AVAILABLE',
  Gallery = 'GALLERY',
  Highlight = 'HIGHLIGHT',
  Images = 'IMAGES',
  PriceDrop = 'PRICE_DROP',
  TopAd = 'TOP_AD',
  VeteranFriendly = 'VETERAN_FRIENDLY',
  Videos = 'VIDEOS',
  VirtualTour = 'VIRTUAL_TOUR'
}

export type AdditionalFlagsFilterInput = {
  filterName: Scalars['String']['input'];
  flags: Array<AdditionalFlags>;
};

export type AddressFormat = {
  __typename?: 'AddressFormat';
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type AmountPrice = {
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  originalAmount?: Maybe<Scalars['Float']['output']>;
  type: ListingPriceType;
};

export type AppDownloadBannerState = {
  __typename?: 'AppDownloadBannerState';
  isVisible: Scalars['Boolean']['output'];
};

export type AppliedAdditionalFlagsFilter = AppliedFilter & {
  __typename?: 'AppliedAdditionalFlagsFilter';
  filterName: Scalars['String']['output'];
  flags: Array<AdditionalFlags>;
};

export type AppliedAttributeFilter = AppliedFilter & {
  __typename?: 'AppliedAttributeFilter';
  filterName: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type AppliedDateFilter = AppliedFilter & {
  __typename?: 'AppliedDateFilter';
  dateSearchRangeBound?: Maybe<Scalars['String']['output']>;
  filterName: Scalars['String']['output'];
  value: Scalars['Date']['output'];
};

export type AppliedDateRangeFilter = AppliedFilter & {
  __typename?: 'AppliedDateRangeFilter';
  end?: Maybe<Scalars['Date']['output']>;
  filterName: Scalars['String']['output'];
  start?: Maybe<Scalars['Date']['output']>;
};

export type AppliedFilter = {
  filterName: Scalars['String']['output'];
};

export type AppliedRangeFilter = AppliedFilter & {
  __typename?: 'AppliedRangeFilter';
  filterName: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
};

export type AppliedToggleFilter = AppliedFilter & {
  __typename?: 'AppliedToggleFilter';
  filterName: Scalars['String']['output'];
  toggleValue: Scalars['String']['output'];
};

/** Shared Inputs */
export type AreaLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Radius should be in kilometres */
  radius: Scalars['Int']['input'];
};

export type Attribute = {
  __typename?: 'Attribute';
  canonicalName?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  controlRange?: Maybe<IntegerRange>;
  controlType?: Maybe<ControlType>;
  id: Scalars['Int']['output'];
  isBoolean?: Maybe<Scalars['Boolean']['output']>;
  localizedFields?: Maybe<Array<Maybe<AttributeFields>>>;
  localizedNames?: Maybe<AttributeNames>;
  required: Scalars['Boolean']['output'];
};


export type AttributeLocalizedFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type AttributeLocalizedNamesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeFields = {
  __typename?: 'AttributeFields';
  canonicalValue?: Maybe<Scalars['String']['output']>;
  seoSlug?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Schema for Tree Select, Checkbox, Multi-Select, and Toggles Controls */
export type AttributeFilter = Filter & {
  __typename?: 'AttributeFilter';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  selectedValues?: Maybe<Array<Scalars['String']['output']>>;
  type: FilterControlType;
  values?: Maybe<Array<AttributeValue>>;
};

export type AttributeFilterInput = {
  filterName: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type AttributeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeMap = {
  __typename?: 'AttributeMap';
  carbodytype_s?: Maybe<Scalars['String']['output']>;
  carcolor_s?: Maybe<Scalars['String']['output']>;
  carfueltype_s?: Maybe<Scalars['String']['output']>;
  carmake_s?: Maybe<Scalars['String']['output']>;
  carmileageinkms_i?: Maybe<Scalars['String']['output']>;
  carmodel_s?: Maybe<Scalars['String']['output']>;
  cartransmission_s?: Maybe<Scalars['String']['output']>;
  cartrim_s?: Maybe<Scalars['String']['output']>;
  caryear_i?: Maybe<Scalars['String']['output']>;
  drivetrain_s?: Maybe<Scalars['String']['output']>;
  forsaleby_s?: Maybe<Scalars['String']['output']>;
  furnished_s?: Maybe<Scalars['String']['output']>;
  numberbathrooms_s?: Maybe<Scalars['String']['output']>;
  numberbedrooms_s?: Maybe<Scalars['String']['output']>;
  petsallowed_s?: Maybe<Scalars['String']['output']>;
  phonebrand_s?: Maybe<Scalars['String']['output']>;
  phonecarrier_s?: Maybe<Scalars['String']['output']>;
  size_s?: Maybe<Scalars['String']['output']>;
  stock_s?: Maybe<Scalars['String']['output']>;
  unittype_s?: Maybe<Scalars['String']['output']>;
  vehicletype_s?: Maybe<Scalars['String']['output']>;
  vin_s?: Maybe<Scalars['String']['output']>;
};

export type AttributeNames = {
  __typename?: 'AttributeNames';
  groupName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subGroupName?: Maybe<Scalars['String']['output']>;
};

export type AttributeValue = {
  __typename?: 'AttributeValue';
  label: Scalars['String']['output'];
  parentValue?: Maybe<Scalars['String']['output']>;
  /** Only applies to category and location attribute values that have more than 5 results */
  seoUrl?: Maybe<Scalars['URL']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type AuthModalState = {
  __typename?: 'AuthModalState';
  callbackUrl?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  isModalOpen: Scalars['Boolean']['output'];
  modalVariant?: Maybe<AuthModalVariant>;
};

export enum AuthModalVariant {
  GuestMessage = 'GUEST_MESSAGE',
  LoginToFavourite = 'LOGIN_TO_FAVOURITE',
  LoginToFinanceInquiry = 'LOGIN_TO_FINANCE_INQUIRY',
  LoginToMessage = 'LOGIN_TO_MESSAGE',
  LoginToRequestViewing = 'LOGIN_TO_REQUEST_VIEWING'
}

export type AutocompleteCategory = {
  __typename?: 'AutocompleteCategory';
  id: Scalars['String']['output'];
  localizedName: Scalars['String']['output'];
};

export type AutocompleteSuggestion = {
  __typename?: 'AutocompleteSuggestion';
  categories: Array<AutocompleteCategory>;
  completion: Scalars['String']['output'];
};

export type AutocompleteSuggestionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type AutosDealerAmountPrice = AmountPrice & ListingPrice & {
  __typename?: 'AutosDealerAmountPrice';
  amount: Scalars['Float']['output'];
  classification?: Maybe<ListingPriceClassification>;
  currency: Scalars['String']['output'];
  msrp?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
  surcharges: AutosSurcharges;
  type: ListingPriceType;
};

export type AutosInstantCashEstimate = {
  __typename?: 'AutosInstantCashEstimate';
  clickoutId: Scalars['ID']['output'];
  listingId: Scalars['ID']['output'];
  lowerValue: Scalars['Int']['output'];
  upperValue: Scalars['Int']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type AutosInstantCashOffer = {
  __typename?: 'AutosInstantCashOffer';
  clickoutId: Scalars['ID']['output'];
  clickoutUrl: Scalars['URL']['output'];
  listingId: Scalars['ID']['output'];
  offer: Scalars['Int']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type AutosInstantCashUnion = AutosInstantCashEstimate | AutosInstantCashOffer;

export type AutosListing = FullListing & Listing & {
  __typename?: 'AutosListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  /** Autos Listing fields */
  attributes: AutosListingAttributes;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  favouriteDate?: Maybe<Scalars['DateTime']['output']>;
  flags: AutosListingFlags;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Int']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  metrics?: Maybe<ListingMetrics>;
  mileageAnalysis?: Maybe<MileageAnalysis>;
  moveUrl?: Maybe<Scalars['URL']['output']>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  productUrl?: Maybe<Scalars['URL']['output']>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  status: ListingStatus;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type AutosListingAttributes = ListingAttributes & {
  __typename?: 'AutosListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  /** Listing attributes that only apply to Autos categories */
  carfaxUrl?: Maybe<Scalars['URL']['output']>;
  cpoProgram?: Maybe<Scalars['Boolean']['output']>;
  forSaleBy?: Maybe<Scalars['String']['output']>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type AutosListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AutosListingFlags = ListingFlags & {
  __typename?: 'AutosListingFlags';
  /** Listing flags that only apply to Autos categories */
  carfaxAvailable?: Maybe<Scalars['Boolean']['output']>;
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  chatOptIn?: Maybe<Scalars['Boolean']['output']>;
  creditOptIn?: Maybe<Scalars['Boolean']['output']>;
  enhancedContactForm?: Maybe<Scalars['Boolean']['output']>;
  financingAvailable?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isFromAutosDealer?: Maybe<Scalars['Boolean']['output']>;
  /** Listing flags computed with listing data */
  isFromDealer?: Maybe<Scalars['Boolean']['output']>;
  isMoVe?: Maybe<Scalars['Boolean']['output']>;
  isPint?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  isSM360?: Maybe<Scalars['Boolean']['output']>;
  isVerticalCategory?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  provTopAd?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
  tradeInOptIn?: Maybe<Scalars['Boolean']['output']>;
};

export enum AutosSurcharges {
  NoTax = 'NO_TAX',
  PlusGst = 'PLUS_GST',
  PlusTaxes = 'PLUS_TAXES',
  PlusTaxesLuxurySurcharge = 'PLUS_TAXES_LUXURY_SURCHARGE'
}

export type AutosWarrantyEstimate = {
  __typename?: 'AutosWarrantyEstimate';
  asLowAsPerMonth: Scalars['Int']['output'];
  coverageTermInMonths: Scalars['Int']['output'];
  downPayment: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  offerExpiry: Scalars['DateTime']['output'];
  paymentTermInMonths: Scalars['Int']['output'];
};

export type AveragePrice = {
  __typename?: 'AveragePrice';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BackgroundAdType = {
  __typename?: 'BackgroundAdType';
  color?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type BackgroundType = {
  __typename?: 'BackgroundType';
  altText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type BaseListing = {
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  title: Scalars['String']['output'];
};

export enum BlendingPattern {
  Largest = 'LARGEST',
  Repeat = 'REPEAT'
}

export type BoundingBox = {
  __typename?: 'BoundingBox';
  ne: LocationCoordinates;
  sw: LocationCoordinates;
};

export type BoundingBoxInput = {
  ne: LocationCoordinatesInput;
  sw: LocationCoordinatesInput;
};

export type BoxFields = {
  __typename?: 'BoxFields';
  kjses?: Maybe<Scalars['String']['output']>;
  xsrfToken?: Maybe<Scalars['String']['output']>;
};

export type BrandedCategoryItem = {
  __typename?: 'BrandedCategoryItem';
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BrowseHeroModule = {
  __typename?: 'BrowseHeroModule';
  component: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  tiles: Array<Maybe<BrowseTile>>;
  title: Array<Maybe<CustomizedText>>;
};

export type BrowseTile = {
  __typename?: 'BrowseTile';
  background?: Maybe<BackgroundType>;
  link: LinkType;
  title: Scalars['String']['output'];
  tracking?: Maybe<Tracking>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Cta = {
  __typename?: 'CTA';
  altText?: Maybe<Scalars['String']['output']>;
  link: LinkType;
  text: Scalars['String']['output'];
  tracking?: Maybe<Tracking>;
};

export type Campaign = {
  __typename?: 'Campaign';
  customFields?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  labelImage?: Maybe<Scalars['String']['output']>;
  labelText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  categoryPath?: Maybe<Scalars['String']['output']>;
  categoryPaths?: Maybe<Array<Maybe<Category>>>;
  children?: Maybe<Array<Maybe<Category>>>;
  enabled?: Maybe<CategoryEnabled>;
  id: Scalars['Int']['output'];
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  isVacationRentals?: Maybe<Scalars['Boolean']['output']>;
  l1Category?: Maybe<Category>;
  localizedName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  searchSeoUrl?: Maybe<Scalars['String']['output']>;
};


export type CategoryAttributesArgs = {
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  isProfessionalUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<PageType>;
};


export type CategoryChildrenArgs = {
  filterDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryLocalizedNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CategorySearchSeoUrlArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryEnabled = {
  __typename?: 'CategoryEnabled';
  browsing?: Maybe<Scalars['Boolean']['output']>;
  posting?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryLink = {
  __typename?: 'CategoryLink';
  nameId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CategoryLinkInfo = {
  categoryId: Scalars['Int']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  nameId: Scalars['String']['input'];
};

export type ClientSelectionDetail = {
  __typename?: 'ClientSelectionDetail';
  conversationId: Scalars['String']['output'];
  lastMessage: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  receivedDate: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

/** Deprecated: Use CommercialProfileV2 instead */
export type CommercialProfile = {
  __typename?: 'CommercialProfile';
  address?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  /** @deprecated Use searchResultsLogoUrl, viewAdLogoUrl, merchantStoreLogoUrl instead */
  logo?: Maybe<Scalars['String']['output']>;
  memberSince?: Maybe<Scalars['Long']['output']>;
  merchantStoreLogoUrl?: Maybe<Scalars['String']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  searchResultsLogoUrl?: Maybe<Scalars['String']['output']>;
  staticMapUrl?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  viewAdLogoUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CommercialProfileV2 = ProfileV2 & {
  __typename?: 'CommercialProfileV2';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSalesforceEnabled: Scalars['Boolean']['output'];
  listings?: Maybe<Array<FullListing>>;
  logoUrl?: Maybe<Scalars['URL']['output']>;
  memberSince?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences: UserPreferences;
  profilePath?: Maybe<Scalars['String']['output']>;
  staticMapUrl?: Maybe<Scalars['URL']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  userType: UserType;
  websiteUrl?: Maybe<Scalars['URL']['output']>;
};


export type CommercialProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type CommercialProfileV2LogoUrlArgs = {
  size: LogoType;
};


export type CommercialProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PhoneNumberSource>;
};

export enum ContactType {
  New = 'NEW',
  Used = 'USED'
}

export type ContentModule = BrowseHeroModule;

export enum ContentModuleId {
  WelcomePopularBanner = 'WELCOME_POPULAR_BANNER'
}

export enum ControlType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Dropdown = 'DROPDOWN',
  IntegerRange = 'INTEGER_RANGE',
  MakeModel = 'MAKE_MODEL',
  String = 'STRING'
}

export type Conversation = {
  __typename?: 'Conversation';
  adId: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageNotification?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Maybe<Participant>>>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ConversationId = {
  __typename?: 'ConversationId';
  id?: Maybe<Scalars['String']['output']>;
};

export type CoreListing = Listing & {
  __typename?: 'CoreListing';
  adSource: AdSource;
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  price?: Maybe<ListingPrice>;
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type CovidResponse = {
  __typename?: 'CovidResponse';
  badges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dealerId?: Maybe<Scalars['Int']['output']>;
  dealerMessage?: Maybe<Scalars['String']['output']>;
  dealerWebsiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomizedText = {
  __typename?: 'CustomizedText';
  style?: Maybe<CustomizedTextStyle>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomizedTextStyle = {
  __typename?: 'CustomizedTextStyle';
  color?: Maybe<Scalars['String']['output']>;
  isBold?: Maybe<Scalars['Boolean']['output']>;
};

/** Schema for Single Date Filters */
export type DateFilter = Filter & {
  __typename?: 'DateFilter';
  dateSearchRangeBound?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  selectedValue?: Maybe<Scalars['Date']['output']>;
  type: FilterControlType;
};

export type DateFilterInput = {
  dateSearchRangeBound?: InputMaybe<Scalars['String']['input']>;
  filterName: Scalars['String']['input'];
  value: Scalars['Date']['input'];
};

export type DateRangeFilterInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  filterName: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type DeleteAdInputArgs = {
  adId: Scalars['Int']['input'];
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  sellDestination?: InputMaybe<SellDestination>;
  surveyEventInput?: InputMaybe<DeleteSurveyEventInput>;
};

export type DeleteSurveyEventInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientUserId?: InputMaybe<Scalars['Int']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  feedbackSource?: InputMaybe<AdFeedbackSource>;
  platform: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<SurveyQuestionInput>>>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<SurveyUserInput>;
};

export type Details = {
  billingToken?: InputMaybe<Scalars['String']['input']>;
  facilitatorAccessToken?: InputMaybe<Scalars['String']['input']>;
  orderID?: InputMaybe<Scalars['ID']['input']>;
  payerID?: InputMaybe<Scalars['ID']['input']>;
  paymentID?: InputMaybe<Scalars['ID']['input']>;
};

export enum DeviceType {
  Desktop = 'DESKTOP',
  Mweb = 'MWEB'
}

export enum Direction {
  B2S = 'B2S',
  Both = 'BOTH',
  S2B = 'S2B'
}

export type DismissedStates = {
  __typename?: 'DismissedStates';
  appDownloadPSA: Scalars['Boolean']['output'];
  siteMaintenancePSA_may27th: Scalars['Boolean']['output'];
};

export type DropInConfiguration = {
  __typename?: 'DropInConfiguration';
  clientKey: Scalars['String']['output'];
  environment: DropInEnvironment;
  paymentMethods: Scalars['String']['output'];
  paypalMerchantId: Scalars['String']['output'];
};

export enum DropInEnvironment {
  Live = 'LIVE',
  Test = 'TEST'
}

export type DynamicPhoneNumber = {
  __typename?: 'DynamicPhoneNumber';
  e164?: Maybe<Scalars['String']['output']>;
  local?: Maybe<Scalars['String']['output']>;
};

export type EasyPriceDropNotification = Notification & {
  __typename?: 'EasyPriceDropNotification';
  body: Scalars['String']['output'];
  data: AdData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EditAdPriceResponse = {
  __typename?: 'EditAdPriceResponse';
  status?: Maybe<EditAdPriceStatus>;
};

export type EditAdPriceStatus = {
  __typename?: 'EditAdPriceStatus';
  message?: Maybe<RepostAdStatus>;
  statusCode: Scalars['Int']['output'];
};

/** URL types for tracking events */
export enum EventsUrlType {
  PartnerPage = 'PARTNER_PAGE',
  SellerHomepage = 'SELLER_HOMEPAGE',
  SellerProductPage = 'SELLER_PRODUCT_PAGE'
}

export type ExternalListingSource = {
  __typename?: 'ExternalListingSource';
  sourceAdId?: Maybe<Scalars['String']['output']>;
  sourcePartnerId?: Maybe<Scalars['String']['output']>;
  sourceProviderId?: Maybe<Scalars['String']['output']>;
};

export type Favourite = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
};

export type FavouriteEntry = {
  __typename?: 'FavouriteEntry';
  adSource: AdSourceType;
  id: Scalars['Long']['output'];
};

export type FavouriteListing = {
  __typename?: 'FavouriteListing';
  adSource: AdSourceType;
  categoryId: Scalars['Int']['output'];
  creationDate: Scalars['String']['output'];
  favouriteDate: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  image?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Long']['output']>;
  priceType?: Maybe<PriceType>;
  title: Scalars['String']['output'];
};

export type FavouriteSearchActivateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationDetails: NotificationDetailsInput;
  /**
   * searchQuery will be formatted the same way it is for searchResultsPageUpdate
   * using parseInputQueryParams, as https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch
   * is expecting it in the same format as that used by the v2/listings endpoint
   */
  searchString: Scalars['String']['input'];
};

export type FavouriteSearchAlert = {
  __typename?: 'FavouriteSearchAlert';
  address?: Maybe<Scalars['String']['output']>;
  alertDestinations: Array<Maybe<FavouriteSearchAlertDestinations>>;
  alertId: Scalars['Int']['output'];
  category?: Maybe<Category>;
  creationDate: Scalars['String']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  listings?: Maybe<Array<FullListing>>;
  location?: Maybe<Location>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  radius?: Maybe<Scalars['Int']['output']>;
  seoUrl: Scalars['String']['output'];
};

export type FavouriteSearchAlertDestinations = {
  __typename?: 'FavouriteSearchAlertDestinations';
  active: Scalars['Boolean']['output'];
  destination: Scalars['String']['output'];
  destinationType: Scalars['String']['output'];
  frequency?: Maybe<Scalars['Int']['output']>;
};

export type FavouriteSearchIdLookupInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /**
   * searchQuery will be formatted the same way it is for searchResultsPageUpdate
   * using parseInputQueryParams, as https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch
   * is expecting it in the same format as that used by the v2/listings endpoint
   */
  searchString: Scalars['String']['input'];
};

export type FavouriteSearchIdLookupOutput = {
  __typename?: 'FavouriteSearchIdLookupOutput';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type FeedItem = BaseListing & {
  __typename?: 'FeedItem';
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price: Price;
  processorName?: Maybe<Scalars['String']['output']>;
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type FeedPageInfo = {
  __typename?: 'FeedPageInfo';
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAds?: Maybe<Scalars['Int']['output']>;
};

export type FeedRecommendations = {
  __typename?: 'FeedRecommendations';
  adSource?: Maybe<Scalars['String']['output']>;
  ads?: Maybe<Array<Maybe<FeedItem>>>;
  description: Scalars['String']['output'];
  seedId: Scalars['Int']['output'];
  seedType?: Maybe<Scalars['String']['output']>;
  seoUrl: Scalars['String']['output'];
};

export type FeedRecommendationsInput = {
  correlationId?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationPath?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationLimitOffset>;
  processor: RecommendationProcessor;
  /** @deprecated User ID will be abstracted from their access token instead. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedResults = BrandedCategoryItem | FeedItem | PopularCategoryItem;

export type FeedbackOption = {
  __typename?: 'FeedbackOption';
  contradictFeedbackId?: Maybe<Scalars['Int']['output']>;
  direction: Direction;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: FeedbackType;
};

export type FeedbackSummaryItem = {
  __typename?: 'FeedbackSummaryItem';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum FeedbackType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type Filter = {
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  type: FilterControlType;
};

export enum FilterControlType {
  Checkboxes = 'CHECKBOXES',
  Date = 'DATE',
  DateRange = 'DATE_RANGE',
  /**
   * The HAS_FILTERS are used by the SRP to filter listings based on specific attributes that are not tied to the category post ad flow in which the listing is posted.
   * For example, filters like “Ads with images” or “Ads with videos.”
   * Internally, the HAS_FILTERS values represent AdditionalFlags. Unlike other filters, their schema is different due to the nature of the data incoming from the backend.
   * Instead of using objects to relate to which filter name is applied, AdditionalFlags are just represented as a simple array of strings that only represents the values.
   */
  HasFilters = 'HAS_FILTERS',
  MultiSelect = 'MULTI_SELECT',
  Radio = 'RADIO',
  Range = 'RANGE',
  Toggles = 'TOGGLES',
  TreeSelect = 'TREE_SELECT',
  Unknown = 'UNKNOWN'
}

export type FilterGroup = {
  __typename?: 'FilterGroup';
  filters: Array<Filter>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** At the time of its implementation, this field is only used to determine the order of the quick filter pills in the SRP */
  quickFilterSortOrder?: Maybe<Scalars['Int']['output']>;
  shouldShowTopLevelAccordion?: Maybe<Scalars['Boolean']['output']>;
};

export enum FilterPriceType {
  Contact = 'CONTACT',
  Fixed = 'FIXED',
  GiveAway = 'GIVE_AWAY',
  SwapTrade = 'SWAP_TRADE'
}

export type FullListing = {
  /** Full Listing fields */
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  attributes?: Maybe<ListingAttributes>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  favouriteDate?: Maybe<Scalars['DateTime']['output']>;
  flags: ListingFlags;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Int']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  metrics?: Maybe<ListingMetrics>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  productUrl?: Maybe<Scalars['URL']['output']>;
  /** The date used to sort on SRP (handles bump-ups) */
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  status: ListingStatus;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type GalleryItem = {
  __typename?: 'GalleryItem';
  /** @deprecated Flag is no longer provided by backend */
  featured: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageAltText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  price?: Maybe<Price>;
  /** @deprecated Flag is no longer provided by backend */
  reduced: Scalars['Boolean']['output'];
  seoUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urgent: Scalars['Boolean']['output'];
};

export type GenerateXsrfResponse = {
  __typename?: 'GenerateXsrfResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  xsrf: Scalars['String']['output'];
};

export type GeocodeCanadianAddress = {
  __typename?: 'GeocodeCanadianAddress';
  city?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationCoordinates>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type GeocodeReverseFromIp = {
  __typename?: 'GeocodeReverseFromIp';
  city?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  province: ProvinceAbbreviation;
};

export type GeolocationInput = {
  accuracy: Scalars['Int']['input'];
  altitude?: InputMaybe<Scalars['Int']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Int']['input'];
  longitude: Scalars['Int']['input'];
  speed?: InputMaybe<Scalars['Int']['input']>;
  timestamp: Scalars['Int']['input'];
};

export type GetAllFavouriteSearchPaging = {
  __typename?: 'GetAllFavouriteSearchPaging';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GetAllFavouriteSearchResponse = {
  __typename?: 'GetAllFavouriteSearchResponse';
  alerts: Array<Maybe<FavouriteSearchAlert>>;
  paging: GetAllFavouriteSearchPaging;
};

export type GetPromotedUrlsInput = {
  categoryId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
};

export type GetPromotedUrlsResponse = {
  __typename?: 'GetPromotedUrlsResponse';
  promotedUrls: Array<PromotedUrl>;
};

export type GoogleAuthor = {
  __typename?: 'GoogleAuthor';
  name: Scalars['String']['output'];
  profilePhotoUrl?: Maybe<Scalars['URL']['output']>;
  profileUrl?: Maybe<Scalars['URL']['output']>;
};

export type GoogleReview = {
  __typename?: 'GoogleReview';
  author: GoogleAuthor;
  rating: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTime']['output'];
};

export type GoogleReviews = {
  __typename?: 'GoogleReviews';
  rating: Scalars['Float']['output'];
  reviews: Array<GoogleReview>;
  totalCount: Scalars['Int']['output'];
  url: Scalars['URL']['output'];
};

export enum Hints {
  CovidAttributesReJobs = 'COVID_ATTRIBUTES_RE_JOBS',
  GoogleMapsDetailsFlow = 'GOOGLE_MAPS_DETAILS_FLOW'
}

export type HomeFeed = {
  __typename?: 'HomeFeed';
  pageInfo?: Maybe<FeedPageInfo>;
  results?: Maybe<Array<Maybe<FeedResults>>>;
};

export type HomeFeedAds = {
  __typename?: 'HomeFeedAds';
  adSlots?: Maybe<Scalars['Int']['output']>;
};

export type HomeFeedInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location?: InputMaybe<LocationQueryCoordsOptions>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  /** @deprecated User ID will be abstracted from their access token instead. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type HomepageGallery = {
  __typename?: 'HomepageGallery';
  items?: Maybe<Array<Maybe<GalleryItem>>>;
  seeAllLink: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  imageAltText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegerRange = {
  __typename?: 'IntegerRange';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export enum ItemSearchHints {
  DominantCategory = 'DOMINANT_CATEGORY',
  IndexCategoryNames = 'INDEX_CATEGORY_NAMES',
  IndexTags = 'INDEX_TAGS'
}

export type ItemSearchOptions = {
  blend?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  excludeAdId?: InputMaybe<Scalars['Int']['input']>;
  externalSourceProviderId?: InputMaybe<Scalars['Int']['input']>;
  hasFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hints?: InputMaybe<Array<InputMaybe<ItemSearchHints>>>;
  ip?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  likeText?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RadialLocationInput>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  posterSource?: InputMaybe<PosterSource>;
  price?: InputMaybe<PriceInput>;
  sessionTestGroup?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<AdType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type LpBillboardModule = {
  __typename?: 'LPBillboardModule';
  adUnitId: Scalars['String']['output'];
  background?: Maybe<BackgroundAdType>;
  component: Scalars['String']['output'];
  pos?: Maybe<Scalars['String']['output']>;
  tile?: Maybe<Scalars['Int']['output']>;
};

export type LpBrowseModule = {
  __typename?: 'LPBrowseModule';
  arrangement?: Maybe<TileArrangement>;
  component: Scalars['String']['output'];
  displayFormat?: Maybe<TileDisplayFormat>;
  heading?: Maybe<Array<Maybe<CustomizedText>>>;
  tileStyle?: Maybe<TileStyle>;
  tiles: Array<Maybe<BrowseTile>>;
};

export type LpHeroModule = {
  __typename?: 'LPHeroModule';
  background?: Maybe<BackgroundType>;
  component: Scalars['String']['output'];
  ctas?: Maybe<Array<Maybe<Cta>>>;
  description: Array<Maybe<CustomizedText>>;
  isOverlay?: Maybe<Scalars['Boolean']['output']>;
  partner?: Maybe<Partner>;
  title: Array<Maybe<CustomizedText>>;
};

export type LpLeaderboardModule = {
  __typename?: 'LPLeaderboardModule';
  adUnitId: Scalars['String']['output'];
  background?: Maybe<BackgroundAdType>;
  component: Scalars['String']['output'];
  pos?: Maybe<Scalars['String']['output']>;
  tile?: Maybe<Scalars['Int']['output']>;
};

export type LabeledUrl = {
  __typename?: 'LabeledUrl';
  label: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type LandingPageContent = {
  __typename?: 'LandingPageContent';
  modules: Array<Maybe<LandingPageModule>>;
  title: Scalars['String']['output'];
};

export type LandingPageModule = BrowseHeroModule | LpBillboardModule | LpBrowseModule | LpHeroModule | LpLeaderboardModule;

export type LatLngType = {
  __typename?: 'LatLngType';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LinkType = {
  __typename?: 'LinkType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  isNewTab?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  nameId?: Maybe<Scalars['String']['output']>;
  type: LinkVariant;
  url: Scalars['String']['output'];
};

export enum LinkVariant {
  Paf = 'PAF',
  Srp = 'SRP',
  Url = 'URL',
  /** @deprecated Use URL instead */
  External = 'external',
  /** @deprecated Use URL instead */
  Internal = 'internal'
}

export type Listing = {
  adSource: AdSource;
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  price?: Maybe<ListingPrice>;
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type ListingAttributeV2 = {
  __typename?: 'ListingAttributeV2';
  canonicalName: Scalars['String']['output'];
  canonicalValues?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type ListingAttributes = {
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type ListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListingFlags = {
  /** Urgent / Reduced Badge */
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isFromAutosDealer?: Maybe<Scalars['Boolean']['output']>;
  /** Listing flags computed with listing data */
  isFromDealer?: Maybe<Scalars['Boolean']['output']>;
  isMoVe?: Maybe<Scalars['Boolean']['output']>;
  isPint?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  /** TODO: Look into what these promotion topAds are and if that are category specific */
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  isSM360?: Maybe<Scalars['Boolean']['output']>;
  isVerticalCategory?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingHomepageGallery = {
  __typename?: 'ListingHomepageGallery';
  items?: Maybe<Array<CoreListing>>;
  seeAllLink: Scalars['URL']['output'];
};

export type ListingLocation = ListingLocationInterface & {
  __typename?: 'ListingLocation';
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LocationCoordinates>;
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nearestIntersection?: Maybe<Array<Scalars['String']['output']>>;
  province?: Maybe<ProvinceAbbreviation>;
  showPinOnMap?: Maybe<Scalars['Boolean']['output']>;
};

/** An estimated (or exact) location of an ad. */
export type ListingLocationInterface = {
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LocationCoordinates>;
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nearestIntersection?: Maybe<Array<Scalars['String']['output']>>;
  province?: Maybe<ProvinceAbbreviation>;
  showPinOnMap?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingMetrics = {
  __typename?: 'ListingMetrics';
  replies?: Maybe<Scalars['Int']['output']>;
  views: Scalars['Int']['output'];
};

export type ListingPrice = {
  type: ListingPriceType;
};

export type ListingPriceClassification = {
  __typename?: 'ListingPriceClassification';
  /** The averagePrice value doesn't get returned from the API on Search */
  averagePrice?: Maybe<Scalars['Float']['output']>;
  rating: ListingPriceRating;
};

export enum ListingPriceRating {
  Fair = 'FAIR',
  Good = 'GOOD',
  Great = 'GREAT',
  Poor = 'POOR'
}

export enum ListingPriceType {
  Contact = 'CONTACT',
  DriveAway = 'DRIVE_AWAY',
  Fixed = 'FIXED',
  Free = 'FREE',
  GiveAway = 'GIVE_AWAY',
  MakeOffer = 'MAKE_OFFER',
  Monthly = 'MONTHLY',
  SpecifiedAmount = 'SPECIFIED_AMOUNT',
  StandardMonthly = 'STANDARD_MONTHLY',
  SwapTrade = 'SWAP_TRADE'
}

export enum ListingStatus {
  Active = 'ACTIVE',
  /**
   * Only the values above are mapped by the API
   * The status below are SubStates that could be mapped by BOX and used on FES
   */
  ActiveDelayed = 'ACTIVE_DELAYED',
  ActiveExpired = 'ACTIVE_EXPIRED',
  ActivePendingHold = 'ACTIVE_PENDING_HOLD',
  AdminDeleted = 'ADMIN_DELETED',
  Blocked = 'BLOCKED',
  Created = 'CREATED',
  Delayed = 'DELAYED',
  Deleted = 'DELETED',
  DeletedExpired = 'DELETED_EXPIRED',
  Expired = 'EXPIRED',
  Hold = 'HOLD',
  InCart = 'IN_CART',
  Mailed = 'MAILED',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  Sold = 'SOLD',
  SystemDeleted = 'SYSTEM_DELETED',
  Unknown = 'UNKNOWN',
  UserDeleted = 'USER_DELETED'
}

export type Listings = {
  __typename?: 'Listings';
  forCategory?: Maybe<ListingsData>;
  forUser?: Maybe<ListingsData>;
};


export type ListingsForCategoryArgs = {
  attributeFilters?: InputMaybe<Array<InputMaybe<AttributeInput>>>;
  categoryId: Scalars['Int']['input'];
  numberOfAds?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingsForUserArgs = {
  posterSource?: InputMaybe<PosterSource>;
  userId: Scalars['Int']['input'];
};

export type ListingsData = {
  __typename?: 'ListingsData';
  items?: Maybe<Array<Maybe<SrpListing>>>;
  totals: TotalListings;
};

export type ListingsPopular = {
  __typename?: 'ListingsPopular';
  listings?: Maybe<Array<Maybe<CoreListing>>>;
  total: Scalars['Int']['output'];
};

export type LivePersonContextVariable = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LivePersonIDs = {
  __typename?: 'LivePersonIDs';
  botId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type LivePersonVipData = {
  botId: Scalars['ID']['input'];
  contextVariables: Array<LivePersonContextVariable>;
  conversationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Locale = {
  __typename?: 'Locale';
  en_CA?: Maybe<Scalars['String']['output']>;
  fr_CA?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<LocationCoordinates>;
  id: Scalars['Int']['output'];
  localizedName?: Maybe<Scalars['String']['output']>;
  locationPaths?: Maybe<Array<Location>>;
  name?: Maybe<Locale>;
  nameId?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentLocation?: Maybe<Location>;
  searchSeoUrl?: Maybe<Scalars['String']['output']>;
  seoLocation?: Maybe<Scalars['String']['output']>;
  siblingLocations: Array<Maybe<Location>>;
};


export type LocationLocalizedNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LocationArea = {
  __typename?: 'LocationArea';
  address?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<BoundingBox>;
  coordinates?: Maybe<LocationCoordinates>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /**
   * Radius is represented in kilometres,
   * TODO: Radius is calculated back from boundingBox Input
   */
  radius: Scalars['Int']['output'];
};

export type LocationCoordinates = {
  __typename?: 'LocationCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationCoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/**
 * Ideally at some point, we can use @oneOf for LocationInput.
 * https://stepzen.com/blog/coming-soon-to-graphql-the-oneof-input-object
 */
export type LocationInput = {
  area?: InputMaybe<AreaLocationInput>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationQueryCoordsOptions = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LocationWithNeighbourhood = {
  __typename?: 'LocationWithNeighbourhood';
  location: Location;
  neighbourhood: Neighbourhood;
};

export type LocationWithPlace = {
  __typename?: 'LocationWithPlace';
  location?: Maybe<Location>;
  place?: Maybe<PlaceDetails>;
};

export enum LogoType {
  MerchantStore = 'MERCHANT_STORE',
  SearchResults = 'SEARCH_RESULTS',
  ViewAd = 'VIEW_AD'
}

export type LogoutUserInput = {
  xsrfToken: Scalars['String']['input'];
};

export type LogoutUserResponse = {
  __typename?: 'LogoutUserResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type MapProvider = {
  __typename?: 'MapProvider';
  apiKey: Scalars['String']['output'];
  error?: Maybe<Scalars['Boolean']['output']>;
  isLoading?: Maybe<Scalars['Boolean']['output']>;
};

export type MapSearchResultsPageState = {
  __typename?: 'MapSearchResultsPageState';
  shouldUpdateLocationRef: Scalars['Boolean']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  categoryId: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  children?: Maybe<Array<Maybe<MenuItem>>>;
  id: Scalars['Int']['output'];
  isLeaf: Scalars['Boolean']['output'];
  seoUrl: Scalars['String']['output'];
};

export type MileageAnalysis = {
  __typename?: 'MileageAnalysis';
  categories: MileageAnalysisCategories;
  usage: MileageAnalysisUsage;
  value: Scalars['Int']['output'];
};

export type MileageAnalysisCategories = {
  __typename?: 'MileageAnalysisCategories';
  average: Scalars['Int']['output'];
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
};

export enum MileageAnalysisUsage {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

/** Shared Schema Types */
export type MinMax = {
  __typename?: 'MinMax';
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
};

export type MinMaxInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type ModalState = {
  __typename?: 'ModalState';
  id: Scalars['String']['output'];
  isOpen: Scalars['Boolean']['output'];
};

export type MoveAd = AdCommon & {
  __typename?: 'MoveAd';
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceAdId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vehicleReport?: Maybe<VehicleReport>;
};

export type MoveListing = {
  __typename?: 'MoveListing';
  priceRating?: Maybe<MoveListingPriceRating>;
};

export type MoveListingPriceRating = {
  __typename?: 'MoveListingPriceRating';
  rating?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateFavouriteSearch?: Maybe<Scalars['Int']['output']>;
  activateFavouriteSearchGuest?: Maybe<Scalars['Int']['output']>;
  /** Add listing to the user's list of favourites. */
  addFavouriteListing: Scalars['ID']['output'];
  /** @deprecated Use `addFavouriteListing` which calls favourite endpoint through GCP Gateway */
  addFavouriteNew?: Maybe<Scalars['Boolean']['output']>;
  /** Change Password via Email Reset Link */
  changePasswordViaResetLink?: Maybe<Scalars['Void']['output']>;
  clearUnseenCount?: Maybe<StatusResponse>;
  createReview?: Maybe<StatusResponse>;
  deactivateFavouriteSearch?: Maybe<Scalars['Int']['output']>;
  deleteAd?: Maybe<Scalars['Boolean']['output']>;
  deleteNotification?: Maybe<StatusResponse>;
  editAdPrice?: Maybe<EditAdPriceResponse>;
  /** Used to track third party URL clicks from listings */
  eventsExternalClick?: Maybe<Scalars['Void']['output']>;
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch */
  favouriteSearchActivate: Scalars['ID']['output'];
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/deleteSavedSearch */
  favouriteSearchDeactivate?: Maybe<Scalars['Void']['output']>;
  /** Request an XSRF token from BOX (/j-token-gen.json) to be used for further requests to BOX. */
  generateXsrf?: Maybe<GenerateXsrfResponse>;
  getAlgoliaKey?: Maybe<Scalars['Boolean']['output']>;
  getGoogleMapsKey?: Maybe<Scalars['Boolean']['output']>;
  getPlaceToken?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Start a conversation with the seller of a listing.
   * Returns the conversation id.
   * FIXME: I think message should be required, but it's not in the schema 🤔
   */
  listingContact: Scalars['ID']['output'];
  /**
   * Listing contact with an attachment. Does not support guest messaging.
   * Returns the conversation id.
   */
  listingContactWithAttachment: Scalars['ID']['output'];
  /** Report a listing */
  listingReport?: Maybe<Scalars['Void']['output']>;
  /** Request a CARFAX report for a listing */
  listingRequestCarfax?: Maybe<Scalars['Void']['output']>;
  /** Request financing for a listing. */
  listingRequestFinancing?: Maybe<Scalars['Void']['output']>;
  /**
   * Start a request a viewing conversation with the seller of the listing.
   * Returns the conversation id.
   */
  listingRequestViewing: Scalars['ID']['output'];
  /**
   * Track a visit to a listing
   * @deprecated To be integrated with the listings call
   */
  listingVisit?: Maybe<Scalars['Void']['output']>;
  /** Send data about the current VIP to LivePerson. */
  livePersonSendVipData?: Maybe<Scalars['Void']['output']>;
  /** Logout the user via hitting m-logout.json endpoint on BOX. Handles SSID and CIS */
  logoutUser?: Maybe<LogoutUserResponse>;
  markAsRead?: Maybe<StatusResponse>;
  /** Returns ID for successfull one time saved search */
  oneTimeSavedSearch: Scalars['Int']['output'];
  /** Remove listing from the user's list of favourites. */
  removeFavouriteListing: Scalars['ID']['output'];
  /** @deprecated Use `removeFavouriteListing` which calls favourite endpoint through GCP Gateway */
  removeFavouriteNew?: Maybe<Scalars['Boolean']['output']>;
  removeFavourites?: Maybe<Scalars['Boolean']['output']>;
  removePaymentInfo?: Maybe<Scalars['Boolean']['output']>;
  removeProfileImage?: Maybe<ProfileUpdateResponse>;
  repostAd?: Maybe<RepostAdResponse>;
  /** Reset user password */
  requestPasswordResetLink?: Maybe<Scalars['Void']['output']>;
  submitPayment?: Maybe<SubmitPaymentResponse>;
  submitPaymentDetails?: Maybe<SubmitPaymentResponse>;
  /** Update password */
  updatePassword?: Maybe<StatusResponse>;
  /** Update account information */
  updatePersonalInformation?: Maybe<StatusResponse>;
  /** Update user preferences */
  updatePreferences?: Maybe<StatusResponse>;
  updateProfileImage?: Maybe<ProfileUpdateResponse>;
  /** Update social links */
  updateSocialLinks?: Maybe<StatusResponse>;
  /** Upload a new profile image */
  uploadProfileImage?: Maybe<UploadProfileImageResponse>;
  /** Create a new User account, confirmation email will be sent on success. */
  userRegistration?: Maybe<Scalars['Void']['output']>;
};


export type MutationActivateFavouriteSearchArgs = {
  searchString: Scalars['String']['input'];
};


export type MutationActivateFavouriteSearchGuestArgs = {
  email: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
};


export type MutationAddFavouriteListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationAddFavouriteNewArgs = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationChangePasswordViaResetLinkArgs = {
  password: Scalars['String']['input'];
  token: Scalars['UUID']['input'];
};


export type MutationClearUnseenCountArgs = {
  lastSeenNotificationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateReviewArgs = {
  review: ReviewInput;
};


export type MutationDeactivateFavouriteSearchArgs = {
  alertId: Scalars['Int']['input'];
};


export type MutationDeleteAdArgs = {
  input?: InputMaybe<DeleteAdInputArgs>;
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEditAdPriceArgs = {
  adId: Scalars['Int']['input'];
  newPrice: Scalars['Long']['input'];
};


export type MutationEventsExternalClickArgs = {
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  urlType: EventsUrlType;
};


export type MutationFavouriteSearchActivateArgs = {
  input: FavouriteSearchActivateInput;
};


export type MutationFavouriteSearchDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationListingContactArgs = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationListingContactWithAttachmentArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationListingReportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Reason;
};


export type MutationListingRequestCarfaxArgs = {
  email: Scalars['String']['input'];
  listingId: Scalars['ID']['input'];
};


export type MutationListingRequestFinancingArgs = {
  email: Scalars['EmailAddress']['input'];
  externalSourceId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationListingRequestViewingArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requestViewingDates?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type MutationListingVisitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLivePersonSendVipDataArgs = {
  input: LivePersonVipData;
};


export type MutationLogoutUserArgs = {
  input?: InputMaybe<LogoutUserInput>;
};


export type MutationMarkAsReadArgs = {
  notificationId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOneTimeSavedSearchArgs = {
  input: OneTimeSavedSearchInput;
};


export type MutationRemoveFavouriteListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationRemoveFavouriteNewArgs = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveFavouritesArgs = {
  favourites: Array<Favourite>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemovePaymentInfoArgs = {
  recurringDetailReference: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type MutationRepostAdArgs = {
  adId: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};


export type MutationRequestPasswordResetLinkArgs = {
  input: RequestPasswordResetLinkInput;
};


export type MutationSubmitPaymentArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  storePaymentMethod: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type MutationSubmitPaymentDetailsArgs = {
  details: Details;
  invoiceId: Scalars['ID']['input'];
  paymentData: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePersonalInformationArgs = {
  input: UpdatePersonalInformationInput;
};


export type MutationUpdatePreferencesArgs = {
  input: UpdatePreferencesInput;
};


export type MutationUpdateProfileImageArgs = {
  input: ProfileImageInput;
};


export type MutationUpdateSocialLinksArgs = {
  input: UpdateSocialLinksInput;
};


export type MutationUploadProfileImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUserRegistrationArgs = {
  input: UserRegistrationInput;
};

export type Neighbourhood = {
  __typename?: 'Neighbourhood';
  boundingBox: BoundingBox;
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  neighbourhoodCentre: LocationCoordinates;
};

export type NeighbourhoodInfo = {
  __typename?: 'NeighbourhoodInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profile?: Maybe<NeighbourhoodProfile>;
  scores?: Maybe<NeighbourhoodScores>;
};

export type NeighbourhoodProfile = {
  __typename?: 'NeighbourhoodProfile';
  summary?: Maybe<Scalars['String']['output']>;
  transportation?: Maybe<Scalars['String']['output']>;
};

export type NeighbourhoodScores = {
  __typename?: 'NeighbourhoodScores';
  transportation?: Maybe<TransportationScore>;
};

export type NonAmountPrice = ListingPrice & {
  __typename?: 'NonAmountPrice';
  type: ListingPriceType;
};

export type Notification = {
  body: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotificationDetailsInput = {
  frequency: NotificationFrequency;
  notificationMethod: NotificationMethod;
};

export enum NotificationFrequency {
  Day = 'DAY',
  Week = 'WEEK'
}

export enum NotificationMethod {
  Email = 'EMAIL',
  Push = 'PUSH'
}

export type Notifications = {
  __typename?: 'Notifications';
  newCount: Scalars['Int']['output'];
  notifications: Array<Maybe<Notification>>;
};

export type OneTimeSavedSearchInput = {
  address: Scalars['String']['input'];
  searchQuery: Scalars['String']['input'];
};

export type OrganicAd = AdCommon & {
  __typename?: 'OrganicAd';
  adDataArray: Array<AdDataPair>;
  attributes?: Maybe<AttributeMap>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  favourite: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<AdLocation>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  recommendedAds?: Maybe<Array<Maybe<OrganicAd>>>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  sortingDate?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  suggestedPrice?: Maybe<Scalars['Long']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type OrganicAdLocationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type OrganicAdRecommendedAdsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type OtherUserProfile = {
  __typename?: 'OtherUserProfile';
  id: Scalars['Int']['output'];
  profileName?: Maybe<Scalars['String']['output']>;
};

export type OtherUserProfileData = {
  __typename?: 'OtherUserProfileData';
  otherUserProfile?: Maybe<OtherUserProfile>;
};

export enum PageType {
  Paf = 'PAF',
  Srp = 'SRP',
  Vip = 'VIP'
}

export type Pagination = {
  __typename?: 'Pagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginationInputV2 = {
  /** How many items per page. */
  limit: Scalars['Int']['input'];
  /** Starting index of fetched items. Want page 3 of limit 10? Offset = 20. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationLimitOffset = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Participant = {
  __typename?: 'Participant';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type Partner = {
  __typename?: 'Partner';
  brand: PartnerBrand;
  title?: Maybe<Scalars['String']['output']>;
};

export type PartnerBrand = {
  __typename?: 'PartnerBrand';
  link?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type PendingLocation = {
  __typename?: 'PendingLocation';
  area?: Maybe<LocationArea>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type PendingSearchInput = {
  __typename?: 'PendingSearchInput';
  additionalFlagFilters?: Maybe<Array<AdditionalFlags>>;
  attributeFilters?: Maybe<Array<AppliedAttributeFilter>>;
  by?: Maybe<SrpSortBy>;
  dateFilters?: Maybe<Array<AppliedDateFilter>>;
  dateRangeFilters?: Maybe<Array<AppliedDateRangeFilter>>;
  direction?: Maybe<SortDirection>;
  keywords?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  rangeFilters?: Maybe<Array<AppliedRangeFilter>>;
  toggleFilters?: Maybe<Array<AppliedToggleFilter>>;
};

/** Account type for FSBO/Personal accounts */
export type PersonalAccount = Account & {
  __typename?: 'PersonalAccount';
  /** Account type, personal or business */
  accountType: Scalars['String']['output'];
  /** Street Address */
  address?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** User Id */
  id: Scalars['ID']['output'];
  /** Display name */
  name?: Maybe<Scalars['NonEmptyString']['output']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Account preferences and opt-ins */
  preferences?: Maybe<AccountPreferences>;
  /** User profile image url */
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** Social media links */
  socialLinks?: Maybe<AccountSocialLinks>;
};

export enum PhoneNumberSource {
  Autos = 'Autos',
  Dynamic = 'Dynamic',
  Static = 'Static'
}

export type PlaceDetails = {
  __typename?: 'PlaceDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<AddressFormat>;
  id?: Maybe<Scalars['String']['output']>;
  isCity: Scalars['Boolean']['output'];
  isCountry: Scalars['Boolean']['output'];
  isPostalCode: Scalars['Boolean']['output'];
  isProvince: Scalars['Boolean']['output'];
  isStreetAddress: Scalars['Boolean']['output'];
  location?: Maybe<LocationCoordinates>;
  postalCode?: Maybe<AddressFormat>;
  province?: Maybe<AddressFormat>;
  viewport?: Maybe<ViewportType>;
};

export type PlaceSuggestions = {
  __typename?: 'PlaceSuggestions';
  address?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PopularAttribute = {
  __typename?: 'PopularAttribute';
  canonicalName?: Maybe<Scalars['String']['output']>;
  localizedName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PopularAttributes = {
  __typename?: 'PopularAttributes';
  localizedSeoUrl?: Maybe<Scalars['String']['output']>;
  seoAttributes?: Maybe<Array<Maybe<PopularAttribute>>>;
};


export type PopularAttributesLocalizedSeoUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type PopularAttributesSeoAttributesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PopularCategoriesResponse = {
  __typename?: 'PopularCategoriesResponse';
  categories: Array<PopularCategory>;
  total: Scalars['Int']['output'];
};

export type PopularCategory = {
  __typename?: 'PopularCategory';
  id: Scalars['Int']['output'];
  name: PopularCategoryName;
  rank: Scalars['Int']['output'];
};

export type PopularCategoryItem = {
  __typename?: 'PopularCategoryItem';
  id: Scalars['ID']['output'];
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PopularCategoryName = {
  __typename?: 'PopularCategoryName';
  enCa: Scalars['String']['output'];
  frCa: Scalars['String']['output'];
};

export type PopularSearchListings = {
  __typename?: 'PopularSearchListings';
  labeledUrl: LabeledUrl;
  listings?: Maybe<Array<FullListing>>;
};


export type PopularSearchListingsListingsArgs = {
  pagination?: InputMaybe<PaginationInputV2>;
};

export type PosterInfo = {
  __typename?: 'PosterInfo';
  allowEmailContact?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  posterId: Scalars['ID']['output'];
  posterType?: Maybe<PosterType>;
  profile?: Maybe<Profile>;
  rating?: Maybe<Scalars['Float']['output']>;
  sellerType: SellerType;
  websiteUrl?: Maybe<Scalars['URL']['output']>;
};

export enum PosterSource {
  Belen = 'BELEN',
  Commercial = 'COMMERCIAL',
  Private = 'PRIVATE'
}

/** Used for ODIN? What are all possible values? */
export enum PosterType {
  Commercial = 'COMMERCIAL',
  Private = 'PRIVATE'
}

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PriceDistribution = {
  __typename?: 'PriceDistribution';
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  numBuckets?: Maybe<Scalars['Int']['output']>;
  resultBuckets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type PriceDistributionOptions = {
  attributeFilters?: InputMaybe<Array<InputMaybe<AttributeInput>>>;
  categoryId: Scalars['Int']['input'];
  location?: InputMaybe<RadialLocationInput>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  maxPrice: Scalars['Int']['input'];
  minPrice: Scalars['Int']['input'];
  numBuckets: Scalars['Int']['input'];
};

export type PriceInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceRating = {
  __typename?: 'PriceRating';
  accuracy?: Maybe<Scalars['Int']['output']>;
  averagePrice?: Maybe<AveragePrice>;
  provider?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingThresholds?: Maybe<RatingThresholds>;
};

export enum PriceType {
  Contact = 'CONTACT',
  Fixed = 'FIXED',
  GiveAway = 'GIVE_AWAY',
  Monthly = 'MONTHLY',
  Offer = 'OFFER',
  SwapTrade = 'SWAP_TRADE'
}

/** Deprecated: Use ProfileV2 instead */
export type Profile = {
  __typename?: 'Profile';
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isAdmarkt?: Maybe<Scalars['Boolean']['output']>;
  isProfessional?: Maybe<Scalars['Boolean']['output']>;
  isReadIndicatorEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSfidEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberSince?: Maybe<Scalars['Long']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  replyRate?: Maybe<Scalars['Int']['output']>;
  responsiveness?: Maybe<Scalars['String']['output']>;
};

export type ProfileImageInput = {
  image: Scalars['Upload']['input'];
  size: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};

/** Different sort by list compared to SRP */
export enum ProfileSortBy {
  Date = 'DATE',
  Price = 'PRICE'
}

export type ProfileSortInput = {
  by: ProfileSortBy;
  direction: SortDirection;
};

export enum ProfileType {
  CasMerchant = 'CAS_MERCHANT',
  Dealer = 'DEALER',
  Fsbo = 'FSBO',
  HeDealer = 'HE_DEALER',
  JobsProfessional = 'JOBS_PROFESSIONAL',
  PvDealer = 'PV_DEALER',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  ReProfessional = 'RE_PROFESSIONAL',
  RvDealer = 'RV_DEALER'
}

export type ProfileUpdateResponse = {
  __typename?: 'ProfileUpdateResponse';
  userDetails?: Maybe<UserProfile>;
};

export type ProfileV2 = {
  /** The ID of the profile, can start with COMMERCIAL_ for non BOX accounts */
  id: Scalars['ID']['output'];
  listings?: Maybe<Array<FullListing>>;
  memberSince?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences: UserPreferences;
  profilePath?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};


export type ProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type ProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export enum ProfileV2Type {
  Commercial = 'COMMERCIAL',
  Standard = 'STANDARD'
}

export type PromotedUrl = {
  __typename?: 'PromotedUrl';
  categoryId: Scalars['Int']['output'];
  keywords: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum ProvinceAbbreviation {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Ooc = 'OOC',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

export type Query = {
  __typename?: 'Query';
  ad?: Maybe<Ad>;
  appDownloadBanner: AppDownloadBannerState;
  authModalState: AuthModalState;
  autocompleteSuggestions: Array<AutocompleteSuggestion>;
  /**
   * Query to fetch instant cash offers/estimates for a set of listing IDs
   * Arguments:
   * - ids ([ID!]!): listing IDs to fetch instant cash offers/estimates for (max 20)
   * Returns:
   * - [AutosInstantCashUnion]: Object containing list of instant cash offers/estimates, each
   *   corresponding to one of the queried listing IDs. If there is no instant cash offer/estimate
   *   for any particular listing ID, it will not be included in the response
   */
  autosInstantCash: Array<AutosInstantCashUnion>;
  /**
   * Query to fetch a warranty estimate for a given listing ID
   * Arguments:
   * - id: The listing ID for which warranty estimate is to be fetched
   * Returns:
   * - AutosWarrantyEstimate: Object containing warranty estimate details, if available
   */
  autosWarranty?: Maybe<AutosWarrantyEstimate>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  category?: Maybe<Category>;
  categoryLinks?: Maybe<Array<Maybe<CategoryLink>>>;
  clientList?: Maybe<Array<Maybe<ClientSelectionDetail>>>;
  contentModule?: Maybe<ContentModule>;
  conversationIdByAdId?: Maybe<ConversationId>;
  covidResponse?: Maybe<CovidResponse>;
  /** Get the dealer phone number from MoVe's Call Tracking vendor (Freespee) */
  dealerPhoneNumber: Scalars['String']['output'];
  dismissedStates: DismissedStates;
  dropInConfiguration?: Maybe<DropInConfiguration>;
  eligibility?: Maybe<ReviewEligibility>;
  /**
   * Fetch the users favourite listings.
   * (!) NeighbourhoodInfo is not supported in this query.
   */
  favouriteListings: Array<FullListing>;
  /**
   * Fetch the users full list of favourite ids.
   * (!) NeighbourhoodInfo is not supported in this query.
   */
  favouriteListingsIds: Array<Scalars['ID']['output']>;
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/lookupsavedsearch */
  favouriteSearchIdLookup?: Maybe<FavouriteSearchIdLookupOutput>;
  favouritesList?: Maybe<Array<Maybe<FavouriteEntry>>>;
  favouritesListings?: Maybe<Array<Maybe<FavouriteListing>>>;
  feedRecommendations?: Maybe<FeedRecommendations>;
  feedbackOptions: Array<FeedbackOption>;
  feedbackSummary: Array<Maybe<FeedbackSummaryItem>>;
  /** @deprecated Use profile instead */
  findCommercialProfile?: Maybe<CommercialProfile>;
  /** @deprecated Use profile instead */
  findProfile: Profile;
  /** @deprecated No longer supported */
  findProfiles: Array<Profile>;
  geocodeCanadianAddress?: Maybe<GeocodeCanadianAddress>;
  geocodeReverseFromIp: GeocodeReverseFromIp;
  getAllFavouriteSearch?: Maybe<GetAllFavouriteSearchResponse>;
  getDynamicPhoneNumber?: Maybe<DynamicPhoneNumber>;
  getMoveSRPUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Query to fetch promoted URLs for a given category and location
   * Arguments:
   * - input: Object containing categoryId, locationId, and optional limit
   * Returns:
   * - GetPromotedUrlsResponse: Object containing promoted URLs details
   */
  getPromotedUrls: GetPromotedUrlsResponse;
  hasMoveListings: Scalars['Boolean']['output'];
  homeFeed?: Maybe<HomeFeed>;
  homeFeedAds: HomeFeedAds;
  homepageGallery?: Maybe<HomepageGallery>;
  initialStructuredMessage?: Maybe<Array<Maybe<StructuredMessage>>>;
  /** Check if the autos listing is digital retail elibigible to determine if the associated UI should be displayed */
  isDigitalRetailEligible: Scalars['Boolean']['output'];
  landingPageContent?: Maybe<LandingPageContent>;
  /**
   * Get a listing by its id
   * Trackview is used to track a visit to the listing
   * IsExternalId is used to fetch an external listing from MoVe
   */
  listing?: Maybe<FullListing>;
  listingHomepageGallery?: Maybe<ListingHomepageGallery>;
  listingUrl: Scalars['URL']['output'];
  listings?: Maybe<Listings>;
  /**
   * Query to fetch popular listings for a given location ID
   * Arguments:
   * - locationId: The location ID for which popular listings are to be fetched
   * - categoryId: The category ID to filter popular listings by category
   * Returns:
   * - ListingsPopular: Object containing popular listings details, if available
   */
  listingsPopular?: Maybe<ListingsPopular>;
  listingsRecommendedForYou?: Maybe<Array<Maybe<CoreListing>>>;
  /** Get similar listings to the inputted listing id */
  listingsSimilar?: Maybe<Array<CoreListing>>;
  /** Fetch the user platform ID from LivePerson. */
  livePersonGetIDs?: Maybe<LivePersonIDs>;
  location?: Maybe<Location>;
  locationFromCoordinates?: Maybe<LocationWithPlace>;
  locationFromNeighbourhood?: Maybe<LocationWithNeighbourhood>;
  locationFromPlace?: Maybe<LocationWithPlace>;
  locationPath?: Maybe<Array<Maybe<Location>>>;
  mapProvider?: Maybe<MapProvider>;
  mapSrp: MapSearchResultsPageState;
  menu?: Maybe<MenuItem>;
  menuPrefetch?: Maybe<Array<Maybe<MenuItem>>>;
  modal: ModalState;
  /** Get my account information */
  myAccount?: Maybe<Account>;
  myAdListing?: Maybe<OrganicAd>;
  notifications: Notifications;
  placeSuggestions?: Maybe<Array<Maybe<PlaceSuggestions>>>;
  placeSuggestionsGoogleMaps: Array<Maybe<PlaceSuggestions>>;
  placeSuggestionsLocalInfo: Array<Maybe<PlaceSuggestionsLocalInfo>>;
  popularAttributes?: Maybe<Array<Maybe<PopularAttributes>>>;
  /**
   * Query to fetch popular categories for a given location ID
   * Arguments:
   * - locationId: The location ID for which popular categories are to be fetched
   * - categoryId: The category ID to filter popular categories by category
   * Returns:
   * - PopularCategoriesResponse: Object containing popular categories details, if available
   */
  popularCategories?: Maybe<PopularCategoriesResponse>;
  priceDistribution?: Maybe<PriceDistribution>;
  /** Get a profile by its id */
  profile: ProfileV2;
  r2sModalState: ReplyToSellerModalState;
  requestViewingState: RequestViewingState;
  review?: Maybe<Review>;
  reviewDetailSummary: Array<ReviewDetailDirectedSummary>;
  reviewSummary: ReviewSummary;
  reviews: Reviews;
  /**
   * Query to fetch Google reviews for a specific dealer by their dealerId.
   * Arguments:
   * - dealerId (Int!): Unique dealer identifier
   * Returns:
   * - GoogleReviews: Object containing overall rating, review count, profile URL, and reviews list
   */
  reviewsFromGoogle?: Maybe<GoogleReviews>;
  searchCategories?: Maybe<Array<Maybe<Category>>>;
  searchInputFromUrl: Scalars['String']['output'];
  searchResultsPage: SearchResultsPage;
  /** With an SRP SEO url, query for the search results page. */
  searchResultsPageByUrl: SearchResultsPage;
  /**
   * By query object, sorted & paginated sorted listings search that includes search filters and extended search query data.
   * Slow decorator should be removed or at least adjusted once we have optimized the category/location calls.
   */
  searchResultsPageUpdate: SearchResultsPage;
  searchState: SearchPageState;
  /** Returns an SEO formatted url from SRP input */
  searchUrl?: Maybe<Scalars['URL']['output']>;
  /** Returns a set of popular or related keyword search urls by category and location. */
  searchUrlsPopular?: Maybe<Array<LabeledUrl>>;
  /**
   * Fetches a set of popular URLS/keywords [LabeledUrl!] & matching listings
   * Will eventually replace searchUrlsPopular
   */
  searchUrlsPopularWithListings?: Maybe<Array<PopularSearchListings>>;
  srp: SearchResultsPageState;
  structuredMessage?: Maybe<Array<Maybe<StructuredMessage>>>;
  transaction?: Maybe<TransactionDetails>;
  /** Returns logged in users conversationsWithUnreadMessagesCount */
  unreadConversationsCount: Scalars['Int']['output'];
  unreadNotificationsCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  userAgent: UserAgent;
  userAuthState: UserAuthState;
  userConversations?: Maybe<UserConversations>;
  userLocale: UserLocale;
  userLocation: UserLocation;
};


export type QueryAdArgs = {
  id: Scalars['Int']['input'];
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<AdSource>;
};


export type QueryAutocompleteSuggestionsArgs = {
  input: AutocompleteSuggestionsInput;
};


export type QueryAutosInstantCashArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryAutosWarrantyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  categoryId: Scalars['Int']['input'];
  customType?: InputMaybe<Scalars['String']['input']>;
  filterAmount?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  placement: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategoryLinksArgs = {
  linkInfo?: InputMaybe<Array<InputMaybe<CategoryLinkInfo>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryClientListArgs = {
  adId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentModuleArgs = {
  locationId: Scalars['Int']['input'];
  moduleId: ContentModuleId;
};


export type QueryConversationIdByAdIdArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryCovidResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealerPhoneNumberArgs = {
  adId?: InputMaybe<Scalars['Int']['input']>;
  contactType?: InputMaybe<ContactType>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  sellerId: Scalars['Int']['input'];
};


export type QueryDropInConfigurationArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type QueryEligibilityArgs = {
  conversationId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  reviewerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFavouriteSearchIdLookupArgs = {
  input: FavouriteSearchIdLookupInput;
};


export type QueryFavouritesListArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFavouritesListingsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedRecommendationsArgs = {
  input: FeedRecommendationsInput;
};


export type QueryFeedbackSummaryArgs = {
  revieweeId: Scalars['Int']['input'];
};


export type QueryFindCommercialProfileArgs = {
  contactType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  isBoxDealer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindProfileArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryFindProfilesArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryGeocodeCanadianAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetAllFavouriteSearchArgs = {
  input: PaginationLimitOffset;
};


export type QueryGetDynamicPhoneNumberArgs = {
  adId: Scalars['String']['input'];
  listingType: Scalars['String']['input'];
  sellerId?: InputMaybe<Scalars['String']['input']>;
  sellerName: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  vipUrl: Scalars['String']['input'];
};


export type QueryGetMoveSrpUrlArgs = {
  attributesQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPromotedUrlsArgs = {
  input: GetPromotedUrlsInput;
};


export type QueryHasMoveListingsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryHomeFeedArgs = {
  homePageMixGroup?: InputMaybe<Scalars['String']['input']>;
  input: HomeFeedInput;
};


export type QueryHomepageGalleryArgs = {
  deviceType: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  numberOfAds?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryInitialStructuredMessageArgs = {
  categoryId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsDigitalRetailEligibleArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryLandingPageContentArgs = {
  landingPageName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  trackView?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListingHomepageGalleryArgs = {
  deviceType: DeviceType;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  pagination: PaginationInputV2;
};


export type QueryListingUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingsArgs = {
  searchParams?: InputMaybe<ItemSearchOptions>;
};


export type QueryListingsPopularArgs = {
  categoryId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryListingsRecommendedForYouArgs = {
  listingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryListingsSimilarArgs = {
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingId: Scalars['ID']['input'];
};


export type QueryLivePersonGetIDsArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationFromCoordinatesArgs = {
  coordinates?: InputMaybe<LocationQueryCoordsOptions>;
};


export type QueryLocationFromNeighbourhoodArgs = {
  neighbourhoodId: Scalars['ID']['input'];
};


export type QueryLocationFromPlaceArgs = {
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  placeId: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationPathArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryMenuPrefetchArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryModalArgs = {
  id: Scalars['String']['input'];
};


export type QueryMyAdListingArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryNotificationsArgs = {
  lastSeenNotificationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlaceSuggestionsArgs = {
  input: Scalars['String']['input'];
  location?: InputMaybe<LocationQueryCoordsOptions>;
};


export type QueryPlaceSuggestionsGoogleMapsArgs = {
  input: Scalars['String']['input'];
  location?: InputMaybe<LocationQueryCoordsOptions>;
};


export type QueryPlaceSuggestionsLocalInfoArgs = {
  input: Scalars['String']['input'];
};


export type QueryPopularAttributesArgs = {
  categoryId: Scalars['Int']['input'];
  conditionalFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPopularCategoriesArgs = {
  categoryId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryPriceDistributionArgs = {
  searchParams?: InputMaybe<PriceDistributionOptions>;
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<ProfileV2Type>;
};


export type QueryReviewArgs = {
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  reviewerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewDetailSummaryArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryReviewSummaryArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryReviewsArgs = {
  lastSeenReviewId?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryReviewsFromGoogleArgs = {
  dealerId: Scalars['ID']['input'];
};


export type QuerySearchCategoriesArgs = {
  selectedId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchInputFromUrlArgs = {
  input: SearchInputFromUrlInput;
};


export type QuerySearchResultsPageArgs = {
  by: SearchResultsPageInputBy;
  pagination: PaginationInputV2;
  sorting?: InputMaybe<SrpSortInput>;
};


export type QuerySearchResultsPageByUrlArgs = {
  input: SearchResultsByUrlInput;
};


export type QuerySearchResultsPageUpdateArgs = {
  input: SearchResultsInput;
};


export type QuerySearchUrlArgs = {
  input: SearchUrlInput;
};


export type QuerySearchUrlsPopularArgs = {
  input: SearchUrlPopularRelatedInput;
};


export type QuerySearchUrlsPopularWithListingsArgs = {
  input: SearchUrlPopularRelatedInput;
};


export type QueryStructuredMessageArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<RoleType>;
};


export type QueryTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export enum R2SPlacement {
  Gallery = 'GALLERY',
  VipSideBar = 'VIP_SIDE_BAR',
  VipStickyBar = 'VIP_STICKY_BAR'
}

export type RadialLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius: Scalars['Int']['input'];
};

export type RangeControlValues = MinMax | StartEndDate;

/** Schema for Range Controls */
export type RangeFilter = Filter & {
  __typename?: 'RangeFilter';
  fromRange: MinMax;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  rangeLabels: RangeLabels;
  selectedRangeValues?: Maybe<RangeControlValues>;
  toRange: MinMax;
  type: FilterControlType;
};

export type RangeFilterInput = {
  filterName: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type RangeLabels = {
  __typename?: 'RangeLabels';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type RatingThresholds = {
  __typename?: 'RatingThresholds';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  midHigh?: Maybe<Scalars['Float']['output']>;
  midLow?: Maybe<Scalars['Float']['output']>;
};

export type RealEstateListing = FullListing & Listing & {
  __typename?: 'RealEstateListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  /** Real Estate Listing fields */
  attributes: RealEstateListingAttributes;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  favouriteDate?: Maybe<Scalars['DateTime']['output']>;
  flags: RealEstateListingFlags;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Int']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  metrics?: Maybe<ListingMetrics>;
  mlsAd?: Maybe<Scalars['Boolean']['output']>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  productUrl?: Maybe<Scalars['URL']['output']>;
  rentalBadge?: Maybe<Scalars['String']['output']>;
  requestViewingUrl?: Maybe<Scalars['URL']['output']>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  status: ListingStatus;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  virtualTourUrl?: Maybe<Scalars['URL']['output']>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type RealEstateListingAttributes = ListingAttributes & {
  __typename?: 'RealEstateListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type RealEstateListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RealEstateListingFlags = ListingFlags & {
  __typename?: 'RealEstateListingFlags';
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  /** Listing flags that only apply to Real Estate categories */
  comfree?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isFromAutosDealer?: Maybe<Scalars['Boolean']['output']>;
  /** Listing flags computed with listing data */
  isFromDealer?: Maybe<Scalars['Boolean']['output']>;
  isMoVe?: Maybe<Scalars['Boolean']['output']>;
  isPint?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  isSM360?: Maybe<Scalars['Boolean']['output']>;
  isVerticalCategory?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
  viewingAvailable?: Maybe<Scalars['Boolean']['output']>;
  virtualTour?: Maybe<Scalars['Boolean']['output']>;
};

export type RealEstateListingLocation = ListingLocationInterface & {
  __typename?: 'RealEstateListingLocation';
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LocationCoordinates>;
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nearestIntersection?: Maybe<Array<Scalars['String']['output']>>;
  neighbourhoodInfo?: Maybe<NeighbourhoodInfo>;
  province?: Maybe<ProvinceAbbreviation>;
  showPinOnMap?: Maybe<Scalars['Boolean']['output']>;
};

export enum Reason {
  Duplicated = 'DUPLICATED',
  Irrelevant = 'IRRELEVANT',
  Miscategorized = 'MISCATEGORIZED',
  Other = 'OTHER',
  Prohibited = 'PROHIBITED',
  VideoMatureOrProhibited = 'VIDEO_MATURE_OR_PROHIBITED'
}

export type RecentlyViewedListings = BaseListing & {
  __typename?: 'RecentlyViewedListings';
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price: Price;
  seoUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum RecommendationProcessor {
  SimilarToFavourites = 'SIMILAR_TO_FAVOURITES'
}

export type RelatedSeoUrlGroup = {
  __typename?: 'RelatedSeoUrlGroup';
  label: Scalars['String']['output'];
  relatedUrls: Array<LabeledUrl>;
};

export type ReplyToSellerModalState = {
  __typename?: 'ReplyToSellerModalState';
  isOpen: Scalars['Boolean']['output'];
  placement?: Maybe<R2SPlacement>;
};

export type RepostAdResponse = {
  __typename?: 'RepostAdResponse';
  status?: Maybe<RepostAdStatus>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum RepostAdStatus {
  Ok = 'OK',
  Redirect = 'REDIRECT'
}

export type RequestPasswordResetLinkInput = {
  email: Scalars['EmailAddress']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['URL']['input'];
};

export enum RequestViewingMode {
  Fsbo = 'FSBO',
  SubscriptionSeller = 'SUBSCRIPTION_SELLER'
}

export type RequestViewingState = {
  __typename?: 'RequestViewingState';
  isModalOpen: Scalars['Boolean']['output'];
  mode?: Maybe<RequestViewingMode>;
  notification?: Maybe<Scalars['String']['output']>;
};

export enum ResponseCode {
  Authorised = 'AUTHORISED',
  Error = 'ERROR',
  Redirectshopper = 'REDIRECTSHOPPER',
  Refused = 'REFUSED'
}

/** V2 of Profile */
export enum Responsiveness {
  Over_72Hours = 'OVER_72_HOURS',
  Under_2Hours = 'UNDER_2_HOURS',
  Under_6Hours = 'UNDER_6_HOURS',
  Under_24Hours = 'UNDER_24_HOURS',
  Under_72Hours = 'UNDER_72_HOURS'
}

export type ResultsCluster = {
  __typename?: 'ResultsCluster';
  boundingBox: BoundingBox;
  coordinates: LocationCoordinates;
  listingCount: Scalars['Int']['output'];
  results?: Maybe<Array<FullListing>>;
};

export enum ResultsView {
  Grid = 'GRID',
  List = 'LIST',
  Map = 'MAP'
}

export type Review = {
  __typename?: 'Review';
  categoryName?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  dateCreated?: Maybe<Scalars['Int']['output']>;
  direction: Direction;
  feedbackOptions?: Maybe<Array<FeedbackOption>>;
  id: Scalars['Int']['output'];
  listingId: Scalars['String']['output'];
  reviewedBy?: Maybe<Profile>;
  revieweeId: Scalars['Int']['output'];
  reviewerId: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type ReviewDetailDirectedSummary = {
  __typename?: 'ReviewDetailDirectedSummary';
  direction: Direction;
  scoreSummary: Array<ScoreSummary>;
};

export type ReviewEligibility = {
  __typename?: 'ReviewEligibility';
  eligibilityDate?: Maybe<Scalars['Int']['output']>;
  isEligible: Scalars['Boolean']['output'];
  waitPeriodToPublishReview?: Maybe<Scalars['Int']['output']>;
};

export type ReviewInput = {
  categoryId: Scalars['Int']['input'];
  conversationId: Scalars['String']['input'];
  direction: Direction;
  feedbackIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  /** @deprecated Reviewer ID will be abstracted from their access token instead. */
  reviewerId?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Int']['input'];
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  sumScore: Scalars['Int']['output'];
  totalReviews: Scalars['Int']['output'];
};

export type Reviews = {
  __typename?: 'Reviews';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Review>;
};

export enum RoleType {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type SdkData = {
  __typename?: 'SDKData';
  token: Scalars['String']['output'];
};

export type SrpListing = BaseListing & {
  __typename?: 'SRPListing';
  attributeMap?: Maybe<AttributeMap>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasCarproof?: Maybe<Scalars['Boolean']['output']>;
  hasFinancing?: Maybe<Scalars['Boolean']['output']>;
  hasIncentives?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  images?: Maybe<Array<Maybe<Image>>>;
  isDisplayPriceDrop?: Maybe<Scalars['Boolean']['output']>;
  isHighLight?: Maybe<Scalars['Boolean']['output']>;
  isPriceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProvincialTopAd?: Maybe<Scalars['Boolean']['output']>;
  isUrgent?: Maybe<Scalars['Boolean']['output']>;
  isVeteranFriendly?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<AdLocation>;
  locationId: Scalars['Int']['output'];
  originalPrice?: Maybe<Price>;
  posterLogoUrl?: Maybe<Scalars['String']['output']>;
  price: Price;
  sortingDate: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum SrpSortBy {
  Date = 'DATE',
  Distance = 'DISTANCE',
  Match = 'MATCH',
  Mileage = 'MILEAGE',
  Price = 'PRICE',
  StartDate = 'START_DATE'
}

export type SrpSortInput = {
  by: SrpSortBy;
  direction: SortDirection;
};

export type ScoreSummary = {
  __typename?: 'ScoreSummary';
  count: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SearchCategory = {
  __typename?: 'SearchCategory';
  id: Scalars['Int']['output'];
  isDomCat?: Maybe<Scalars['Boolean']['output']>;
  localizedName: Scalars['String']['output'];
  name?: Maybe<Locale>;
  parentId?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<SearchCategoryPath>>;
  seoUrl?: Maybe<Scalars['String']['output']>;
};

export type SearchCategoryPath = {
  __typename?: 'SearchCategoryPath';
  id: Scalars['Int']['output'];
  localizedName: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  seoUrl?: Maybe<Scalars['String']['output']>;
};

export type SearchControls = {
  __typename?: 'SearchControls';
  filtering: Array<FilterGroup>;
  sorting: Array<SortOption>;
};

export type SearchInputFromUrlInput = {
  pagination: PaginationInputV2;
  url: Scalars['URL']['input'];
};

export enum SearchOrigin {
  Algolia = 'ALGOLIA',
  Browse = 'BROWSE',
  OrganicKeyword = 'ORGANIC_KEYWORD',
  RecentSearch = 'RECENT_SEARCH',
  SavedSearch = 'SAVED_SEARCH'
}

export type SearchPageState = {
  __typename?: 'SearchPageState';
  currentPage: Scalars['Int']['output'];
  pageViewType: ResultsView;
};

export type SearchQuery = {
  __typename?: 'SearchQuery';
  area?: Maybe<LocationArea>;
  canonicalUrl?: Maybe<Scalars['URL']['output']>;
  category?: Maybe<Category>;
  categoryId: Scalars['Int']['output'];
  filters: Array<AppliedFilter>;
  keywords?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['Int']['output'];
  priceType?: Maybe<FilterPriceType>;
  /** The raw search query string to be used for favouriting searches. */
  searchString: Scalars['String']['output'];
  seoUrl?: Maybe<Scalars['URL']['output']>;
  view: ResultsView;
};

export type SearchQueryInput = {
  additionalFlagFilters?: InputMaybe<Array<AdditionalFlags>>;
  attributeFilters?: InputMaybe<Array<AttributeFilterInput>>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dateFilters?: InputMaybe<Array<DateFilterInput>>;
  dateRangeFilters?: InputMaybe<Array<DateRangeFilterInput>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
  oneListingPerUser?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<SearchOrigin>;
  rangeFilters?: InputMaybe<Array<RangeFilterInput>>;
  toggleFilters?: InputMaybe<Array<ToggleFilterInput>>;
  topAdCount?: InputMaybe<Scalars['Int']['input']>;
  view?: InputMaybe<ResultsView>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  clusters?: Maybe<Array<ResultsCluster>>;
  mainListings: Array<FullListing>;
  topListings: Array<FullListing>;
};


export type SearchResultsMainListingsArgs = {
  pagination?: InputMaybe<PaginationInputV2>;
};

export type SearchResultsByUrlInput = {
  pagination: PaginationInputV2;
  url: Scalars['URL']['input'];
};

export type SearchResultsInput = {
  pagination: PaginationInputV2;
  searchQuery: SearchQueryInput;
  sorting?: InputMaybe<SrpSortInput>;
};

export type SearchResultsPage = {
  __typename?: 'SearchResultsPage';
  /** Contains the SRP Filtering section controls, and the sorting controls info along with selected values. */
  controls: SearchControls;
  /** Pagination and total results details. */
  pagination: Pagination;
  /** New listing array of normalized listings with organic, CAS, and MOVE listings. */
  results?: Maybe<SearchResults>;
  /** The parameters used to query the search as verified by the response. */
  searchQuery: SearchQuery;
};

export type SearchResultsPageInputBy = {
  query?: InputMaybe<SearchQueryInput>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type SearchResultsPageState = {
  __typename?: 'SearchResultsPageState';
  isFilterDrawerOpen: Scalars['Boolean']['output'];
  isListingsDrawerOpen: Scalars['Boolean']['output'];
  loadingFilters: Scalars['Boolean']['output'];
  loadingResults: Scalars['Boolean']['output'];
  pendingSearchInput?: Maybe<PendingSearchInput>;
  searchCategory: SearchCategory;
  searchKeyword?: Maybe<Scalars['String']['output']>;
  selectedAccordionItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchUrlInput = {
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery: SearchQueryInput;
  sorting?: InputMaybe<SrpSortInput>;
};

export type SearchUrlPopularRelatedInput = {
  categoryId: Scalars['ID']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
};

export enum SellDestination {
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SoldElsewhere = 'SOLD_ELSEWHERE',
  SoldOnKijiji = 'SOLD_ON_KIJIJI'
}

export enum SellerType {
  Commercial = 'COMMERCIAL',
  Fsbo = 'FSBO',
  Kmb = 'KMB'
}

/** Shared ENUMS */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortOption = {
  __typename?: 'SortOption';
  by: SrpSortBy;
  direction: SortDirection;
  isSelected: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type StandardAmountPrice = AmountPrice & ListingPrice & {
  __typename?: 'StandardAmountPrice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  originalAmount?: Maybe<Scalars['Float']['output']>;
  type: ListingPriceType;
};

export type StandardListing = FullListing & Listing & {
  __typename?: 'StandardListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  attributes?: Maybe<ListingAttributes>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  favouriteDate?: Maybe<Scalars['DateTime']['output']>;
  flags: ListingFlags;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Int']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocationInterface;
  metrics?: Maybe<ListingMetrics>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  productUrl?: Maybe<Scalars['URL']['output']>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  status: ListingStatus;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type StandardListingAttributes = ListingAttributes & {
  __typename?: 'StandardListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type StandardListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StandardListingFlags = ListingFlags & {
  __typename?: 'StandardListingFlags';
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isFromAutosDealer: Scalars['Boolean']['output'];
  /** Listing flags computed with listing data */
  isFromDealer: Scalars['Boolean']['output'];
  isMoVe: Scalars['Boolean']['output'];
  isPint: Scalars['Boolean']['output'];
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  isSM360: Scalars['Boolean']['output'];
  isVerticalCategory: Scalars['Boolean']['output'];
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
};

export type StandardNotification = Notification & {
  __typename?: 'StandardNotification';
  body: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StandardProfileV2 = ProfileV2 & {
  __typename?: 'StandardProfileV2';
  /** @deprecated For backwards compatibility */
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  /** @deprecated For backwards compatibility */
  isAdmarkt: Scalars['Boolean']['output'];
  /** @deprecated For backwards compatibility, use preferences instead */
  isReadIndicatorEnabled: Scalars['Boolean']['output'];
  /** @deprecated For backwards compatibility, use only in commercial */
  isSalesforceEnabled: Scalars['Boolean']['output'];
  listings?: Maybe<Array<FullListing>>;
  memberSince?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences: UserPreferences;
  profilePath?: Maybe<Scalars['String']['output']>;
  replyRate?: Maybe<Scalars['Int']['output']>;
  responsiveness?: Maybe<Responsiveness>;
  userType: UserType;
};


export type StandardProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type StandardProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type StartEndDate = {
  __typename?: 'StartEndDate';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type StructuredMessage = {
  __typename?: 'StructuredMessage';
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubmitPaymentResponse = {
  __typename?: 'SubmitPaymentResponse';
  nextPaymentAction?: Maybe<NextPaymentAction>;
  responseCode: ResponseCode;
  responseMessage?: Maybe<Scalars['String']['output']>;
  transactionContext?: Maybe<TransactionContext>;
};

export type SurveyAnswerInput = {
  id: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyQuestionInput = {
  answers: Array<InputMaybe<SurveyAnswerInput>>;
  id: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyUserInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TileArrangement = {
  __typename?: 'TileArrangement';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Scalars['String']['output']>;
};

export enum TileDisplayFormat {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum TileStyle {
  Article = 'ARTICLE',
  FullImage = 'FULL_IMAGE'
}

/** Schema for Toggle Filters */
export type ToggleFilter = Filter & {
  __typename?: 'ToggleFilter';
  isSelected: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  trueValue: Scalars['String']['output'];
  type: FilterControlType;
};

export type ToggleFilterInput = {
  filterName: Scalars['String']['input'];
  toggleValue: Scalars['String']['input'];
};

export type TotalListings = {
  __typename?: 'TotalListings';
  CAS?: Maybe<Scalars['Int']['output']>;
  ORGANIC?: Maybe<Scalars['Int']['output']>;
  ZIP?: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  action: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nonInteraction?: Maybe<Scalars['Int']['output']>;
};

export type TransactionContext = {
  __typename?: 'TransactionContext';
  invoice: Scalars['String']['output'];
  targetIds: Array<Scalars['ID']['output']>;
};

export type TransactionData = {
  __typename?: 'TransactionData';
  transactionId: Scalars['ID']['output'];
};

export type TransactionDetails = {
  __typename?: 'TransactionDetails';
  ad?: Maybe<OrganicAd>;
  conversationId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isListingOwner?: Maybe<Scalars['Boolean']['output']>;
  listingId: Scalars['Int']['output'];
  otherUserProfile?: Maybe<Profile>;
  transactionStatus: TransactionStatus;
  waitPeriodToPublishReview?: Maybe<Scalars['Int']['output']>;
};

export enum TransactionStatus {
  ClientConfirmed = 'CLIENT_CONFIRMED',
  ClientDenied = 'CLIENT_DENIED',
  ClientReviewed = 'CLIENT_REVIEWED',
  HandshakeExpired = 'HANDSHAKE_EXPIRED',
  OwnerCreated = 'OWNER_CREATED',
  OwnerReviewed = 'OWNER_REVIEWED',
  ReviewExpired = 'REVIEW_EXPIRED'
}

export type TransportationScore = {
  __typename?: 'TransportationScore';
  cycle?: Maybe<TransportationScoreData>;
  transit?: Maybe<TransportationScoreData>;
  walk?: Maybe<TransportationScoreData>;
};

export type TransportationScoreData = {
  __typename?: 'TransportationScoreData';
  description: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type UpdatePasswordInput = {
  /** New password */
  newPassword: Scalars['String']['input'];
  /** Current password */
  oldPassword: Scalars['String']['input'];
};

export type UpdatePersonalInformationInput = {
  /** Update the user's address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The user's email address. Even if this value is unchanged, it needs to be sent to make sure the user's email address doesn't get changed to blank */
  email: Scalars['EmailAddress']['input'];
  /** The user's full name. Even if this value is unchanged, it needs to be sent to make sure the name doesn't get changed to blank */
  name: Scalars['NonEmptyString']['input'];
  /** Update the phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePreferencesInput = {
  /** Yes, I would like Kijiji and its corporate family members to contact me about events, new features, and other promotional information. */
  contactMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the visit counter on my ads (Only you will be able to see the visits number using My Ads). */
  hideVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Send me Bump Up and other feature notification emails. */
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Read Receipts enabled (others will see when I've read their messages). */
  readReciepts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSocialLinksInput = {
  /** Update facebook url */
  facebook?: InputMaybe<Scalars['String']['input']>;
  /** Update Instagram url */
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** Update LinkedIn url */
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** Update Pinterest url */
  pinterest?: InputMaybe<Scalars['String']['input']>;
  /** Update TikTok url */
  tiktok?: InputMaybe<Scalars['String']['input']>;
  /** Update Twitter url */
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** Update Youtube url */
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UploadProfileImageResponse = {
  __typename?: 'UploadProfileImageResponse';
  /** Object filename returned when the image is uploaded */
  objectId: Scalars['String']['output'];
  /** URL path of the image */
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['Int']['output'];
  recentlyViewedListings?: Maybe<Array<Maybe<RecentlyViewedListings>>>;
};


export type UserRecentlyViewedListingsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserAgent = {
  __typename?: 'UserAgent';
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type UserAuthState = {
  __typename?: 'UserAuthState';
  isMiddlewareAuthenticated?: Maybe<Scalars['Boolean']['output']>;
};

export type UserConversations = {
  __typename?: 'UserConversations';
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserEligibleToReviewNotification = Notification & {
  __typename?: 'UserEligibleToReviewNotification';
  body: Scalars['String']['output'];
  data: UserEligibleToReviewNotificationData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserEligibleToReviewNotificationData = {
  __typename?: 'UserEligibleToReviewNotificationData';
  otherUserProfile?: Maybe<OtherUserProfile>;
  transactionId?: Maybe<Scalars['ID']['output']>;
};

export type UserLocale = {
  __typename?: 'UserLocale';
  apiLocale: Scalars['String']['output'];
  cookieLocale: Scalars['String']['output'];
  languageKey: Scalars['String']['output'];
  routeLocale: Scalars['String']['output'];
};

export type UserLocation = {
  __typename?: 'UserLocation';
  area?: Maybe<LocationArea>;
  id: Scalars['Int']['output'];
  isRegion: Scalars['Boolean']['output'];
  name: Locale;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  /** Yes, I would like Kijiji and its corporate family members to contact me about events, new features, and other promotional information. */
  contactMe: Scalars['Boolean']['output'];
  /** Hide the visit counter on my ads (Only you will be able to see the visits number using My Ads). */
  hideVisit: Scalars['Boolean']['output'];
  /** Send me Bump Up and other feature notification emails. */
  pushNotification: Scalars['Boolean']['output'];
  /** Read Receipts enabled (others will see when I've read their messages). */
  readReceipts: Scalars['Boolean']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAdmarkt?: Maybe<Scalars['Boolean']['output']>;
  isProfessional?: Maybe<Scalars['Boolean']['output']>;
  isSfidEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberSince?: Maybe<Scalars['Float']['output']>;
  numberOfActiveAds?: Maybe<Scalars['Int']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<ProfileType>;
  responsiveness?: Maybe<Scalars['String']['output']>;
};

export type UserRegistrationInput = {
  /** Optional business name. If provided, a Business account is created (otherwise FSBO). */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Name to be displayed on the account's profile */
  displayName: Scalars['String']['input'];
  /** Account's primary email address */
  email: Scalars['EmailAddress']['input'];
  /** Account's password */
  password: Scalars['String']['input'];
  /** reCaptcha token */
  reCaptchaToken: Scalars['String']['input'];
  /** URL to redirect users back to after the account activation */
  redirectUrl: Scalars['String']['input'];
};

export type UserReviewCreatedNotification = Notification & {
  __typename?: 'UserReviewCreatedNotification';
  body: Scalars['String']['output'];
  data: OtherUserProfileData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserReviewPublishedNotification = Notification & {
  __typename?: 'UserReviewPublishedNotification';
  body: Scalars['String']['output'];
  data: OtherUserProfileData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum UserType {
  Admarkt = 'ADMARKT',
  CasMerchant = 'CAS_MERCHANT',
  Dealer = 'DEALER',
  Fsbo = 'FSBO',
  Guest = 'GUEST',
  HeDealer = 'HE_DEALER',
  JobsProfessional = 'JOBS_PROFESSIONAL',
  Professional = 'PROFESSIONAL',
  PvDealer = 'PV_DEALER',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  RetailProfessional = 'RETAIL_PROFESSIONAL',
  ReProfessional = 'RE_PROFESSIONAL',
  RvDealer = 'RV_DEALER',
  Unknown = 'UNKNOWN'
}

export type VehicleReport = {
  __typename?: 'VehicleReport';
  badgeKeys: Array<Scalars['String']['output']>;
  badges: Array<Scalars['String']['output']>;
  providerLogoUrl: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reportUrl?: Maybe<Scalars['String']['output']>;
};

export type ViewportType = {
  __typename?: 'ViewportType';
  northeast?: Maybe<LatLngType>;
  southwest?: Maybe<LatLngType>;
};

export type NextPaymentAction = {
  __typename?: 'nextPaymentAction';
  paymentData: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  sdkData: SdkData;
  type: Scalars['String']['output'];
};

export type PlaceSuggestionsLocalInfo = {
  __typename?: 'placeSuggestionsLocalInfo';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GetListingHomepageGalleryQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  pagination: PaginationInputV2;
  deviceType: DeviceType;
}>;


export type GetListingHomepageGalleryQuery = { __typename?: 'Query', listingHomepageGallery?: { __typename?: 'ListingHomepageGallery', seeAllLink: string, items?: Array<{ __typename?: 'CoreListing', adSource: AdSource, categoryId: number, id: string, imageUrls: Array<string>, title: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', type: ListingPriceType, amount: number } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', type: ListingPriceType, amount: number } | null }> | null } | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'Notifications', newCount: number, notifications: Array<{ __typename?: 'EasyPriceDropNotification', id: string, type: string, body: string, title: string, pictureUrl?: string | null, destinationUrl?: string | null, dateCreated: string, read: boolean } | { __typename?: 'StandardNotification', id: string, type: string, body: string, title: string, pictureUrl?: string | null, destinationUrl?: string | null, dateCreated: string, read: boolean } | { __typename?: 'UserEligibleToReviewNotification', id: string, type: string, body: string, title: string, pictureUrl?: string | null, destinationUrl?: string | null, dateCreated: string, read: boolean } | { __typename?: 'UserReviewCreatedNotification', id: string, type: string, body: string, title: string, pictureUrl?: string | null, destinationUrl?: string | null, dateCreated: string, read: boolean } | { __typename?: 'UserReviewPublishedNotification', id: string, type: string, body: string, title: string, pictureUrl?: string | null, destinationUrl?: string | null, dateCreated: string, read: boolean } | null> } };

export type GetUnreadNotificationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationDataQuery = { __typename?: 'Query', unreadConversationsCount: number };

export type ChangePasswordViaResetLinkMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['UUID']['input'];
}>;


export type ChangePasswordViaResetLinkMutation = { __typename?: 'Mutation', changePasswordViaResetLink?: null | null };

export type GenerateXsrfMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateXsrfMutation = { __typename?: 'Mutation', generateXsrf?: { __typename?: 'GenerateXsrfResponse', message?: string | null, statusCode?: number | null, xsrf: string } | null };

export type LogoutUserMutationVariables = Exact<{
  input: LogoutUserInput;
}>;


export type LogoutUserMutation = { __typename?: 'Mutation', logoutUser?: { __typename?: 'LogoutUserResponse', message?: string | null, statusCode?: number | null } | null };

export type RequestPasswordResetLinkMutationVariables = Exact<{
  input: RequestPasswordResetLinkInput;
}>;


export type RequestPasswordResetLinkMutation = { __typename?: 'Mutation', requestPasswordResetLink?: null | null };

export type RegisterUserMutationVariables = Exact<{
  input: UserRegistrationInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', userRegistration?: null | null };

export type GetAutosWarrantyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAutosWarrantyQuery = { __typename?: 'Query', autosWarranty?: { __typename?: 'AutosWarrantyEstimate', id: string, offerExpiry: any, coverageTermInMonths: number, paymentTermInMonths: number, asLowAsPerMonth: number, downPayment: number } | null };

export type GetCampaignsForVipQueryVariables = Exact<{
  placement: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
}>;


export type GetCampaignsForVipQuery = { __typename?: 'Query', campaigns?: Array<{ __typename?: 'Campaign', id: number, type?: string | null } | null> | null };

export type PopularListingsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
}>;


export type PopularListingsQuery = { __typename?: 'Query', listingsPopular?: { __typename?: 'ListingsPopular', listings?: Array<{ __typename?: 'CoreListing', id: string, title: string, url: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, location: { __typename?: 'ListingLocation', id: number, name: string, province?: ProvinceAbbreviation | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, province?: ProvinceAbbreviation | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, msrp?: number | null, originalAmount?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', averagePrice?: number | null, rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null } | null> | null } | null };

export type EventsExternalClickMutationVariables = Exact<{
  eventsExternalClickId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  urlType: EventsUrlType;
}>;


export type EventsExternalClickMutation = { __typename?: 'Mutation', eventsExternalClick?: null | null };

export type ListingRequestCarfaxMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type ListingRequestCarfaxMutation = { __typename?: 'Mutation', listingRequestCarfax?: null | null };

export type GetListingsMostRecentQueryVariables = Exact<{
  by: SearchResultsPageInputBy;
  pagination: PaginationInputV2;
}>;


export type GetListingsMostRecentQuery = { __typename?: 'Query', searchResultsPage: { __typename?: 'SearchResultsPage', results?: { __typename?: 'SearchResults', mainListings: Array<{ __typename?: 'AutosListing', id: string, categoryId: number, title: string, url: string, imageUrls: Array<string>, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'RealEstateListing', id: string, categoryId: number, title: string, url: string, imageUrls: Array<string>, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'StandardListing', id: string, categoryId: number, title: string, url: string, imageUrls: Array<string>, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null }> } | null, searchQuery: { __typename?: 'SearchQuery', seoUrl?: string | null } } };

export type GetMileageAnalysisQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type GetMileageAnalysisQuery = { __typename?: 'Query', listing?: { __typename?: 'AutosListing', mileageAnalysis?: { __typename?: 'MileageAnalysis', usage: MileageAnalysisUsage, value: number, categories: { __typename?: 'MileageAnalysisCategories', high: number, average: number, low: number } } | null } | { __typename?: 'RealEstateListing' } | { __typename?: 'StandardListing' } | null };

export type ContactSellerMutationVariables = Exact<{
  listingContactId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
}>;


export type ContactSellerMutation = { __typename?: 'Mutation', listingContact: string };

export type ContactSellerWithAttachmentMutationVariables = Exact<{
  listingContactWithAttachmentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  attachment?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type ContactSellerWithAttachmentMutation = { __typename?: 'Mutation', listingContactWithAttachment: string };

export type GetConversationIdByListingIdQueryVariables = Exact<{
  adId: Scalars['Int']['input'];
}>;


export type GetConversationIdByListingIdQuery = { __typename?: 'Query', conversationIdByAdId?: { __typename?: 'ConversationId', id?: string | null } | null };

export type GetInitialStructuredMessageQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInitialStructuredMessageQuery = { __typename?: 'Query', initialStructuredMessage?: Array<{ __typename?: 'StructuredMessage', id?: number | null, message?: string | null } | null> | null };

export type GetR2SStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetR2SStateQuery = { __typename?: 'Query', r2sModalState: { __typename?: 'ReplyToSellerModalState', isOpen: boolean, placement?: R2SPlacement | null } };

export type ListingReportMutationVariables = Exact<{
  listingReportId: Scalars['ID']['input'];
  reason: Reason;
  email?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListingReportMutation = { __typename?: 'Mutation', listingReport?: null | null };

export type RequestViewingMutationVariables = Exact<{
  listingRequestViewingId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requestViewingDates?: InputMaybe<Array<Scalars['Date']['input']> | Scalars['Date']['input']>;
}>;


export type RequestViewingMutation = { __typename?: 'Mutation', listingRequestViewing: string };

export type GetListingsSimilarQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetListingsSimilarQuery = { __typename?: 'Query', listingsSimilar?: Array<{ __typename?: 'CoreListing', adSource: AdSource, categoryId: number, id: string, imageUrls: Array<string>, title: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null }> | null };

export type LivePersonGetIDsQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type LivePersonGetIDsQuery = { __typename?: 'Query', livePersonGetIDs?: { __typename?: 'LivePersonIDs', botId: string, userId: string } | null };

export type LivePersonSendVipDataMutationVariables = Exact<{
  input: LivePersonVipData;
}>;


export type LivePersonSendVipDataMutation = { __typename?: 'Mutation', livePersonSendVipData?: null | null };

export type GetMapProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMapProviderQuery = { __typename?: 'Query', mapProvider?: { __typename?: 'MapProvider', isLoading?: boolean | null, error?: boolean | null, apiKey: string } | null };

export type GetModalStateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetModalStateQuery = { __typename?: 'Query', modal: { __typename?: 'ModalState', id: string, isOpen: boolean } };

export type GetMenuPrefetchQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>> | InputMaybe<Hints>>;
}>;


export type GetMenuPrefetchQuery = { __typename?: 'Query', menuPrefetch?: Array<{ __typename?: 'MenuItem', id: number, categoryName: string, isLeaf: boolean, seoUrl: string, children?: Array<{ __typename?: 'MenuItem', categoryName: string, seoUrl: string, isLeaf: boolean, id: number, children?: Array<{ __typename?: 'MenuItem', categoryName: string, id: number, isLeaf: boolean, seoUrl: string } | null> | null } | null> | null } | null> | null };

export type GetGoogleReviewsQueryVariables = Exact<{
  dealerId: Scalars['ID']['input'];
}>;


export type GetGoogleReviewsQuery = { __typename?: 'Query', reviewsFromGoogle?: { __typename?: 'GoogleReviews', rating: number, totalCount: number, url: string, reviews: Array<{ __typename?: 'GoogleReview', rating: number, text?: string | null, time: any, author: { __typename?: 'GoogleAuthor', name: string, profileUrl?: string | null, profilePhotoUrl?: string | null } }> } | null };

export type GetProfileQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  size: LogoType;
}>;


export type GetProfileQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', logoUrl?: string | null, staticMapUrl?: string | null, websiteUrl?: string | null, id: string, name: string, numberOfListings?: number | null, userType: UserType, profilePath?: string | null, preferences: { __typename?: 'UserPreferences', hideVisit: boolean } } | { __typename?: 'StandardProfileV2', imageUrl?: string | null, isSalesforceEnabled: boolean, id: string, name: string, numberOfListings?: number | null, userType: UserType, profilePath?: string | null, preferences: { __typename?: 'UserPreferences', hideVisit: boolean } } };

export type GetProfilePhoneNumberQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  listingId?: InputMaybe<Scalars['ID']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PhoneNumberSource>;
}>;


export type GetProfilePhoneNumberQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', phoneNumber?: string | null, id: string } | { __typename?: 'StandardProfileV2', phoneNumber?: string | null, id: string } };

export type GetReviewSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetReviewSummaryQuery = { __typename?: 'Query', reviewSummary: { __typename?: 'ReviewSummary', sumScore: number, totalReviews: number } };

export type AutocompleteSuggestionsQueryVariables = Exact<{
  input: AutocompleteSuggestionsInput;
}>;


export type AutocompleteSuggestionsQuery = { __typename?: 'Query', autocompleteSuggestions: Array<{ __typename?: 'AutocompleteSuggestion', completion: string, categories: Array<{ __typename?: 'AutocompleteCategory', id: string, localizedName: string }> }> };

export type GetSearchPageStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchPageStateQuery = { __typename?: 'Query', searchState: { __typename?: 'SearchPageState', pageViewType: ResultsView, currentPage: number } };

export type GetSearchUrlQueryVariables = Exact<{
  input: SearchUrlInput;
}>;


export type GetSearchUrlQuery = { __typename?: 'Query', searchUrl?: string | null };

export type GetProfileMetricsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileMetricsQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', id: string, memberSince?: string | null } | { __typename?: 'StandardProfileV2', replyRate?: number | null, responsiveness?: Responsiveness | null, id: string, memberSince?: string | null } };

export type PersonalInformationFieldsFragment = { __typename?: 'PersonalAccount', accountType: string, id: string, name?: string | null, email?: string | null, address?: string | null, profileUrl?: string | null, phoneNumber?: string | null };

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'Query', myAccount?: { __typename?: 'PersonalAccount', accountType: string, id: string, name?: string | null, email?: string | null, address?: string | null, profileUrl?: string | null, phoneNumber?: string | null } | null };

export type GetAlgoliaKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetAlgoliaKeyMutation = { __typename?: 'Mutation', getAlgoliaKey?: boolean | null };

export type GetCampaignsQueryVariables = Exact<{
  placement: Scalars['String']['input'];
  customType: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  filterAmount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: Array<{ __typename?: 'Campaign', customFields?: string | null, id: number } | null> | null };

export type GetCategoryPathQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCategoryPathQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null };

export type GetAppDownloadBannerStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppDownloadBannerStateQuery = { __typename?: 'Query', appDownloadBanner: { __typename?: 'AppDownloadBannerState', isVisible: boolean } };

export type GetHomeFeedAdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeFeedAdsQuery = { __typename?: 'Query', homeFeedAds: { __typename?: 'HomeFeedAds', adSlots?: number | null } };

export type GetPsaDismissedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPsaDismissedQuery = { __typename?: 'Query', dismissedStates: { __typename?: 'DismissedStates', appDownloadPSA: boolean, siteMaintenancePSA_may27th: boolean } };

export type GetSearchCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchCategoryQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', searchCategory: { __typename?: 'SearchCategory', id: number, isDomCat?: boolean | null, localizedName: string, parentId?: number | null, seoUrl?: string | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null, path?: Array<{ __typename?: 'SearchCategoryPath', id: number, localizedName: string, parentId?: number | null, seoUrl?: string | null }> | null } } };

export type GetSearchKeywordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchKeywordQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', searchKeyword?: string | null } };

export type GetUserAgentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAgentQuery = { __typename?: 'Query', userAgent: { __typename?: 'UserAgent', userAgent?: string | null } };

export type GetUserAuthStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAuthStateQuery = { __typename?: 'Query', userAuthState: { __typename?: 'UserAuthState', isMiddlewareAuthenticated?: boolean | null } };

export type GetUserLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLocaleQuery = { __typename?: 'Query', userLocale: { __typename?: 'UserLocale', apiLocale: string, cookieLocale: string, languageKey: string, routeLocale: string } };

export type GetUserLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLocationQuery = { __typename?: 'Query', userLocation: { __typename?: 'UserLocation', id: number, isRegion: boolean, name: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null }, area?: { __typename?: 'LocationArea', latitude: number, longitude: number, radius: number, address?: string | null } | null } };

export type GetContentModuleQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  moduleId: ContentModuleId;
}>;


export type GetContentModuleQuery = { __typename?: 'Query', contentModule?: { __typename?: 'BrowseHeroModule', component: string, title: Array<{ __typename?: 'CustomizedText', text?: string | null, style?: { __typename?: 'CustomizedTextStyle', color?: string | null, isBold?: boolean | null } | null } | null>, partner?: { __typename?: 'Partner', title?: string | null, brand: { __typename?: 'PartnerBrand', logoUrl?: string | null, link?: string | null } } | null, tiles: Array<{ __typename?: 'BrowseTile', title: string, type?: string | null, link: { __typename?: 'LinkType', url: string, isNewTab?: boolean | null }, tracking?: { __typename?: 'Tracking', action: string, label: string } | null, background?: { __typename?: 'BackgroundType', imageUrl?: string | null, altText?: string | null } | null } | null> } | null };

export type FavouriteSearchActivateMutationVariables = Exact<{
  input: FavouriteSearchActivateInput;
}>;


export type FavouriteSearchActivateMutation = { __typename?: 'Mutation', favouriteSearchActivate: string };

export type FavouriteSearchActivateGuestMutationVariables = Exact<{
  searchString: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type FavouriteSearchActivateGuestMutation = { __typename?: 'Mutation', activateFavouriteSearchGuest?: number | null };

export type FavouriteSearchDeactivateMutationVariables = Exact<{
  favouriteSearchDeactivateId: Scalars['ID']['input'];
}>;


export type FavouriteSearchDeactivateMutation = { __typename?: 'Mutation', favouriteSearchDeactivate?: null | null };

export type FavouriteSearchIdLookupQueryVariables = Exact<{
  input: FavouriteSearchIdLookupInput;
}>;


export type FavouriteSearchIdLookupQuery = { __typename?: 'Query', favouriteSearchIdLookup?: { __typename?: 'FavouriteSearchIdLookupOutput', id: string, active: boolean } | null };

export type GetSearchCategoriesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetSearchCategoriesQuery = { __typename?: 'Query', searchCategories?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null } | null> | null };

export type GetGoogleMapsKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleMapsKeyMutation = { __typename?: 'Mutation', getGoogleMapsKey?: boolean | null };

export type GetPlaceSuggestionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
  location?: InputMaybe<LocationQueryCoordsOptions>;
}>;


export type GetPlaceSuggestionsQuery = { __typename?: 'Query', placeSuggestions?: Array<{ __typename?: 'PlaceSuggestions', placeId?: string | null, address?: string | null } | null> | null };

export type GetPlaceTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetPlaceTokenMutation = { __typename?: 'Mutation', getPlaceToken?: boolean | null };

export type GetCategoriesNearYouQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetCategoriesNearYouQuery = { __typename?: 'Query', menuPrefetch?: Array<{ __typename?: 'MenuItem', id: number, categoryName: string, seoUrl: string } | null> | null };

export type GetFeedRecommendationsQueryVariables = Exact<{
  input: FeedRecommendationsInput;
}>;


export type GetFeedRecommendationsQuery = { __typename?: 'Query', feedRecommendations?: { __typename?: 'FeedRecommendations', seedId: number, description: string, seoUrl: string, ads?: Array<{ __typename?: 'FeedItem', id: string, categoryId: number, imageUrls?: Array<string | null> | null, locationId: number, seoUrl: string, title: string, type: string, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | null> | null } | null };

export type GetHomeFeedQueryVariables = Exact<{
  input: HomeFeedInput;
  homePageMixGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHomeFeedQuery = { __typename?: 'Query', homeFeed?: { __typename?: 'HomeFeed', pageInfo?: { __typename?: 'FeedPageInfo', currentPage?: number | null, numberOfAds?: number | null, hasNextPage?: boolean | null, links?: Array<number | null> | null } | null, results?: Array<{ __typename?: 'BrandedCategoryItem', id: string, imageUrl: string, seoUrl: string, title: string } | { __typename?: 'FeedItem', id: string, imageUrls?: Array<string | null> | null, processorName?: string | null, seoUrl: string, title: string, type: string, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | { __typename?: 'PopularCategoryItem', id: string, seoUrl: string, title: string } | null> | null } | null };

export type GetPopularKeywordsNearYouQueryVariables = Exact<{
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetPopularKeywordsNearYouQuery = { __typename?: 'Query', searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type GetRecentlyViewedListingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetRecentlyViewedListingsQuery = { __typename?: 'Query', user?: { __typename?: 'User', recentlyViewedListings?: Array<{ __typename?: 'RecentlyViewedListings', title: string, seoUrl: string, imageUrls?: Array<string | null> | null, id: string, locationId: number, categoryId: number, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | null> | null } | null };

export type GetRecommendedForYouQueryVariables = Exact<{
  listingIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetRecommendedForYouQuery = { __typename?: 'Query', listingsRecommendedForYou?: Array<{ __typename?: 'CoreListing', adSource: AdSource, id: string, categoryId: number, title: string, imageUrls: Array<string>, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | null> | null };

export type GetListingQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  trackView?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetListingQuery = { __typename?: 'Query', listing?: { __typename?: 'AutosListing', activationDate?: any | null, adSource: AdSource, productUrl?: string | null, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, youtubeVideoId?: string | null, status: ListingStatus, endDate?: any | null, externalSource?: { __typename?: 'ExternalListingSource', sourceProviderId?: string | null } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null }, flags: { __typename?: 'AutosListingFlags', chatOptIn?: boolean | null, creditOptIn?: boolean | null, tradeInOptIn?: boolean | null, enhancedContactForm?: boolean | null, financingAvailable?: boolean | null, categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, isFromAutosDealer?: boolean | null, isFromDealer?: boolean | null, isMoVe?: boolean | null, isPint?: boolean | null, isSM360?: boolean | null, isVerticalCategory?: boolean | null }, location: { __typename?: 'ListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', name: string, id: string, profile?: { __typename?: 'NeighbourhoodProfile', summary?: string | null, transportation?: string | null } | null, scores?: { __typename?: 'NeighbourhoodScores', transportation?: { __typename?: 'TransportationScore', cycle?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, walk?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, transit?: { __typename?: 'TransportationScoreData', score: number, description: string } | null } | null } | null } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null, phoneNumber?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', averagePrice?: number | null, rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null, metrics?: { __typename?: 'ListingMetrics', views: number } | null } | { __typename?: 'RealEstateListing', virtualTourUrl?: string | null, mlsAd?: boolean | null, requestViewingUrl?: string | null, rentalBadge?: string | null, activationDate?: any | null, adSource: AdSource, productUrl?: string | null, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, youtubeVideoId?: string | null, status: ListingStatus, endDate?: any | null, externalSource?: { __typename?: 'ExternalListingSource', sourceProviderId?: string | null } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', comfree?: boolean | null, categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, isFromAutosDealer?: boolean | null, isFromDealer?: boolean | null, isMoVe?: boolean | null, isPint?: boolean | null, isSM360?: boolean | null, isVerticalCategory?: boolean | null }, location: { __typename?: 'ListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', name: string, id: string, profile?: { __typename?: 'NeighbourhoodProfile', summary?: string | null, transportation?: string | null } | null, scores?: { __typename?: 'NeighbourhoodScores', transportation?: { __typename?: 'TransportationScore', cycle?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, walk?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, transit?: { __typename?: 'TransportationScoreData', score: number, description: string } | null } | null } | null } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null, phoneNumber?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', averagePrice?: number | null, rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null, metrics?: { __typename?: 'ListingMetrics', views: number } | null } | { __typename?: 'StandardListing', activationDate?: any | null, adSource: AdSource, productUrl?: string | null, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, youtubeVideoId?: string | null, status: ListingStatus, endDate?: any | null, externalSource?: { __typename?: 'ExternalListingSource', sourceProviderId?: string | null } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', chatOptIn?: boolean | null, creditOptIn?: boolean | null, tradeInOptIn?: boolean | null, enhancedContactForm?: boolean | null, financingAvailable?: boolean | null, categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, isFromAutosDealer?: boolean | null, isFromDealer?: boolean | null, isMoVe?: boolean | null, isPint?: boolean | null, isSM360?: boolean | null, isVerticalCategory?: boolean | null } | { __typename?: 'RealEstateListingFlags', comfree?: boolean | null, categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, isFromAutosDealer?: boolean | null, isFromDealer?: boolean | null, isMoVe?: boolean | null, isPint?: boolean | null, isSM360?: boolean | null, isVerticalCategory?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, isFromAutosDealer: boolean, isFromDealer: boolean, isMoVe: boolean, isPint: boolean, isSM360: boolean, isVerticalCategory: boolean }, location: { __typename?: 'ListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', showPinOnMap?: boolean | null, address?: string | null, id: number, name: string, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', name: string, id: string, profile?: { __typename?: 'NeighbourhoodProfile', summary?: string | null, transportation?: string | null } | null, scores?: { __typename?: 'NeighbourhoodScores', transportation?: { __typename?: 'TransportationScore', cycle?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, walk?: { __typename?: 'TransportationScoreData', score: number, description: string } | null, transit?: { __typename?: 'TransportationScoreData', score: number, description: string } | null } | null } | null } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null, phoneNumber?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', averagePrice?: number | null, rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null, metrics?: { __typename?: 'ListingMetrics', views: number } | null } | null };

export type GetSellerListingDataQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type GetSellerListingDataQuery = { __typename?: 'Query', listing?: { __typename?: 'AutosListing', metrics?: { __typename?: 'ListingMetrics', replies?: number | null } | null } | { __typename?: 'RealEstateListing', metrics?: { __typename?: 'ListingMetrics', replies?: number | null } | null } | { __typename?: 'StandardListing', metrics?: { __typename?: 'ListingMetrics', replies?: number | null } | null } | null };

export type ListingRequestFinancingMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
  externalSourceId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  listingRequestFinancingId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
}>;


export type ListingRequestFinancingMutation = { __typename?: 'Mutation', listingRequestFinancing?: null | null };

export type VehicleReportQueryVariables = Exact<{
  adId: Scalars['Int']['input'];
  source?: InputMaybe<AdSource>;
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VehicleReportQuery = { __typename?: 'Query', ad?: { __typename?: 'MoveAd', vehicleReport?: { __typename?: 'VehicleReport', badgeKeys: Array<string>, reportUrl?: string | null } | null } | { __typename?: 'OrganicAd' } | null };

export type GetGeocodeCanadianAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetGeocodeCanadianAddressQuery = { __typename?: 'Query', geocodeCanadianAddress?: { __typename?: 'GeocodeCanadianAddress', location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | null };

export type GetGeocodeReverseFromIpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeocodeReverseFromIpQuery = { __typename?: 'Query', geocodeReverseFromIp: { __typename?: 'GeocodeReverseFromIp', city?: string | null, province: ProvinceAbbreviation, locationId?: number | null } };

export type GetLocationFromCoordinatesQueryVariables = Exact<{
  coordinates: LocationQueryCoordsOptions;
}>;


export type GetLocationFromCoordinatesQuery = { __typename?: 'Query', locationFromCoordinates?: { __typename?: 'LocationWithPlace', location?: { __typename?: 'Location', id: number, locationPaths?: Array<{ __typename?: 'Location', id: number }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null, place?: { __typename?: 'PlaceDetails', address?: string | null, location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, postalCode?: { __typename?: 'AddressFormat', long: string } | null } | null } | null };

export type GetLocationFromIdQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetLocationFromIdQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: number, localizedName?: string | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | null };

export type GetLocationFromPlaceQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationFromPlaceQuery = { __typename?: 'Query', locationFromPlace?: { __typename?: 'LocationWithPlace', place?: { __typename?: 'PlaceDetails', id?: string | null, address?: string | null, isCountry: boolean, isProvince: boolean, location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, postalCode?: { __typename?: 'AddressFormat', long: string, short: string } | null } | null, location?: { __typename?: 'Location', id: number, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null } | null };

export type GetLocationPathFromIdQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetLocationPathFromIdQuery = { __typename?: 'Query', location?: { __typename?: 'Location', locationPaths?: Array<{ __typename?: 'Location', id: number, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null }> | null } | null };

export type SocialLinksFieldsFragment = { __typename?: 'PersonalAccount', socialLinks?: { __typename?: 'AccountSocialLinks', facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null, tiktok?: string | null, pinterest?: string | null, linkedin?: string | null } | null };

export type GetSocialLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialLinksQuery = { __typename?: 'Query', myAccount?: { __typename?: 'PersonalAccount', socialLinks?: { __typename?: 'AccountSocialLinks', facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null, tiktok?: string | null, pinterest?: string | null, linkedin?: string | null } | null } | null };

export type UpdateSocialLinksMutationVariables = Exact<{
  input: UpdateSocialLinksInput;
}>;


export type UpdateSocialLinksMutation = { __typename?: 'Mutation', updateSocialLinks?: { __typename?: 'StatusResponse', statusCode?: number | null } | null };

export type AddFavouriteListingMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type AddFavouriteListingMutation = { __typename?: 'Mutation', addFavouriteListing: string };

export type GetAuthModalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthModalStateQuery = { __typename?: 'Query', authModalState: { __typename?: 'AuthModalState', isModalOpen: boolean, modalVariant?: AuthModalVariant | null, callbackUrl?: string | null, categoryId?: number | null } };

export type GetSeoUrlQueryVariables = Exact<{
  input: SearchUrlInput;
}>;


export type GetSeoUrlQuery = { __typename?: 'Query', searchUrl?: string | null };

export type GetSearchResultsPageByUrlQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
  pagination: PaginationInputV2;
}>;


export type GetSearchResultsPageByUrlQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null, dateSearchRangeBound?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> }, pagination: { __typename?: 'Pagination', offset: number, limit: number, totalCount: number }, searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, canonicalUrl?: string | null, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number, boundingBox?: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } } | null } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, dateSearchRangeBound?: string | null, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }> }, results?: { __typename?: 'SearchResults', topListings: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }>, mainListings: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }>, clusters?: Array<{ __typename?: 'ResultsCluster', listingCount: number, coordinates: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, boundingBox: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } }, results?: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }> | null }> | null } | null } };

export type GetSearchResultsPageByUrlWithSeoQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
  pagination: PaginationInputV2;
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetSearchResultsPageByUrlWithSeoQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null, dateSearchRangeBound?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> }, pagination: { __typename?: 'Pagination', offset: number, limit: number, totalCount: number }, searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, canonicalUrl?: string | null, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number, boundingBox?: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } } | null } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, dateSearchRangeBound?: string | null, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }> }, results?: { __typename?: 'SearchResults', topListings: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }>, mainListings: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }>, clusters?: Array<{ __typename?: 'ResultsCluster', listingCount: number, coordinates: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, boundingBox: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } }, results?: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }> | null }> | null } | null }, searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type BreadcrumbsSearchQueryFragment = { __typename?: 'SearchQuery', keywords?: string | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null };

export type GetBreadcrumbsBySearchPageUrlQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
}>;


export type GetBreadcrumbsBySearchPageUrlQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null } } };

export type GetCategoriesQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'Attribute', id: number, canonicalName?: string | null, localizedFields?: Array<{ __typename?: 'AttributeFields', canonicalValue?: string | null, seoSlug?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetUserFavouritesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFavouritesListQuery = { __typename?: 'Query', favouriteListingsIds: Array<string> };

export type GetFilterDrawerStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterDrawerStateQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', isFilterDrawerOpen: boolean, selectedAccordionItems?: Array<string> | null } };

export type GetListingsDrawerStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingsDrawerStateQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', isListingsDrawerOpen: boolean } };

export type GetMapSearchResultsPageStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMapSearchResultsPageStateQuery = { __typename?: 'Query', mapSrp: { __typename?: 'MapSearchResultsPageState', shouldUpdateLocationRef: boolean } };

export type GetOrganicListingsQueryVariables = Exact<{
  input: SearchResultsInput;
  pagination: PaginationInputV2;
}>;


export type GetOrganicListingsQuery = { __typename?: 'Query', searchResultsPageUpdate: { __typename?: 'SearchResultsPage', results?: { __typename?: 'SearchResults', mainListings: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }> } | null } };

export type GetPopularRelatedKeywordsQueryVariables = Exact<{
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetPopularRelatedKeywordsQuery = { __typename?: 'Query', searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type GetSearchLoadingStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchLoadingStateQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', loadingFilters: boolean, loadingResults: boolean } };

export type GetPendingSearchInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingSearchInputQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', pendingSearchInput?: { __typename?: 'PendingSearchInput', keywords?: string | null, by?: SrpSortBy | null, direction?: SortDirection | null, offset?: number | null, additionalFlagFilters?: Array<AdditionalFlags> | null, attributeFilters?: Array<{ __typename?: 'AppliedAttributeFilter', filterName: string, values: Array<string> }> | null, rangeFilters?: Array<{ __typename?: 'AppliedRangeFilter', filterName: string, minValue?: number | null, maxValue?: number | null }> | null, dateRangeFilters?: Array<{ __typename?: 'AppliedDateRangeFilter', filterName: string, start?: string | null, end?: string | null }> | null, dateFilters?: Array<{ __typename?: 'AppliedDateFilter', filterName: string, value: string }> | null, toggleFilters?: Array<{ __typename?: 'AppliedToggleFilter', filterName: string, toggleValue: string }> | null } | null } };

export type GetVipUrlQueryVariables = Exact<{
  adId: Scalars['ID']['input'];
}>;


export type GetVipUrlQuery = { __typename?: 'Query', listingUrl: string };

export type RemoveFavouriteListingMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type RemoveFavouriteListingMutation = { __typename?: 'Mutation', removeFavouriteListing: string };

export type ClustersFieldsFragment = { __typename?: 'ResultsCluster', listingCount: number, coordinates: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, boundingBox: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } }, results?: Array<{ __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null }> | null };

export type AttributeFilterFieldsFragment = { __typename: 'AttributeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null };

export type DateFilterFieldsFragment = { __typename: 'DateFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValue?: string | null, dateSearchRangeBound?: string | null };

export type RangeFilterFieldsFragment = { __typename: 'RangeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null };

export type ToggleFilterFieldsFragment = { __typename: 'ToggleFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, trueValue: string, isSelected: boolean };

type Listing_AutosListing_Fragment = { __typename?: 'AutosListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } };

type Listing_RealEstateListing_Fragment = { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } };

type Listing_StandardListing_Fragment = { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageCount: number, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | { __typename?: 'RealEstateListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null, neighbourhoodInfo?: { __typename?: 'NeighbourhoodInfo', id: string, name: string } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType, classification?: { __typename?: 'ListingPriceClassification', rating: ListingPriceRating } | null } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, rating?: number | null }, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null };

export type ListingFragment = Listing_AutosListing_Fragment | Listing_RealEstateListing_Fragment | Listing_StandardListing_Fragment;

export type PaginationFieldsFragment = { __typename?: 'Pagination', offset: number, limit: number, totalCount: number };

export type SearchControlsFieldsFragment = { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null, dateSearchRangeBound?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> };

export type SearchQueryFieldsFragment = { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, canonicalUrl?: string | null, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number, boundingBox?: { __typename?: 'BoundingBox', ne: { __typename?: 'LocationCoordinates', latitude: number, longitude: number }, sw: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } } | null } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, dateSearchRangeBound?: string | null, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }> };

export type GetPosterOtherAdsQueryVariables = Exact<{
  sort: ProfileSortInput;
  pagination: PaginationInputV2;
  profileId: Scalars['ID']['input'];
}>;


export type GetPosterOtherAdsQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', id: string, name: string, listings?: Array<{ __typename?: 'AutosListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'RealEstateListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'StandardListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null }> | null } | { __typename?: 'StandardProfileV2', id: string, name: string, listings?: Array<{ __typename?: 'AutosListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'RealEstateListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null } | { __typename?: 'StandardListing', title: string, adSource: AdSource, categoryId: number, imageUrls: Array<string>, id: string, url: string, location: { __typename?: 'ListingLocation', id: number, name: string } | { __typename?: 'RealEstateListingLocation', id: number, name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null }> | null } };

export type GetPromotedUrlsQueryVariables = Exact<{
  input: GetPromotedUrlsInput;
}>;


export type GetPromotedUrlsQuery = { __typename?: 'Query', getPromotedUrls: { __typename?: 'GetPromotedUrlsResponse', promotedUrls: Array<{ __typename?: 'PromotedUrl', url: string, keywords: string, categoryId: number, locationId: number }> } };

export type GetRequestViewingModalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestViewingModalStateQuery = { __typename?: 'Query', requestViewingState: { __typename?: 'RequestViewingState', isModalOpen: boolean, notification?: string | null, mode?: RequestViewingMode | null } };

export const PersonalInformationFieldsFragmentDoc = gql`
    fragment PersonalInformationFields on PersonalAccount {
  accountType
  id
  name
  email
  address
  profileUrl
  phoneNumber
}
    `;
export const SocialLinksFieldsFragmentDoc = gql`
    fragment SocialLinksFields on PersonalAccount {
  socialLinks {
    facebook
    instagram
    twitter
    youtube
    tiktok
    pinterest
    linkedin
  }
}
    `;
export const BreadcrumbsSearchQueryFragmentDoc = gql`
    fragment BreadcrumbsSearchQuery on SearchQuery {
  category {
    id
    localizedName
    parentId
    searchSeoUrl
    categoryPaths {
      id
      localizedName
      parentId
      searchSeoUrl
    }
  }
  keywords
}
    `;
export const ListingFragmentDoc = gql`
    fragment Listing on FullListing {
  id
  title
  description
  imageCount
  imageUrls
  categoryId
  url
  activationDate
  sortingDate
  adSource
  location {
    id
    name
    address
    distance
    nearestIntersection
    coordinates {
      latitude
      longitude
    }
    ... on RealEstateListingLocation {
      neighbourhoodInfo {
        id
        name
      }
    }
  }
  price {
    type
    ... on AmountPrice {
      amount
      originalAmount
    }
    ... on AutosDealerAmountPrice {
      msrp
      surcharges
      classification {
        rating
      }
    }
  }
  flags {
    categorySpecificBadge
    priceDrop
    showcase
    topAd
    highlight
    shippedBySeller
    isPromotionProvTopAd
    isPromotionTopAd
    ... on RealEstateListingFlags {
      virtualTour
    }
  }
  posterInfo {
    posterId
    rating
  }
  attributes {
    all {
      canonicalName
      canonicalValues
    }
  }
}
    `;
export const ClustersFieldsFragmentDoc = gql`
    fragment ClustersFields on ResultsCluster {
  listingCount
  coordinates {
    latitude
    longitude
  }
  boundingBox {
    ne {
      latitude
      longitude
    }
    sw {
      latitude
      longitude
    }
  }
  results {
    ...Listing
  }
}
    ${ListingFragmentDoc}`;
export const PaginationFieldsFragmentDoc = gql`
    fragment PaginationFields on Pagination {
  offset
  limit
  totalCount
}
    `;
export const AttributeFilterFieldsFragmentDoc = gql`
    fragment AttributeFilterFields on AttributeFilter {
  __typename
  type
  name
  parentName
  label
  values {
    label
    value
    totalResults
    parentValue
    seoUrl
  }
  selectedValues
}
    `;
export const RangeFilterFieldsFragmentDoc = gql`
    fragment RangeFilterFields on RangeFilter {
  __typename
  type
  name
  parentName
  label
  fromRange {
    min
    max
  }
  toRange {
    min
    max
  }
  rangeLabels {
    from
    to
  }
  selectedRangeValues {
    __typename
    ... on MinMax {
      __typename
      min
      max
    }
    ... on StartEndDate {
      __typename
      start
      end
    }
  }
}
    `;
export const DateFilterFieldsFragmentDoc = gql`
    fragment DateFilterFields on DateFilter {
  __typename
  type
  name
  parentName
  label
  selectedValue
  dateSearchRangeBound
}
    `;
export const ToggleFilterFieldsFragmentDoc = gql`
    fragment ToggleFilterFields on ToggleFilter {
  __typename
  type
  name
  parentName
  label
  trueValue
  isSelected
}
    `;
export const SearchControlsFieldsFragmentDoc = gql`
    fragment SearchControlsFields on SearchControls {
  filtering {
    name
    label
    shouldShowTopLevelAccordion
    quickFilterSortOrder
    filters {
      name
      type
      label
      parentName
      ... on AttributeFilter {
        ...AttributeFilterFields
      }
      ... on RangeFilter {
        ...RangeFilterFields
      }
      ... on DateFilter {
        ...DateFilterFields
      }
      ... on ToggleFilter {
        ...ToggleFilterFields
      }
    }
  }
  sorting {
    by
    direction
    label
    isSelected
  }
}
    ${AttributeFilterFieldsFragmentDoc}
${RangeFilterFieldsFragmentDoc}
${DateFilterFieldsFragmentDoc}
${ToggleFilterFieldsFragmentDoc}`;
export const SearchQueryFieldsFragmentDoc = gql`
    fragment SearchQueryFields on SearchQuery {
  area {
    address
    latitude
    longitude
    radius
    boundingBox {
      ne {
        latitude
        longitude
      }
      sw {
        latitude
        longitude
      }
    }
  }
  category {
    id
    localizedName
    parentId
    searchSeoUrl
    categoryPaths {
      id
      localizedName
      parentId
      searchSeoUrl
    }
  }
  keywords
  location {
    id
    localizedName
    locationPaths {
      id
      localizedName
    }
    name {
      en_CA
      fr_CA
    }
  }
  seoUrl
  searchString
  canonicalUrl
  filters {
    filterName
    ... on AppliedAdditionalFlagsFilter {
      flags
    }
    ... on AppliedAttributeFilter {
      values
    }
    ... on AppliedRangeFilter {
      minValue
      maxValue
    }
    ... on AppliedDateRangeFilter {
      start
      end
    }
    ... on AppliedDateFilter {
      value
      dateSearchRangeBound
    }
    ... on AppliedToggleFilter {
      toggleValue
    }
  }
}
    `;
export const GetListingHomepageGalleryDocument = gql`
    query GetListingHomepageGallery($locationId: Int!, $pagination: PaginationInputV2!, $deviceType: DeviceType!) {
  listingHomepageGallery(
    locationId: $locationId
    pagination: $pagination
    deviceType: $deviceType
  ) {
    items {
      adSource
      categoryId
      id
      imageUrls
      location {
        id
        name
      }
      title
      price {
        ... on NonAmountPrice {
          type
        }
        ... on StandardAmountPrice {
          type
          amount
        }
        ... on AutosDealerAmountPrice {
          type
          amount
        }
        ... on AmountPrice {
          type
          amount
        }
      }
      url
    }
    seeAllLink
  }
}
    `;

/**
 * __useGetListingHomepageGalleryQuery__
 *
 * To run a query within a React component, call `useGetListingHomepageGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingHomepageGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingHomepageGalleryQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      pagination: // value for 'pagination'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useGetListingHomepageGalleryQuery(baseOptions: Apollo.QueryHookOptions<GetListingHomepageGalleryQuery, GetListingHomepageGalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingHomepageGalleryQuery, GetListingHomepageGalleryQueryVariables>(GetListingHomepageGalleryDocument, options);
      }
export function useGetListingHomepageGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingHomepageGalleryQuery, GetListingHomepageGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingHomepageGalleryQuery, GetListingHomepageGalleryQueryVariables>(GetListingHomepageGalleryDocument, options);
        }
export type GetListingHomepageGalleryQueryHookResult = ReturnType<typeof useGetListingHomepageGalleryQuery>;
export type GetListingHomepageGalleryLazyQueryHookResult = ReturnType<typeof useGetListingHomepageGalleryLazyQuery>;
export type GetListingHomepageGalleryQueryResult = Apollo.QueryResult<GetListingHomepageGalleryQuery, GetListingHomepageGalleryQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications {
  notifications {
    newCount
    notifications {
      id
      type
      body
      title
      pictureUrl
      destinationUrl
      dateCreated
      read
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetUnreadNotificationDataDocument = gql`
    query GetUnreadNotificationData {
  unreadConversationsCount
}
    `;

/**
 * __useGetUnreadNotificationDataQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>(GetUnreadNotificationDataDocument, options);
      }
export function useGetUnreadNotificationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>(GetUnreadNotificationDataDocument, options);
        }
export type GetUnreadNotificationDataQueryHookResult = ReturnType<typeof useGetUnreadNotificationDataQuery>;
export type GetUnreadNotificationDataLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationDataLazyQuery>;
export type GetUnreadNotificationDataQueryResult = Apollo.QueryResult<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>;
export const ChangePasswordViaResetLinkDocument = gql`
    mutation changePasswordViaResetLink($password: String!, $token: UUID!) {
  changePasswordViaResetLink(password: $password, token: $token)
}
    `;
export type ChangePasswordViaResetLinkMutationFn = Apollo.MutationFunction<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>;

/**
 * __useChangePasswordViaResetLinkMutation__
 *
 * To run a mutation, you first call `useChangePasswordViaResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordViaResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordViaResetLinkMutation, { data, loading, error }] = useChangePasswordViaResetLinkMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useChangePasswordViaResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>(ChangePasswordViaResetLinkDocument, options);
      }
export type ChangePasswordViaResetLinkMutationHookResult = ReturnType<typeof useChangePasswordViaResetLinkMutation>;
export type ChangePasswordViaResetLinkMutationResult = Apollo.MutationResult<ChangePasswordViaResetLinkMutation>;
export type ChangePasswordViaResetLinkMutationOptions = Apollo.BaseMutationOptions<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>;
export const GenerateXsrfDocument = gql`
    mutation generateXsrf {
  generateXsrf {
    message
    statusCode
    xsrf
  }
}
    `;
export type GenerateXsrfMutationFn = Apollo.MutationFunction<GenerateXsrfMutation, GenerateXsrfMutationVariables>;

/**
 * __useGenerateXsrfMutation__
 *
 * To run a mutation, you first call `useGenerateXsrfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateXsrfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateXsrfMutation, { data, loading, error }] = useGenerateXsrfMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateXsrfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateXsrfMutation, GenerateXsrfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateXsrfMutation, GenerateXsrfMutationVariables>(GenerateXsrfDocument, options);
      }
export type GenerateXsrfMutationHookResult = ReturnType<typeof useGenerateXsrfMutation>;
export type GenerateXsrfMutationResult = Apollo.MutationResult<GenerateXsrfMutation>;
export type GenerateXsrfMutationOptions = Apollo.BaseMutationOptions<GenerateXsrfMutation, GenerateXsrfMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser($input: LogoutUserInput!) {
  logoutUser(input: $input) {
    message
    statusCode
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const RequestPasswordResetLinkDocument = gql`
    mutation requestPasswordResetLink($input: RequestPasswordResetLinkInput!) {
  requestPasswordResetLink(input: $input)
}
    `;
export type RequestPasswordResetLinkMutationFn = Apollo.MutationFunction<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>;

/**
 * __useRequestPasswordResetLinkMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetLinkMutation, { data, loading, error }] = useRequestPasswordResetLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>(RequestPasswordResetLinkDocument, options);
      }
export type RequestPasswordResetLinkMutationHookResult = ReturnType<typeof useRequestPasswordResetLinkMutation>;
export type RequestPasswordResetLinkMutationResult = Apollo.MutationResult<RequestPasswordResetLinkMutation>;
export type RequestPasswordResetLinkMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>;
export const RegisterUserDocument = gql`
    mutation registerUser($input: UserRegistrationInput!) {
  userRegistration(input: $input)
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const GetAutosWarrantyDocument = gql`
    query GetAutosWarranty($id: ID!) {
  autosWarranty(id: $id) {
    id
    offerExpiry
    coverageTermInMonths
    paymentTermInMonths
    asLowAsPerMonth
    downPayment
  }
}
    `;

/**
 * __useGetAutosWarrantyQuery__
 *
 * To run a query within a React component, call `useGetAutosWarrantyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutosWarrantyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutosWarrantyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAutosWarrantyQuery(baseOptions: Apollo.QueryHookOptions<GetAutosWarrantyQuery, GetAutosWarrantyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutosWarrantyQuery, GetAutosWarrantyQueryVariables>(GetAutosWarrantyDocument, options);
      }
export function useGetAutosWarrantyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutosWarrantyQuery, GetAutosWarrantyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutosWarrantyQuery, GetAutosWarrantyQueryVariables>(GetAutosWarrantyDocument, options);
        }
export type GetAutosWarrantyQueryHookResult = ReturnType<typeof useGetAutosWarrantyQuery>;
export type GetAutosWarrantyLazyQueryHookResult = ReturnType<typeof useGetAutosWarrantyLazyQuery>;
export type GetAutosWarrantyQueryResult = Apollo.QueryResult<GetAutosWarrantyQuery, GetAutosWarrantyQueryVariables>;
export const GetCampaignsForVipDocument = gql`
    query getCampaignsForVip($placement: String!, $locationId: Int!, $categoryId: Int!, $platform: String!) {
  campaigns(
    placement: $placement
    locationId: $locationId
    categoryId: $categoryId
    platform: $platform
  ) {
    id
    type
  }
}
    `;

/**
 * __useGetCampaignsForVipQuery__
 *
 * To run a query within a React component, call `useGetCampaignsForVipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsForVipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsForVipQuery({
 *   variables: {
 *      placement: // value for 'placement'
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetCampaignsForVipQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignsForVipQuery, GetCampaignsForVipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsForVipQuery, GetCampaignsForVipQueryVariables>(GetCampaignsForVipDocument, options);
      }
export function useGetCampaignsForVipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsForVipQuery, GetCampaignsForVipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsForVipQuery, GetCampaignsForVipQueryVariables>(GetCampaignsForVipDocument, options);
        }
export type GetCampaignsForVipQueryHookResult = ReturnType<typeof useGetCampaignsForVipQuery>;
export type GetCampaignsForVipLazyQueryHookResult = ReturnType<typeof useGetCampaignsForVipLazyQuery>;
export type GetCampaignsForVipQueryResult = Apollo.QueryResult<GetCampaignsForVipQuery, GetCampaignsForVipQueryVariables>;
export const PopularListingsDocument = gql`
    query PopularListings($locationId: Int!, $categoryId: Int!) {
  listingsPopular(locationId: $locationId, categoryId: $categoryId) {
    listings {
      id
      title
      url
      adSource
      categoryId
      imageUrls
      location {
        id
        name
        province
      }
      price {
        type
        ... on NonAmountPrice {
          type
        }
        ... on StandardAmountPrice {
          amount
          currency
          originalAmount
          type
        }
        ... on AutosDealerAmountPrice {
          amount
          classification {
            averagePrice
            rating
          }
          currency
          msrp
          originalAmount
          surcharges
          type
        }
        ... on AmountPrice {
          amount
          currency
          originalAmount
          type
        }
      }
    }
  }
}
    `;

/**
 * __usePopularListingsQuery__
 *
 * To run a query within a React component, call `usePopularListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularListingsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function usePopularListingsQuery(baseOptions: Apollo.QueryHookOptions<PopularListingsQuery, PopularListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularListingsQuery, PopularListingsQueryVariables>(PopularListingsDocument, options);
      }
export function usePopularListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularListingsQuery, PopularListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularListingsQuery, PopularListingsQueryVariables>(PopularListingsDocument, options);
        }
export type PopularListingsQueryHookResult = ReturnType<typeof usePopularListingsQuery>;
export type PopularListingsLazyQueryHookResult = ReturnType<typeof usePopularListingsLazyQuery>;
export type PopularListingsQueryResult = Apollo.QueryResult<PopularListingsQuery, PopularListingsQueryVariables>;
export const EventsExternalClickDocument = gql`
    mutation EventsExternalClick($eventsExternalClickId: ID!, $url: String!, $urlType: EventsUrlType!) {
  eventsExternalClick(id: $eventsExternalClickId, url: $url, urlType: $urlType)
}
    `;
export type EventsExternalClickMutationFn = Apollo.MutationFunction<EventsExternalClickMutation, EventsExternalClickMutationVariables>;

/**
 * __useEventsExternalClickMutation__
 *
 * To run a mutation, you first call `useEventsExternalClickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventsExternalClickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventsExternalClickMutation, { data, loading, error }] = useEventsExternalClickMutation({
 *   variables: {
 *      eventsExternalClickId: // value for 'eventsExternalClickId'
 *      url: // value for 'url'
 *      urlType: // value for 'urlType'
 *   },
 * });
 */
export function useEventsExternalClickMutation(baseOptions?: Apollo.MutationHookOptions<EventsExternalClickMutation, EventsExternalClickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventsExternalClickMutation, EventsExternalClickMutationVariables>(EventsExternalClickDocument, options);
      }
export type EventsExternalClickMutationHookResult = ReturnType<typeof useEventsExternalClickMutation>;
export type EventsExternalClickMutationResult = Apollo.MutationResult<EventsExternalClickMutation>;
export type EventsExternalClickMutationOptions = Apollo.BaseMutationOptions<EventsExternalClickMutation, EventsExternalClickMutationVariables>;
export const ListingRequestCarfaxDocument = gql`
    mutation ListingRequestCarfax($listingId: ID!, $email: String!) {
  listingRequestCarfax(listingId: $listingId, email: $email)
}
    `;
export type ListingRequestCarfaxMutationFn = Apollo.MutationFunction<ListingRequestCarfaxMutation, ListingRequestCarfaxMutationVariables>;

/**
 * __useListingRequestCarfaxMutation__
 *
 * To run a mutation, you first call `useListingRequestCarfaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingRequestCarfaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingRequestCarfaxMutation, { data, loading, error }] = useListingRequestCarfaxMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useListingRequestCarfaxMutation(baseOptions?: Apollo.MutationHookOptions<ListingRequestCarfaxMutation, ListingRequestCarfaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingRequestCarfaxMutation, ListingRequestCarfaxMutationVariables>(ListingRequestCarfaxDocument, options);
      }
export type ListingRequestCarfaxMutationHookResult = ReturnType<typeof useListingRequestCarfaxMutation>;
export type ListingRequestCarfaxMutationResult = Apollo.MutationResult<ListingRequestCarfaxMutation>;
export type ListingRequestCarfaxMutationOptions = Apollo.BaseMutationOptions<ListingRequestCarfaxMutation, ListingRequestCarfaxMutationVariables>;
export const GetListingsMostRecentDocument = gql`
    query GetListingsMostRecent($by: SearchResultsPageInputBy!, $pagination: PaginationInputV2!) {
  searchResultsPage(by: $by, pagination: $pagination) {
    results {
      mainListings(pagination: $pagination) {
        id
        categoryId
        title
        url
        imageUrls
        adSource
        location {
          id
          name
        }
        price {
          type
          ... on StandardAmountPrice {
            amount
          }
          ... on AutosDealerAmountPrice {
            amount
          }
          ... on AmountPrice {
            amount
          }
        }
      }
    }
    searchQuery {
      seoUrl
    }
  }
}
    `;

/**
 * __useGetListingsMostRecentQuery__
 *
 * To run a query within a React component, call `useGetListingsMostRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingsMostRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingsMostRecentQuery({
 *   variables: {
 *      by: // value for 'by'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetListingsMostRecentQuery(baseOptions: Apollo.QueryHookOptions<GetListingsMostRecentQuery, GetListingsMostRecentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingsMostRecentQuery, GetListingsMostRecentQueryVariables>(GetListingsMostRecentDocument, options);
      }
export function useGetListingsMostRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingsMostRecentQuery, GetListingsMostRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingsMostRecentQuery, GetListingsMostRecentQueryVariables>(GetListingsMostRecentDocument, options);
        }
export type GetListingsMostRecentQueryHookResult = ReturnType<typeof useGetListingsMostRecentQuery>;
export type GetListingsMostRecentLazyQueryHookResult = ReturnType<typeof useGetListingsMostRecentLazyQuery>;
export type GetListingsMostRecentQueryResult = Apollo.QueryResult<GetListingsMostRecentQuery, GetListingsMostRecentQueryVariables>;
export const GetMileageAnalysisDocument = gql`
    query GetMileageAnalysis($listingId: ID!) {
  listing(id: $listingId) {
    ... on AutosListing {
      mileageAnalysis {
        categories {
          high
          average
          low
        }
        usage
        value
      }
    }
  }
}
    `;

/**
 * __useGetMileageAnalysisQuery__
 *
 * To run a query within a React component, call `useGetMileageAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMileageAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMileageAnalysisQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetMileageAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetMileageAnalysisQuery, GetMileageAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMileageAnalysisQuery, GetMileageAnalysisQueryVariables>(GetMileageAnalysisDocument, options);
      }
export function useGetMileageAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMileageAnalysisQuery, GetMileageAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMileageAnalysisQuery, GetMileageAnalysisQueryVariables>(GetMileageAnalysisDocument, options);
        }
export type GetMileageAnalysisQueryHookResult = ReturnType<typeof useGetMileageAnalysisQuery>;
export type GetMileageAnalysisLazyQueryHookResult = ReturnType<typeof useGetMileageAnalysisLazyQuery>;
export type GetMileageAnalysisQueryResult = Apollo.QueryResult<GetMileageAnalysisQuery, GetMileageAnalysisQueryVariables>;
export const ContactSellerDocument = gql`
    mutation ContactSeller($listingContactId: ID!, $message: String, $name: String, $email: EmailAddress) {
  listingContact(
    id: $listingContactId
    message: $message
    name: $name
    email: $email
  )
}
    `;
export type ContactSellerMutationFn = Apollo.MutationFunction<ContactSellerMutation, ContactSellerMutationVariables>;

/**
 * __useContactSellerMutation__
 *
 * To run a mutation, you first call `useContactSellerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSellerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSellerMutation, { data, loading, error }] = useContactSellerMutation({
 *   variables: {
 *      listingContactId: // value for 'listingContactId'
 *      message: // value for 'message'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useContactSellerMutation(baseOptions?: Apollo.MutationHookOptions<ContactSellerMutation, ContactSellerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSellerMutation, ContactSellerMutationVariables>(ContactSellerDocument, options);
      }
export type ContactSellerMutationHookResult = ReturnType<typeof useContactSellerMutation>;
export type ContactSellerMutationResult = Apollo.MutationResult<ContactSellerMutation>;
export type ContactSellerMutationOptions = Apollo.BaseMutationOptions<ContactSellerMutation, ContactSellerMutationVariables>;
export const ContactSellerWithAttachmentDocument = gql`
    mutation ContactSellerWithAttachment($listingContactWithAttachmentId: ID!, $message: String!, $attachment: Upload) {
  listingContactWithAttachment(
    id: $listingContactWithAttachmentId
    message: $message
    attachment: $attachment
  )
}
    `;
export type ContactSellerWithAttachmentMutationFn = Apollo.MutationFunction<ContactSellerWithAttachmentMutation, ContactSellerWithAttachmentMutationVariables>;

/**
 * __useContactSellerWithAttachmentMutation__
 *
 * To run a mutation, you first call `useContactSellerWithAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactSellerWithAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactSellerWithAttachmentMutation, { data, loading, error }] = useContactSellerWithAttachmentMutation({
 *   variables: {
 *      listingContactWithAttachmentId: // value for 'listingContactWithAttachmentId'
 *      message: // value for 'message'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useContactSellerWithAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ContactSellerWithAttachmentMutation, ContactSellerWithAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactSellerWithAttachmentMutation, ContactSellerWithAttachmentMutationVariables>(ContactSellerWithAttachmentDocument, options);
      }
export type ContactSellerWithAttachmentMutationHookResult = ReturnType<typeof useContactSellerWithAttachmentMutation>;
export type ContactSellerWithAttachmentMutationResult = Apollo.MutationResult<ContactSellerWithAttachmentMutation>;
export type ContactSellerWithAttachmentMutationOptions = Apollo.BaseMutationOptions<ContactSellerWithAttachmentMutation, ContactSellerWithAttachmentMutationVariables>;
export const GetConversationIdByListingIdDocument = gql`
    query GetConversationIdByListingId($adId: Int!) {
  conversationIdByAdId(adId: $adId) {
    id
  }
}
    `;

/**
 * __useGetConversationIdByListingIdQuery__
 *
 * To run a query within a React component, call `useGetConversationIdByListingIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationIdByListingIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationIdByListingIdQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useGetConversationIdByListingIdQuery(baseOptions: Apollo.QueryHookOptions<GetConversationIdByListingIdQuery, GetConversationIdByListingIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationIdByListingIdQuery, GetConversationIdByListingIdQueryVariables>(GetConversationIdByListingIdDocument, options);
      }
export function useGetConversationIdByListingIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationIdByListingIdQuery, GetConversationIdByListingIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationIdByListingIdQuery, GetConversationIdByListingIdQueryVariables>(GetConversationIdByListingIdDocument, options);
        }
export type GetConversationIdByListingIdQueryHookResult = ReturnType<typeof useGetConversationIdByListingIdQuery>;
export type GetConversationIdByListingIdLazyQueryHookResult = ReturnType<typeof useGetConversationIdByListingIdLazyQuery>;
export type GetConversationIdByListingIdQueryResult = Apollo.QueryResult<GetConversationIdByListingIdQuery, GetConversationIdByListingIdQueryVariables>;
export const GetInitialStructuredMessageDocument = gql`
    query GetInitialStructuredMessage($categoryId: Int!, $locale: String, $price: Int) {
  initialStructuredMessage(
    categoryId: $categoryId
    locale: $locale
    price: $price
  ) {
    id
    message
  }
}
    `;

/**
 * __useGetInitialStructuredMessageQuery__
 *
 * To run a query within a React component, call `useGetInitialStructuredMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialStructuredMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialStructuredMessageQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useGetInitialStructuredMessageQuery(baseOptions: Apollo.QueryHookOptions<GetInitialStructuredMessageQuery, GetInitialStructuredMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialStructuredMessageQuery, GetInitialStructuredMessageQueryVariables>(GetInitialStructuredMessageDocument, options);
      }
export function useGetInitialStructuredMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialStructuredMessageQuery, GetInitialStructuredMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialStructuredMessageQuery, GetInitialStructuredMessageQueryVariables>(GetInitialStructuredMessageDocument, options);
        }
export type GetInitialStructuredMessageQueryHookResult = ReturnType<typeof useGetInitialStructuredMessageQuery>;
export type GetInitialStructuredMessageLazyQueryHookResult = ReturnType<typeof useGetInitialStructuredMessageLazyQuery>;
export type GetInitialStructuredMessageQueryResult = Apollo.QueryResult<GetInitialStructuredMessageQuery, GetInitialStructuredMessageQueryVariables>;
export const GetR2SStateDocument = gql`
    query GetR2SState {
  r2sModalState @client {
    isOpen
    placement
  }
}
    `;

/**
 * __useGetR2SStateQuery__
 *
 * To run a query within a React component, call `useGetR2SStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetR2SStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetR2SStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetR2SStateQuery(baseOptions?: Apollo.QueryHookOptions<GetR2SStateQuery, GetR2SStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetR2SStateQuery, GetR2SStateQueryVariables>(GetR2SStateDocument, options);
      }
export function useGetR2SStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetR2SStateQuery, GetR2SStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetR2SStateQuery, GetR2SStateQueryVariables>(GetR2SStateDocument, options);
        }
export type GetR2SStateQueryHookResult = ReturnType<typeof useGetR2SStateQuery>;
export type GetR2SStateLazyQueryHookResult = ReturnType<typeof useGetR2SStateLazyQuery>;
export type GetR2SStateQueryResult = Apollo.QueryResult<GetR2SStateQuery, GetR2SStateQueryVariables>;
export const ListingReportDocument = gql`
    mutation ListingReport($listingReportId: ID!, $reason: Reason!, $email: String, $comment: String) {
  listingReport(
    id: $listingReportId
    reason: $reason
    email: $email
    comment: $comment
  )
}
    `;
export type ListingReportMutationFn = Apollo.MutationFunction<ListingReportMutation, ListingReportMutationVariables>;

/**
 * __useListingReportMutation__
 *
 * To run a mutation, you first call `useListingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingReportMutation, { data, loading, error }] = useListingReportMutation({
 *   variables: {
 *      listingReportId: // value for 'listingReportId'
 *      reason: // value for 'reason'
 *      email: // value for 'email'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useListingReportMutation(baseOptions?: Apollo.MutationHookOptions<ListingReportMutation, ListingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingReportMutation, ListingReportMutationVariables>(ListingReportDocument, options);
      }
export type ListingReportMutationHookResult = ReturnType<typeof useListingReportMutation>;
export type ListingReportMutationResult = Apollo.MutationResult<ListingReportMutation>;
export type ListingReportMutationOptions = Apollo.BaseMutationOptions<ListingReportMutation, ListingReportMutationVariables>;
export const RequestViewingDocument = gql`
    mutation RequestViewing($listingRequestViewingId: ID!, $message: String!, $name: String!, $requestViewingDates: [Date!]) {
  listingRequestViewing(
    id: $listingRequestViewingId
    message: $message
    name: $name
    requestViewingDates: $requestViewingDates
  )
}
    `;
export type RequestViewingMutationFn = Apollo.MutationFunction<RequestViewingMutation, RequestViewingMutationVariables>;

/**
 * __useRequestViewingMutation__
 *
 * To run a mutation, you first call `useRequestViewingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestViewingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestViewingMutation, { data, loading, error }] = useRequestViewingMutation({
 *   variables: {
 *      listingRequestViewingId: // value for 'listingRequestViewingId'
 *      message: // value for 'message'
 *      name: // value for 'name'
 *      requestViewingDates: // value for 'requestViewingDates'
 *   },
 * });
 */
export function useRequestViewingMutation(baseOptions?: Apollo.MutationHookOptions<RequestViewingMutation, RequestViewingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestViewingMutation, RequestViewingMutationVariables>(RequestViewingDocument, options);
      }
export type RequestViewingMutationHookResult = ReturnType<typeof useRequestViewingMutation>;
export type RequestViewingMutationResult = Apollo.MutationResult<RequestViewingMutation>;
export type RequestViewingMutationOptions = Apollo.BaseMutationOptions<RequestViewingMutation, RequestViewingMutationVariables>;
export const GetListingsSimilarDocument = gql`
    query GetListingsSimilar($listingId: ID!, $limit: Int, $isExternalId: Boolean) {
  listingsSimilar(
    listingId: $listingId
    limit: $limit
    isExternalId: $isExternalId
  ) {
    adSource
    categoryId
    id
    imageUrls
    title
    url
    location {
      id
      name
    }
    price {
      type
      ... on StandardAmountPrice {
        amount
      }
      ... on AutosDealerAmountPrice {
        amount
      }
    }
  }
}
    `;

/**
 * __useGetListingsSimilarQuery__
 *
 * To run a query within a React component, call `useGetListingsSimilarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingsSimilarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingsSimilarQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      limit: // value for 'limit'
 *      isExternalId: // value for 'isExternalId'
 *   },
 * });
 */
export function useGetListingsSimilarQuery(baseOptions: Apollo.QueryHookOptions<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>(GetListingsSimilarDocument, options);
      }
export function useGetListingsSimilarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>(GetListingsSimilarDocument, options);
        }
export type GetListingsSimilarQueryHookResult = ReturnType<typeof useGetListingsSimilarQuery>;
export type GetListingsSimilarLazyQueryHookResult = ReturnType<typeof useGetListingsSimilarLazyQuery>;
export type GetListingsSimilarQueryResult = Apollo.QueryResult<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>;
export const LivePersonGetIDsDocument = gql`
    query LivePersonGetIDs($conversationId: ID!) {
  livePersonGetIDs(conversationId: $conversationId) {
    botId
    userId
  }
}
    `;

/**
 * __useLivePersonGetIDsQuery__
 *
 * To run a query within a React component, call `useLivePersonGetIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivePersonGetIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePersonGetIDsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useLivePersonGetIDsQuery(baseOptions: Apollo.QueryHookOptions<LivePersonGetIDsQuery, LivePersonGetIDsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LivePersonGetIDsQuery, LivePersonGetIDsQueryVariables>(LivePersonGetIDsDocument, options);
      }
export function useLivePersonGetIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LivePersonGetIDsQuery, LivePersonGetIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LivePersonGetIDsQuery, LivePersonGetIDsQueryVariables>(LivePersonGetIDsDocument, options);
        }
export type LivePersonGetIDsQueryHookResult = ReturnType<typeof useLivePersonGetIDsQuery>;
export type LivePersonGetIDsLazyQueryHookResult = ReturnType<typeof useLivePersonGetIDsLazyQuery>;
export type LivePersonGetIDsQueryResult = Apollo.QueryResult<LivePersonGetIDsQuery, LivePersonGetIDsQueryVariables>;
export const LivePersonSendVipDataDocument = gql`
    mutation LivePersonSendVipData($input: LivePersonVipData!) {
  livePersonSendVipData(input: $input)
}
    `;
export type LivePersonSendVipDataMutationFn = Apollo.MutationFunction<LivePersonSendVipDataMutation, LivePersonSendVipDataMutationVariables>;

/**
 * __useLivePersonSendVipDataMutation__
 *
 * To run a mutation, you first call `useLivePersonSendVipDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLivePersonSendVipDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [livePersonSendVipDataMutation, { data, loading, error }] = useLivePersonSendVipDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLivePersonSendVipDataMutation(baseOptions?: Apollo.MutationHookOptions<LivePersonSendVipDataMutation, LivePersonSendVipDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LivePersonSendVipDataMutation, LivePersonSendVipDataMutationVariables>(LivePersonSendVipDataDocument, options);
      }
export type LivePersonSendVipDataMutationHookResult = ReturnType<typeof useLivePersonSendVipDataMutation>;
export type LivePersonSendVipDataMutationResult = Apollo.MutationResult<LivePersonSendVipDataMutation>;
export type LivePersonSendVipDataMutationOptions = Apollo.BaseMutationOptions<LivePersonSendVipDataMutation, LivePersonSendVipDataMutationVariables>;
export const GetMapProviderDocument = gql`
    query GetMapProvider {
  mapProvider @client {
    isLoading
    error
    apiKey
  }
}
    `;

/**
 * __useGetMapProviderQuery__
 *
 * To run a query within a React component, call `useGetMapProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMapProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetMapProviderQuery, GetMapProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapProviderQuery, GetMapProviderQueryVariables>(GetMapProviderDocument, options);
      }
export function useGetMapProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapProviderQuery, GetMapProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapProviderQuery, GetMapProviderQueryVariables>(GetMapProviderDocument, options);
        }
export type GetMapProviderQueryHookResult = ReturnType<typeof useGetMapProviderQuery>;
export type GetMapProviderLazyQueryHookResult = ReturnType<typeof useGetMapProviderLazyQuery>;
export type GetMapProviderQueryResult = Apollo.QueryResult<GetMapProviderQuery, GetMapProviderQueryVariables>;
export const GetModalStateDocument = gql`
    query GetModalState($id: String!) {
  modal(id: $id) @client {
    id
    isOpen
  }
}
    `;

/**
 * __useGetModalStateQuery__
 *
 * To run a query within a React component, call `useGetModalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModalStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModalStateQuery(baseOptions: Apollo.QueryHookOptions<GetModalStateQuery, GetModalStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModalStateQuery, GetModalStateQueryVariables>(GetModalStateDocument, options);
      }
export function useGetModalStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModalStateQuery, GetModalStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModalStateQuery, GetModalStateQueryVariables>(GetModalStateDocument, options);
        }
export type GetModalStateQueryHookResult = ReturnType<typeof useGetModalStateQuery>;
export type GetModalStateLazyQueryHookResult = ReturnType<typeof useGetModalStateLazyQuery>;
export type GetModalStateQueryResult = Apollo.QueryResult<GetModalStateQuery, GetModalStateQueryVariables>;
export const GetMenuPrefetchDocument = gql`
    query GetMenuPrefetch($locationId: Int!, $categoryId: Int, $locale: String, $depth: Int, $hints: [Hints]) {
  menuPrefetch(
    locationId: $locationId
    categoryId: $categoryId
    locale: $locale
    depth: $depth
    hints: $hints
  ) {
    id
    categoryName
    isLeaf
    seoUrl
    children {
      categoryName
      seoUrl
      isLeaf
      id
      children {
        categoryName
        id
        isLeaf
        seoUrl
      }
    }
  }
}
    `;

/**
 * __useGetMenuPrefetchQuery__
 *
 * To run a query within a React component, call `useGetMenuPrefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuPrefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuPrefetchQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      depth: // value for 'depth'
 *      hints: // value for 'hints'
 *   },
 * });
 */
export function useGetMenuPrefetchQuery(baseOptions: Apollo.QueryHookOptions<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>(GetMenuPrefetchDocument, options);
      }
export function useGetMenuPrefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>(GetMenuPrefetchDocument, options);
        }
export type GetMenuPrefetchQueryHookResult = ReturnType<typeof useGetMenuPrefetchQuery>;
export type GetMenuPrefetchLazyQueryHookResult = ReturnType<typeof useGetMenuPrefetchLazyQuery>;
export type GetMenuPrefetchQueryResult = Apollo.QueryResult<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>;
export const GetGoogleReviewsDocument = gql`
    query GetGoogleReviews($dealerId: ID!) {
  reviewsFromGoogle(dealerId: $dealerId) {
    rating
    reviews {
      author {
        name
        profileUrl
        profilePhotoUrl
      }
      rating
      text
      time
    }
    totalCount
    url
  }
}
    `;

/**
 * __useGetGoogleReviewsQuery__
 *
 * To run a query within a React component, call `useGetGoogleReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleReviewsQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetGoogleReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetGoogleReviewsQuery, GetGoogleReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleReviewsQuery, GetGoogleReviewsQueryVariables>(GetGoogleReviewsDocument, options);
      }
export function useGetGoogleReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleReviewsQuery, GetGoogleReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleReviewsQuery, GetGoogleReviewsQueryVariables>(GetGoogleReviewsDocument, options);
        }
export type GetGoogleReviewsQueryHookResult = ReturnType<typeof useGetGoogleReviewsQuery>;
export type GetGoogleReviewsLazyQueryHookResult = ReturnType<typeof useGetGoogleReviewsLazyQuery>;
export type GetGoogleReviewsQueryResult = Apollo.QueryResult<GetGoogleReviewsQuery, GetGoogleReviewsQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile($profileId: ID!, $size: LogoType!) {
  profile(id: $profileId) {
    id
    name
    numberOfListings
    userType
    profilePath
    preferences {
      hideVisit
    }
    ... on StandardProfileV2 {
      imageUrl
      isSalesforceEnabled
    }
    ... on CommercialProfileV2 {
      logoUrl(size: $size)
      staticMapUrl
      websiteUrl
    }
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetProfilePhoneNumberDocument = gql`
    query getProfilePhoneNumber($profileId: ID!, $listingId: ID, $recaptchaToken: String, $source: PhoneNumberSource) {
  profile(id: $profileId) {
    id
    ... on StandardProfileV2 {
      phoneNumber(listingId: $listingId, recaptchaToken: $recaptchaToken)
    }
    ... on CommercialProfileV2 {
      phoneNumber(
        listingId: $listingId
        recaptchaToken: $recaptchaToken
        source: $source
      )
    }
  }
}
    `;

/**
 * __useGetProfilePhoneNumberQuery__
 *
 * To run a query within a React component, call `useGetProfilePhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePhoneNumberQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      listingId: // value for 'listingId'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGetProfilePhoneNumberQuery(baseOptions: Apollo.QueryHookOptions<GetProfilePhoneNumberQuery, GetProfilePhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePhoneNumberQuery, GetProfilePhoneNumberQueryVariables>(GetProfilePhoneNumberDocument, options);
      }
export function useGetProfilePhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePhoneNumberQuery, GetProfilePhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePhoneNumberQuery, GetProfilePhoneNumberQueryVariables>(GetProfilePhoneNumberDocument, options);
        }
export type GetProfilePhoneNumberQueryHookResult = ReturnType<typeof useGetProfilePhoneNumberQuery>;
export type GetProfilePhoneNumberLazyQueryHookResult = ReturnType<typeof useGetProfilePhoneNumberLazyQuery>;
export type GetProfilePhoneNumberQueryResult = Apollo.QueryResult<GetProfilePhoneNumberQuery, GetProfilePhoneNumberQueryVariables>;
export const GetReviewSummaryDocument = gql`
    query GetReviewSummary($userId: Int!) {
  reviewSummary(userId: $userId) {
    sumScore
    totalReviews
  }
}
    `;

/**
 * __useGetReviewSummaryQuery__
 *
 * To run a query within a React component, call `useGetReviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReviewSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>(GetReviewSummaryDocument, options);
      }
export function useGetReviewSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>(GetReviewSummaryDocument, options);
        }
export type GetReviewSummaryQueryHookResult = ReturnType<typeof useGetReviewSummaryQuery>;
export type GetReviewSummaryLazyQueryHookResult = ReturnType<typeof useGetReviewSummaryLazyQuery>;
export type GetReviewSummaryQueryResult = Apollo.QueryResult<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>;
export const AutocompleteSuggestionsDocument = gql`
    query AutocompleteSuggestions($input: AutocompleteSuggestionsInput!) {
  autocompleteSuggestions(input: $input) {
    completion
    categories {
      id
      localizedName
    }
  }
}
    `;

/**
 * __useAutocompleteSuggestionsQuery__
 *
 * To run a query within a React component, call `useAutocompleteSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutocompleteSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteSuggestionsQuery, AutocompleteSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteSuggestionsQuery, AutocompleteSuggestionsQueryVariables>(AutocompleteSuggestionsDocument, options);
      }
export function useAutocompleteSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteSuggestionsQuery, AutocompleteSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteSuggestionsQuery, AutocompleteSuggestionsQueryVariables>(AutocompleteSuggestionsDocument, options);
        }
export type AutocompleteSuggestionsQueryHookResult = ReturnType<typeof useAutocompleteSuggestionsQuery>;
export type AutocompleteSuggestionsLazyQueryHookResult = ReturnType<typeof useAutocompleteSuggestionsLazyQuery>;
export type AutocompleteSuggestionsQueryResult = Apollo.QueryResult<AutocompleteSuggestionsQuery, AutocompleteSuggestionsQueryVariables>;
export const GetSearchPageStateDocument = gql`
    query GetSearchPageState {
  searchState @client {
    pageViewType
    currentPage
  }
}
    `;

/**
 * __useGetSearchPageStateQuery__
 *
 * To run a query within a React component, call `useGetSearchPageStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchPageStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchPageStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchPageStateQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchPageStateQuery, GetSearchPageStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchPageStateQuery, GetSearchPageStateQueryVariables>(GetSearchPageStateDocument, options);
      }
export function useGetSearchPageStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchPageStateQuery, GetSearchPageStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchPageStateQuery, GetSearchPageStateQueryVariables>(GetSearchPageStateDocument, options);
        }
export type GetSearchPageStateQueryHookResult = ReturnType<typeof useGetSearchPageStateQuery>;
export type GetSearchPageStateLazyQueryHookResult = ReturnType<typeof useGetSearchPageStateLazyQuery>;
export type GetSearchPageStateQueryResult = Apollo.QueryResult<GetSearchPageStateQuery, GetSearchPageStateQueryVariables>;
export const GetSearchUrlDocument = gql`
    query GetSearchUrl($input: SearchUrlInput!) {
  searchUrl(input: $input)
}
    `;

/**
 * __useGetSearchUrlQuery__
 *
 * To run a query within a React component, call `useGetSearchUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSearchUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSearchUrlQuery, GetSearchUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchUrlQuery, GetSearchUrlQueryVariables>(GetSearchUrlDocument, options);
      }
export function useGetSearchUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchUrlQuery, GetSearchUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchUrlQuery, GetSearchUrlQueryVariables>(GetSearchUrlDocument, options);
        }
export type GetSearchUrlQueryHookResult = ReturnType<typeof useGetSearchUrlQuery>;
export type GetSearchUrlLazyQueryHookResult = ReturnType<typeof useGetSearchUrlLazyQuery>;
export type GetSearchUrlQueryResult = Apollo.QueryResult<GetSearchUrlQuery, GetSearchUrlQueryVariables>;
export const GetProfileMetricsDocument = gql`
    query GetProfileMetrics($profileId: ID!) {
  profile(id: $profileId) {
    id
    memberSince
    ... on StandardProfileV2 {
      replyRate
      responsiveness
    }
  }
}
    `;

/**
 * __useGetProfileMetricsQuery__
 *
 * To run a query within a React component, call `useGetProfileMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMetricsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetProfileMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>(GetProfileMetricsDocument, options);
      }
export function useGetProfileMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>(GetProfileMetricsDocument, options);
        }
export type GetProfileMetricsQueryHookResult = ReturnType<typeof useGetProfileMetricsQuery>;
export type GetProfileMetricsLazyQueryHookResult = ReturnType<typeof useGetProfileMetricsLazyQuery>;
export type GetProfileMetricsQueryResult = Apollo.QueryResult<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>;
export const MyAccountDocument = gql`
    query myAccount {
  myAccount {
    ...PersonalInformationFields
  }
}
    ${PersonalInformationFieldsFragmentDoc}`;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const GetAlgoliaKeyDocument = gql`
    mutation GetAlgoliaKey {
  getAlgoliaKey
}
    `;
export type GetAlgoliaKeyMutationFn = Apollo.MutationFunction<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>;

/**
 * __useGetAlgoliaKeyMutation__
 *
 * To run a mutation, you first call `useGetAlgoliaKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAlgoliaKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAlgoliaKeyMutation, { data, loading, error }] = useGetAlgoliaKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetAlgoliaKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>(GetAlgoliaKeyDocument, options);
      }
export type GetAlgoliaKeyMutationHookResult = ReturnType<typeof useGetAlgoliaKeyMutation>;
export type GetAlgoliaKeyMutationResult = Apollo.MutationResult<GetAlgoliaKeyMutation>;
export type GetAlgoliaKeyMutationOptions = Apollo.BaseMutationOptions<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>;
export const GetCampaignsDocument = gql`
    query getCampaigns($placement: String!, $customType: String!, $locationId: Int!, $categoryId: Int!, $platform: String!, $filterAmount: Int) {
  campaigns(
    placement: $placement
    customType: $customType
    locationId: $locationId
    categoryId: $categoryId
    platform: $platform
    filterAmount: $filterAmount
  ) {
    customFields
    id
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      placement: // value for 'placement'
 *      customType: // value for 'customType'
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *      platform: // value for 'platform'
 *      filterAmount: // value for 'filterAmount'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCategoryPathDocument = gql`
    query GetCategoryPath($categoryId: Int!, $locale: String, $locationId: Int) {
  category(id: $categoryId) {
    id
    localizedName(locale: $locale)
    parentId
    searchSeoUrl(locationId: $locationId)
    categoryPaths {
      id
      localizedName(locale: $locale)
      parentId
      searchSeoUrl(locationId: $locationId)
    }
  }
}
    `;

/**
 * __useGetCategoryPathQuery__
 *
 * To run a query within a React component, call `useGetCategoryPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryPathQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetCategoryPathQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryPathQuery, GetCategoryPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryPathQuery, GetCategoryPathQueryVariables>(GetCategoryPathDocument, options);
      }
export function useGetCategoryPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryPathQuery, GetCategoryPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryPathQuery, GetCategoryPathQueryVariables>(GetCategoryPathDocument, options);
        }
export type GetCategoryPathQueryHookResult = ReturnType<typeof useGetCategoryPathQuery>;
export type GetCategoryPathLazyQueryHookResult = ReturnType<typeof useGetCategoryPathLazyQuery>;
export type GetCategoryPathQueryResult = Apollo.QueryResult<GetCategoryPathQuery, GetCategoryPathQueryVariables>;
export const GetAppDownloadBannerStateDocument = gql`
    query GetAppDownloadBannerState {
  appDownloadBanner @client {
    isVisible
  }
}
    `;

/**
 * __useGetAppDownloadBannerStateQuery__
 *
 * To run a query within a React component, call `useGetAppDownloadBannerStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppDownloadBannerStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppDownloadBannerStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppDownloadBannerStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAppDownloadBannerStateQuery, GetAppDownloadBannerStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppDownloadBannerStateQuery, GetAppDownloadBannerStateQueryVariables>(GetAppDownloadBannerStateDocument, options);
      }
export function useGetAppDownloadBannerStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppDownloadBannerStateQuery, GetAppDownloadBannerStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppDownloadBannerStateQuery, GetAppDownloadBannerStateQueryVariables>(GetAppDownloadBannerStateDocument, options);
        }
export type GetAppDownloadBannerStateQueryHookResult = ReturnType<typeof useGetAppDownloadBannerStateQuery>;
export type GetAppDownloadBannerStateLazyQueryHookResult = ReturnType<typeof useGetAppDownloadBannerStateLazyQuery>;
export type GetAppDownloadBannerStateQueryResult = Apollo.QueryResult<GetAppDownloadBannerStateQuery, GetAppDownloadBannerStateQueryVariables>;
export const GetHomeFeedAdsDocument = gql`
    query GetHomeFeedAds {
  homeFeedAds @client {
    adSlots
  }
}
    `;

/**
 * __useGetHomeFeedAdsQuery__
 *
 * To run a query within a React component, call `useGetHomeFeedAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeFeedAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeFeedAdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeFeedAdsQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>(GetHomeFeedAdsDocument, options);
      }
export function useGetHomeFeedAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>(GetHomeFeedAdsDocument, options);
        }
export type GetHomeFeedAdsQueryHookResult = ReturnType<typeof useGetHomeFeedAdsQuery>;
export type GetHomeFeedAdsLazyQueryHookResult = ReturnType<typeof useGetHomeFeedAdsLazyQuery>;
export type GetHomeFeedAdsQueryResult = Apollo.QueryResult<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>;
export const GetPsaDismissedDocument = gql`
    query GetPSADismissed {
  dismissedStates @client {
    appDownloadPSA
    siteMaintenancePSA_may27th
  }
}
    `;

/**
 * __useGetPsaDismissedQuery__
 *
 * To run a query within a React component, call `useGetPsaDismissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPsaDismissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPsaDismissedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPsaDismissedQuery(baseOptions?: Apollo.QueryHookOptions<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>(GetPsaDismissedDocument, options);
      }
export function useGetPsaDismissedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>(GetPsaDismissedDocument, options);
        }
export type GetPsaDismissedQueryHookResult = ReturnType<typeof useGetPsaDismissedQuery>;
export type GetPsaDismissedLazyQueryHookResult = ReturnType<typeof useGetPsaDismissedLazyQuery>;
export type GetPsaDismissedQueryResult = Apollo.QueryResult<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>;
export const GetSearchCategoryDocument = gql`
    query GetSearchCategory {
  srp @client {
    searchCategory {
      id
      isDomCat
      localizedName
      name {
        en_CA
        fr_CA
      }
      parentId
      path {
        id
        localizedName
        parentId
        seoUrl
      }
      seoUrl
    }
  }
}
    `;

/**
 * __useGetSearchCategoryQuery__
 *
 * To run a query within a React component, call `useGetSearchCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>(GetSearchCategoryDocument, options);
      }
export function useGetSearchCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>(GetSearchCategoryDocument, options);
        }
export type GetSearchCategoryQueryHookResult = ReturnType<typeof useGetSearchCategoryQuery>;
export type GetSearchCategoryLazyQueryHookResult = ReturnType<typeof useGetSearchCategoryLazyQuery>;
export type GetSearchCategoryQueryResult = Apollo.QueryResult<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>;
export const GetSearchKeywordDocument = gql`
    query GetSearchKeyword {
  srp @client {
    searchKeyword
  }
}
    `;

/**
 * __useGetSearchKeywordQuery__
 *
 * To run a query within a React component, call `useGetSearchKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchKeywordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchKeywordQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>(GetSearchKeywordDocument, options);
      }
export function useGetSearchKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>(GetSearchKeywordDocument, options);
        }
export type GetSearchKeywordQueryHookResult = ReturnType<typeof useGetSearchKeywordQuery>;
export type GetSearchKeywordLazyQueryHookResult = ReturnType<typeof useGetSearchKeywordLazyQuery>;
export type GetSearchKeywordQueryResult = Apollo.QueryResult<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>;
export const GetUserAgentDocument = gql`
    query GetUserAgent {
  userAgent @client {
    userAgent
  }
}
    `;

/**
 * __useGetUserAgentQuery__
 *
 * To run a query within a React component, call `useGetUserAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAgentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAgentQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAgentQuery, GetUserAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAgentQuery, GetUserAgentQueryVariables>(GetUserAgentDocument, options);
      }
export function useGetUserAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAgentQuery, GetUserAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAgentQuery, GetUserAgentQueryVariables>(GetUserAgentDocument, options);
        }
export type GetUserAgentQueryHookResult = ReturnType<typeof useGetUserAgentQuery>;
export type GetUserAgentLazyQueryHookResult = ReturnType<typeof useGetUserAgentLazyQuery>;
export type GetUserAgentQueryResult = Apollo.QueryResult<GetUserAgentQuery, GetUserAgentQueryVariables>;
export const GetUserAuthStateDocument = gql`
    query GetUserAuthState {
  userAuthState @client {
    isMiddlewareAuthenticated
  }
}
    `;

/**
 * __useGetUserAuthStateQuery__
 *
 * To run a query within a React component, call `useGetUserAuthStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuthStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAuthStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAuthStateQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>(GetUserAuthStateDocument, options);
      }
export function useGetUserAuthStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>(GetUserAuthStateDocument, options);
        }
export type GetUserAuthStateQueryHookResult = ReturnType<typeof useGetUserAuthStateQuery>;
export type GetUserAuthStateLazyQueryHookResult = ReturnType<typeof useGetUserAuthStateLazyQuery>;
export type GetUserAuthStateQueryResult = Apollo.QueryResult<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>;
export const GetUserLocaleDocument = gql`
    query GetUserLocale {
  userLocale @client {
    apiLocale
    cookieLocale
    languageKey
    routeLocale
  }
}
    `;

/**
 * __useGetUserLocaleQuery__
 *
 * To run a query within a React component, call `useGetUserLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocaleQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLocaleQuery, GetUserLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLocaleQuery, GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
      }
export function useGetUserLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLocaleQuery, GetUserLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLocaleQuery, GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
        }
export type GetUserLocaleQueryHookResult = ReturnType<typeof useGetUserLocaleQuery>;
export type GetUserLocaleLazyQueryHookResult = ReturnType<typeof useGetUserLocaleLazyQuery>;
export type GetUserLocaleQueryResult = Apollo.QueryResult<GetUserLocaleQuery, GetUserLocaleQueryVariables>;
export const GetUserLocationDocument = gql`
    query GetUserLocation {
  userLocation @client {
    id
    isRegion
    name {
      en_CA
      fr_CA
    }
    area {
      latitude
      longitude
      radius
      address
    }
  }
}
    `;

/**
 * __useGetUserLocationQuery__
 *
 * To run a query within a React component, call `useGetUserLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLocationQuery, GetUserLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLocationQuery, GetUserLocationQueryVariables>(GetUserLocationDocument, options);
      }
export function useGetUserLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLocationQuery, GetUserLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLocationQuery, GetUserLocationQueryVariables>(GetUserLocationDocument, options);
        }
export type GetUserLocationQueryHookResult = ReturnType<typeof useGetUserLocationQuery>;
export type GetUserLocationLazyQueryHookResult = ReturnType<typeof useGetUserLocationLazyQuery>;
export type GetUserLocationQueryResult = Apollo.QueryResult<GetUserLocationQuery, GetUserLocationQueryVariables>;
export const GetContentModuleDocument = gql`
    query GetContentModule($locationId: Int!, $moduleId: ContentModuleID!) {
  contentModule(locationId: $locationId, moduleId: $moduleId) {
    ... on BrowseHeroModule {
      component
      title {
        text
        style {
          color
          isBold
        }
      }
      partner {
        title
        brand {
          logoUrl
          link
        }
      }
      tiles {
        title
        link {
          url
          isNewTab
        }
        tracking {
          action
          label
        }
        background {
          imageUrl
          altText
        }
        type
      }
    }
  }
}
    `;

/**
 * __useGetContentModuleQuery__
 *
 * To run a query within a React component, call `useGetContentModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentModuleQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetContentModuleQuery(baseOptions: Apollo.QueryHookOptions<GetContentModuleQuery, GetContentModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentModuleQuery, GetContentModuleQueryVariables>(GetContentModuleDocument, options);
      }
export function useGetContentModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentModuleQuery, GetContentModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentModuleQuery, GetContentModuleQueryVariables>(GetContentModuleDocument, options);
        }
export type GetContentModuleQueryHookResult = ReturnType<typeof useGetContentModuleQuery>;
export type GetContentModuleLazyQueryHookResult = ReturnType<typeof useGetContentModuleLazyQuery>;
export type GetContentModuleQueryResult = Apollo.QueryResult<GetContentModuleQuery, GetContentModuleQueryVariables>;
export const FavouriteSearchActivateDocument = gql`
    mutation FavouriteSearchActivate($input: FavouriteSearchActivateInput!) {
  favouriteSearchActivate(input: $input)
}
    `;
export type FavouriteSearchActivateMutationFn = Apollo.MutationFunction<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>;

/**
 * __useFavouriteSearchActivateMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchActivateMutation, { data, loading, error }] = useFavouriteSearchActivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavouriteSearchActivateMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>(FavouriteSearchActivateDocument, options);
      }
export type FavouriteSearchActivateMutationHookResult = ReturnType<typeof useFavouriteSearchActivateMutation>;
export type FavouriteSearchActivateMutationResult = Apollo.MutationResult<FavouriteSearchActivateMutation>;
export type FavouriteSearchActivateMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>;
export const FavouriteSearchActivateGuestDocument = gql`
    mutation FavouriteSearchActivateGuest($searchString: String!, $email: String!) {
  activateFavouriteSearchGuest(searchString: $searchString, email: $email)
}
    `;
export type FavouriteSearchActivateGuestMutationFn = Apollo.MutationFunction<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>;

/**
 * __useFavouriteSearchActivateGuestMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchActivateGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchActivateGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchActivateGuestMutation, { data, loading, error }] = useFavouriteSearchActivateGuestMutation({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFavouriteSearchActivateGuestMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>(FavouriteSearchActivateGuestDocument, options);
      }
export type FavouriteSearchActivateGuestMutationHookResult = ReturnType<typeof useFavouriteSearchActivateGuestMutation>;
export type FavouriteSearchActivateGuestMutationResult = Apollo.MutationResult<FavouriteSearchActivateGuestMutation>;
export type FavouriteSearchActivateGuestMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>;
export const FavouriteSearchDeactivateDocument = gql`
    mutation FavouriteSearchDeactivate($favouriteSearchDeactivateId: ID!) {
  favouriteSearchDeactivate(id: $favouriteSearchDeactivateId)
}
    `;
export type FavouriteSearchDeactivateMutationFn = Apollo.MutationFunction<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>;

/**
 * __useFavouriteSearchDeactivateMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchDeactivateMutation, { data, loading, error }] = useFavouriteSearchDeactivateMutation({
 *   variables: {
 *      favouriteSearchDeactivateId: // value for 'favouriteSearchDeactivateId'
 *   },
 * });
 */
export function useFavouriteSearchDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>(FavouriteSearchDeactivateDocument, options);
      }
export type FavouriteSearchDeactivateMutationHookResult = ReturnType<typeof useFavouriteSearchDeactivateMutation>;
export type FavouriteSearchDeactivateMutationResult = Apollo.MutationResult<FavouriteSearchDeactivateMutation>;
export type FavouriteSearchDeactivateMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>;
export const FavouriteSearchIdLookupDocument = gql`
    query FavouriteSearchIdLookup($input: FavouriteSearchIdLookupInput!) {
  favouriteSearchIdLookup(input: $input) {
    id
    active
  }
}
    `;

/**
 * __useFavouriteSearchIdLookupQuery__
 *
 * To run a query within a React component, call `useFavouriteSearchIdLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchIdLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavouriteSearchIdLookupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavouriteSearchIdLookupQuery(baseOptions: Apollo.QueryHookOptions<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>(FavouriteSearchIdLookupDocument, options);
      }
export function useFavouriteSearchIdLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>(FavouriteSearchIdLookupDocument, options);
        }
export type FavouriteSearchIdLookupQueryHookResult = ReturnType<typeof useFavouriteSearchIdLookupQuery>;
export type FavouriteSearchIdLookupLazyQueryHookResult = ReturnType<typeof useFavouriteSearchIdLookupLazyQuery>;
export type FavouriteSearchIdLookupQueryResult = Apollo.QueryResult<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>;
export const GetSearchCategoriesDocument = gql`
    query getSearchCategories($locale: String!) {
  searchCategories {
    id
    localizedName(locale: $locale)
    parentId
  }
}
    `;

/**
 * __useGetSearchCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSearchCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCategoriesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetSearchCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>(GetSearchCategoriesDocument, options);
      }
export function useGetSearchCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>(GetSearchCategoriesDocument, options);
        }
export type GetSearchCategoriesQueryHookResult = ReturnType<typeof useGetSearchCategoriesQuery>;
export type GetSearchCategoriesLazyQueryHookResult = ReturnType<typeof useGetSearchCategoriesLazyQuery>;
export type GetSearchCategoriesQueryResult = Apollo.QueryResult<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>;
export const GetGoogleMapsKeyDocument = gql`
    mutation GetGoogleMapsKey {
  getGoogleMapsKey
}
    `;
export type GetGoogleMapsKeyMutationFn = Apollo.MutationFunction<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>;

/**
 * __useGetGoogleMapsKeyMutation__
 *
 * To run a mutation, you first call `useGetGoogleMapsKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleMapsKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGoogleMapsKeyMutation, { data, loading, error }] = useGetGoogleMapsKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleMapsKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>(GetGoogleMapsKeyDocument, options);
      }
export type GetGoogleMapsKeyMutationHookResult = ReturnType<typeof useGetGoogleMapsKeyMutation>;
export type GetGoogleMapsKeyMutationResult = Apollo.MutationResult<GetGoogleMapsKeyMutation>;
export type GetGoogleMapsKeyMutationOptions = Apollo.BaseMutationOptions<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>;
export const GetPlaceSuggestionsDocument = gql`
    query GetPlaceSuggestions($input: String!, $location: LocationQueryCoordsOptions) {
  placeSuggestions(input: $input, location: $location) {
    placeId
    address
  }
}
    `;

/**
 * __useGetPlaceSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetPlaceSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetPlaceSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>(GetPlaceSuggestionsDocument, options);
      }
export function useGetPlaceSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>(GetPlaceSuggestionsDocument, options);
        }
export type GetPlaceSuggestionsQueryHookResult = ReturnType<typeof useGetPlaceSuggestionsQuery>;
export type GetPlaceSuggestionsLazyQueryHookResult = ReturnType<typeof useGetPlaceSuggestionsLazyQuery>;
export type GetPlaceSuggestionsQueryResult = Apollo.QueryResult<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>;
export const GetPlaceTokenDocument = gql`
    mutation getPlaceToken {
  getPlaceToken
}
    `;
export type GetPlaceTokenMutationFn = Apollo.MutationFunction<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>;

/**
 * __useGetPlaceTokenMutation__
 *
 * To run a mutation, you first call `useGetPlaceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPlaceTokenMutation, { data, loading, error }] = useGetPlaceTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaceTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>(GetPlaceTokenDocument, options);
      }
export type GetPlaceTokenMutationHookResult = ReturnType<typeof useGetPlaceTokenMutation>;
export type GetPlaceTokenMutationResult = Apollo.MutationResult<GetPlaceTokenMutation>;
export type GetPlaceTokenMutationOptions = Apollo.BaseMutationOptions<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>;
export const GetCategoriesNearYouDocument = gql`
    query GetCategoriesNearYou($locationId: Int!) {
  menuPrefetch(locationId: $locationId) {
    id
    categoryName
    seoUrl
  }
}
    `;

/**
 * __useGetCategoriesNearYouQuery__
 *
 * To run a query within a React component, call `useGetCategoriesNearYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesNearYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesNearYouQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetCategoriesNearYouQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>(GetCategoriesNearYouDocument, options);
      }
export function useGetCategoriesNearYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>(GetCategoriesNearYouDocument, options);
        }
export type GetCategoriesNearYouQueryHookResult = ReturnType<typeof useGetCategoriesNearYouQuery>;
export type GetCategoriesNearYouLazyQueryHookResult = ReturnType<typeof useGetCategoriesNearYouLazyQuery>;
export type GetCategoriesNearYouQueryResult = Apollo.QueryResult<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>;
export const GetFeedRecommendationsDocument = gql`
    query GetFeedRecommendations($input: FeedRecommendationsInput!) {
  feedRecommendations(input: $input) {
    seedId
    description
    seoUrl
    ads {
      id
      categoryId
      imageUrls
      locationId
      price {
        amount
        type
      }
      seoUrl
      title
      type
    }
  }
}
    `;

/**
 * __useGetFeedRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetFeedRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>(GetFeedRecommendationsDocument, options);
      }
export function useGetFeedRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>(GetFeedRecommendationsDocument, options);
        }
export type GetFeedRecommendationsQueryHookResult = ReturnType<typeof useGetFeedRecommendationsQuery>;
export type GetFeedRecommendationsLazyQueryHookResult = ReturnType<typeof useGetFeedRecommendationsLazyQuery>;
export type GetFeedRecommendationsQueryResult = Apollo.QueryResult<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>;
export const GetHomeFeedDocument = gql`
    query GetHomeFeed($input: HomeFeedInput!, $homePageMixGroup: String) {
  homeFeed(input: $input, homePageMixGroup: $homePageMixGroup) {
    pageInfo {
      currentPage
      numberOfAds
      hasNextPage
      links
    }
    results {
      ... on FeedItem {
        id
        imageUrls
        processorName
        seoUrl
        title
        type
        price {
          amount
          type
        }
      }
      ... on PopularCategoryItem {
        id
        seoUrl
        title
      }
      ... on BrandedCategoryItem {
        id
        imageUrl
        seoUrl
        title
      }
    }
  }
}
    `;

/**
 * __useGetHomeFeedQuery__
 *
 * To run a query within a React component, call `useGetHomeFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *      homePageMixGroup: // value for 'homePageMixGroup'
 *   },
 * });
 */
export function useGetHomeFeedQuery(baseOptions: Apollo.QueryHookOptions<GetHomeFeedQuery, GetHomeFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeFeedQuery, GetHomeFeedQueryVariables>(GetHomeFeedDocument, options);
      }
export function useGetHomeFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeFeedQuery, GetHomeFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeFeedQuery, GetHomeFeedQueryVariables>(GetHomeFeedDocument, options);
        }
export type GetHomeFeedQueryHookResult = ReturnType<typeof useGetHomeFeedQuery>;
export type GetHomeFeedLazyQueryHookResult = ReturnType<typeof useGetHomeFeedLazyQuery>;
export type GetHomeFeedQueryResult = Apollo.QueryResult<GetHomeFeedQuery, GetHomeFeedQueryVariables>;
export const GetPopularKeywordsNearYouDocument = gql`
    query GetPopularKeywordsNearYou($searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    `;

/**
 * __useGetPopularKeywordsNearYouQuery__
 *
 * To run a query within a React component, call `useGetPopularKeywordsNearYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularKeywordsNearYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularKeywordsNearYouQuery({
 *   variables: {
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetPopularKeywordsNearYouQuery(baseOptions: Apollo.QueryHookOptions<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>(GetPopularKeywordsNearYouDocument, options);
      }
export function useGetPopularKeywordsNearYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>(GetPopularKeywordsNearYouDocument, options);
        }
export type GetPopularKeywordsNearYouQueryHookResult = ReturnType<typeof useGetPopularKeywordsNearYouQuery>;
export type GetPopularKeywordsNearYouLazyQueryHookResult = ReturnType<typeof useGetPopularKeywordsNearYouLazyQuery>;
export type GetPopularKeywordsNearYouQueryResult = Apollo.QueryResult<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>;
export const GetRecentlyViewedListingsDocument = gql`
    query GetRecentlyViewedListings($userId: Int!) {
  user(userId: $userId) {
    recentlyViewedListings {
      title
      seoUrl
      price {
        amount
        type
      }
      imageUrls
      id
      locationId
      categoryId
    }
  }
}
    `;

/**
 * __useGetRecentlyViewedListingsQuery__
 *
 * To run a query within a React component, call `useGetRecentlyViewedListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlyViewedListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlyViewedListingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRecentlyViewedListingsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>(GetRecentlyViewedListingsDocument, options);
      }
export function useGetRecentlyViewedListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>(GetRecentlyViewedListingsDocument, options);
        }
export type GetRecentlyViewedListingsQueryHookResult = ReturnType<typeof useGetRecentlyViewedListingsQuery>;
export type GetRecentlyViewedListingsLazyQueryHookResult = ReturnType<typeof useGetRecentlyViewedListingsLazyQuery>;
export type GetRecentlyViewedListingsQueryResult = Apollo.QueryResult<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>;
export const GetRecommendedForYouDocument = gql`
    query GetRecommendedForYou($listingIds: [ID!]) {
  listingsRecommendedForYou(listingIds: $listingIds) {
    adSource
    id
    categoryId
    title
    imageUrls
    location {
      id
      name
    }
    url
    price {
      type
      ... on StandardAmountPrice {
        amount
      }
      ... on AutosDealerAmountPrice {
        amount
      }
      ... on AmountPrice {
        amount
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedForYouQuery__
 *
 * To run a query within a React component, call `useGetRecommendedForYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedForYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedForYouQuery({
 *   variables: {
 *      listingIds: // value for 'listingIds'
 *   },
 * });
 */
export function useGetRecommendedForYouQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>(GetRecommendedForYouDocument, options);
      }
export function useGetRecommendedForYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>(GetRecommendedForYouDocument, options);
        }
export type GetRecommendedForYouQueryHookResult = ReturnType<typeof useGetRecommendedForYouQuery>;
export type GetRecommendedForYouLazyQueryHookResult = ReturnType<typeof useGetRecommendedForYouLazyQuery>;
export type GetRecommendedForYouQueryResult = Apollo.QueryResult<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>;
export const GetListingDocument = gql`
    query GetListing($listingId: ID!, $trackView: Boolean, $isExternalId: Boolean) {
  listing(id: $listingId, isExternalId: $isExternalId, trackView: $trackView) {
    activationDate
    adSource
    productUrl
    externalSource {
      sourceProviderId
    }
    attributes {
      all {
        canonicalName
        canonicalValues
        values
        name
      }
    }
    categoryId
    description
    flags {
      categorySpecificBadge
      highlight
      hpGallery
      topAd
      priceDrop
      showcase
      isFromAutosDealer
      isFromDealer
      isMoVe
      isPint
      isSM360
      isVerticalCategory
      ... on AutosListingFlags {
        chatOptIn
        creditOptIn
        tradeInOptIn
        enhancedContactForm
        financingAvailable
      }
      ... on RealEstateListingFlags {
        comfree
      }
    }
    id
    imageUrls
    location {
      showPinOnMap
      address
      coordinates {
        latitude
        longitude
      }
      id
      name
      ... on RealEstateListingLocation {
        neighbourhoodInfo {
          name
          id
          profile {
            summary
            transportation
          }
          scores {
            transportation {
              cycle {
                score
                description
              }
              walk {
                score
                description
              }
              transit {
                score
                description
              }
            }
          }
        }
      }
    }
    posterInfo {
      posterId
      sellerType
      websiteUrl
      phoneNumber
    }
    price {
      type
      ... on StandardAmountPrice {
        amount
        currency
        originalAmount
      }
      ... on AutosDealerAmountPrice {
        amount
        currency
        originalAmount
        msrp
        surcharges
        classification {
          averagePrice
          rating
        }
      }
    }
    sortingDate
    title
    type
    url
    metrics {
      views
    }
    youtubeVideoId
    status
    endDate
    ... on RealEstateListing {
      virtualTourUrl
      mlsAd
      requestViewingUrl
      rentalBadge
    }
  }
}
    `;

/**
 * __useGetListingQuery__
 *
 * To run a query within a React component, call `useGetListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      trackView: // value for 'trackView'
 *      isExternalId: // value for 'isExternalId'
 *   },
 * });
 */
export function useGetListingQuery(baseOptions: Apollo.QueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
      }
export function useGetListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
        }
export type GetListingQueryHookResult = ReturnType<typeof useGetListingQuery>;
export type GetListingLazyQueryHookResult = ReturnType<typeof useGetListingLazyQuery>;
export type GetListingQueryResult = Apollo.QueryResult<GetListingQuery, GetListingQueryVariables>;
export const GetSellerListingDataDocument = gql`
    query GetSellerListingData($listingId: ID!) {
  listing(id: $listingId) {
    metrics {
      replies
    }
  }
}
    `;

/**
 * __useGetSellerListingDataQuery__
 *
 * To run a query within a React component, call `useGetSellerListingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerListingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerListingDataQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetSellerListingDataQuery(baseOptions: Apollo.QueryHookOptions<GetSellerListingDataQuery, GetSellerListingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSellerListingDataQuery, GetSellerListingDataQueryVariables>(GetSellerListingDataDocument, options);
      }
export function useGetSellerListingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerListingDataQuery, GetSellerListingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSellerListingDataQuery, GetSellerListingDataQueryVariables>(GetSellerListingDataDocument, options);
        }
export type GetSellerListingDataQueryHookResult = ReturnType<typeof useGetSellerListingDataQuery>;
export type GetSellerListingDataLazyQueryHookResult = ReturnType<typeof useGetSellerListingDataLazyQuery>;
export type GetSellerListingDataQueryResult = Apollo.QueryResult<GetSellerListingDataQuery, GetSellerListingDataQueryVariables>;
export const ListingRequestFinancingDocument = gql`
    mutation ListingRequestFinancing($email: EmailAddress!, $externalSourceId: String, $firstName: String!, $lastName: String!, $listingRequestFinancingId: ID!, $message: String, $phoneNumber: String!) {
  listingRequestFinancing(
    email: $email
    externalSourceId: $externalSourceId
    firstName: $firstName
    id: $listingRequestFinancingId
    lastName: $lastName
    message: $message
    phoneNumber: $phoneNumber
  )
}
    `;
export type ListingRequestFinancingMutationFn = Apollo.MutationFunction<ListingRequestFinancingMutation, ListingRequestFinancingMutationVariables>;

/**
 * __useListingRequestFinancingMutation__
 *
 * To run a mutation, you first call `useListingRequestFinancingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingRequestFinancingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingRequestFinancingMutation, { data, loading, error }] = useListingRequestFinancingMutation({
 *   variables: {
 *      email: // value for 'email'
 *      externalSourceId: // value for 'externalSourceId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      listingRequestFinancingId: // value for 'listingRequestFinancingId'
 *      message: // value for 'message'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useListingRequestFinancingMutation(baseOptions?: Apollo.MutationHookOptions<ListingRequestFinancingMutation, ListingRequestFinancingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingRequestFinancingMutation, ListingRequestFinancingMutationVariables>(ListingRequestFinancingDocument, options);
      }
export type ListingRequestFinancingMutationHookResult = ReturnType<typeof useListingRequestFinancingMutation>;
export type ListingRequestFinancingMutationResult = Apollo.MutationResult<ListingRequestFinancingMutation>;
export type ListingRequestFinancingMutationOptions = Apollo.BaseMutationOptions<ListingRequestFinancingMutation, ListingRequestFinancingMutationVariables>;
export const VehicleReportDocument = gql`
    query VehicleReport($adId: Int!, $source: AdSource, $isExternalId: Boolean) {
  ad(id: $adId, source: $source, isExternalId: $isExternalId) {
    ... on MoveAd {
      vehicleReport {
        badgeKeys
        reportUrl
      }
    }
  }
}
    `;

/**
 * __useVehicleReportQuery__
 *
 * To run a query within a React component, call `useVehicleReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleReportQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *      source: // value for 'source'
 *      isExternalId: // value for 'isExternalId'
 *   },
 * });
 */
export function useVehicleReportQuery(baseOptions: Apollo.QueryHookOptions<VehicleReportQuery, VehicleReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleReportQuery, VehicleReportQueryVariables>(VehicleReportDocument, options);
      }
export function useVehicleReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleReportQuery, VehicleReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleReportQuery, VehicleReportQueryVariables>(VehicleReportDocument, options);
        }
export type VehicleReportQueryHookResult = ReturnType<typeof useVehicleReportQuery>;
export type VehicleReportLazyQueryHookResult = ReturnType<typeof useVehicleReportLazyQuery>;
export type VehicleReportQueryResult = Apollo.QueryResult<VehicleReportQuery, VehicleReportQueryVariables>;
export const GetGeocodeCanadianAddressDocument = gql`
    query GetGeocodeCanadianAddress($address: String!) {
  geocodeCanadianAddress(address: $address) {
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetGeocodeCanadianAddressQuery__
 *
 * To run a query within a React component, call `useGetGeocodeCanadianAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeocodeCanadianAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeocodeCanadianAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetGeocodeCanadianAddressQuery(baseOptions: Apollo.QueryHookOptions<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>(GetGeocodeCanadianAddressDocument, options);
      }
export function useGetGeocodeCanadianAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>(GetGeocodeCanadianAddressDocument, options);
        }
export type GetGeocodeCanadianAddressQueryHookResult = ReturnType<typeof useGetGeocodeCanadianAddressQuery>;
export type GetGeocodeCanadianAddressLazyQueryHookResult = ReturnType<typeof useGetGeocodeCanadianAddressLazyQuery>;
export type GetGeocodeCanadianAddressQueryResult = Apollo.QueryResult<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>;
export const GetGeocodeReverseFromIpDocument = gql`
    query GetGeocodeReverseFromIp {
  geocodeReverseFromIp {
    city
    province
    locationId
  }
}
    `;

/**
 * __useGetGeocodeReverseFromIpQuery__
 *
 * To run a query within a React component, call `useGetGeocodeReverseFromIpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeocodeReverseFromIpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeocodeReverseFromIpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeocodeReverseFromIpQuery(baseOptions?: Apollo.QueryHookOptions<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>(GetGeocodeReverseFromIpDocument, options);
      }
export function useGetGeocodeReverseFromIpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>(GetGeocodeReverseFromIpDocument, options);
        }
export type GetGeocodeReverseFromIpQueryHookResult = ReturnType<typeof useGetGeocodeReverseFromIpQuery>;
export type GetGeocodeReverseFromIpLazyQueryHookResult = ReturnType<typeof useGetGeocodeReverseFromIpLazyQuery>;
export type GetGeocodeReverseFromIpQueryResult = Apollo.QueryResult<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>;
export const GetLocationFromCoordinatesDocument = gql`
    query GetLocationFromCoordinates($coordinates: LocationQueryCoordsOptions!) {
  locationFromCoordinates(coordinates: $coordinates) {
    location {
      id
      locationPaths {
        id
      }
      name {
        en_CA
        fr_CA
      }
    }
    place {
      address
      location {
        latitude
        longitude
      }
      postalCode {
        long
      }
    }
  }
}
    `;

/**
 * __useGetLocationFromCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetLocationFromCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromCoordinatesQuery({
 *   variables: {
 *      coordinates: // value for 'coordinates'
 *   },
 * });
 */
export function useGetLocationFromCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>(GetLocationFromCoordinatesDocument, options);
      }
export function useGetLocationFromCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>(GetLocationFromCoordinatesDocument, options);
        }
export type GetLocationFromCoordinatesQueryHookResult = ReturnType<typeof useGetLocationFromCoordinatesQuery>;
export type GetLocationFromCoordinatesLazyQueryHookResult = ReturnType<typeof useGetLocationFromCoordinatesLazyQuery>;
export type GetLocationFromCoordinatesQueryResult = Apollo.QueryResult<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>;
export const GetLocationFromIdDocument = gql`
    query getLocationFromId($locationId: Int!) {
  location(id: $locationId) {
    id
    localizedName
    name {
      en_CA
      fr_CA
    }
    coordinates {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetLocationFromIdQuery__
 *
 * To run a query within a React component, call `useGetLocationFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>(GetLocationFromIdDocument, options);
      }
export function useGetLocationFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>(GetLocationFromIdDocument, options);
        }
export type GetLocationFromIdQueryHookResult = ReturnType<typeof useGetLocationFromIdQuery>;
export type GetLocationFromIdLazyQueryHookResult = ReturnType<typeof useGetLocationFromIdLazyQuery>;
export type GetLocationFromIdQueryResult = Apollo.QueryResult<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>;
export const GetLocationFromPlaceDocument = gql`
    query GetLocationFromPlace($placeId: String!, $sessionToken: String) {
  locationFromPlace(placeId: $placeId, sessionToken: $sessionToken) {
    place {
      id
      address
      location {
        latitude
        longitude
      }
      postalCode {
        long
        short
      }
      isCountry
      isProvince
    }
    location {
      id
      coordinates {
        latitude
        longitude
      }
      name {
        en_CA
        fr_CA
      }
    }
  }
}
    `;

/**
 * __useGetLocationFromPlaceQuery__
 *
 * To run a query within a React component, call `useGetLocationFromPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromPlaceQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetLocationFromPlaceQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>(GetLocationFromPlaceDocument, options);
      }
export function useGetLocationFromPlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>(GetLocationFromPlaceDocument, options);
        }
export type GetLocationFromPlaceQueryHookResult = ReturnType<typeof useGetLocationFromPlaceQuery>;
export type GetLocationFromPlaceLazyQueryHookResult = ReturnType<typeof useGetLocationFromPlaceLazyQuery>;
export type GetLocationFromPlaceQueryResult = Apollo.QueryResult<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>;
export const GetLocationPathFromIdDocument = gql`
    query GetLocationPathFromId($locationId: Int!) {
  location(id: $locationId) {
    locationPaths {
      id
      name {
        en_CA
        fr_CA
      }
    }
  }
}
    `;

/**
 * __useGetLocationPathFromIdQuery__
 *
 * To run a query within a React component, call `useGetLocationPathFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationPathFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationPathFromIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationPathFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>(GetLocationPathFromIdDocument, options);
      }
export function useGetLocationPathFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>(GetLocationPathFromIdDocument, options);
        }
export type GetLocationPathFromIdQueryHookResult = ReturnType<typeof useGetLocationPathFromIdQuery>;
export type GetLocationPathFromIdLazyQueryHookResult = ReturnType<typeof useGetLocationPathFromIdLazyQuery>;
export type GetLocationPathFromIdQueryResult = Apollo.QueryResult<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>;
export const GetSocialLinksDocument = gql`
    query GetSocialLinks {
  myAccount {
    ...SocialLinksFields
  }
}
    ${SocialLinksFieldsFragmentDoc}`;

/**
 * __useGetSocialLinksQuery__
 *
 * To run a query within a React component, call `useGetSocialLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
      }
export function useGetSocialLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
        }
export type GetSocialLinksQueryHookResult = ReturnType<typeof useGetSocialLinksQuery>;
export type GetSocialLinksLazyQueryHookResult = ReturnType<typeof useGetSocialLinksLazyQuery>;
export type GetSocialLinksQueryResult = Apollo.QueryResult<GetSocialLinksQuery, GetSocialLinksQueryVariables>;
export const UpdateSocialLinksDocument = gql`
    mutation UpdateSocialLinks($input: UpdateSocialLinksInput!) {
  updateSocialLinks(input: $input) {
    statusCode
  }
}
    `;
export type UpdateSocialLinksMutationFn = Apollo.MutationFunction<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>;

/**
 * __useUpdateSocialLinksMutation__
 *
 * To run a mutation, you first call `useUpdateSocialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialLinksMutation, { data, loading, error }] = useUpdateSocialLinksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialLinksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>(UpdateSocialLinksDocument, options);
      }
export type UpdateSocialLinksMutationHookResult = ReturnType<typeof useUpdateSocialLinksMutation>;
export type UpdateSocialLinksMutationResult = Apollo.MutationResult<UpdateSocialLinksMutation>;
export type UpdateSocialLinksMutationOptions = Apollo.BaseMutationOptions<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>;
export const AddFavouriteListingDocument = gql`
    mutation AddFavouriteListing($listingId: ID!) {
  addFavouriteListing(listingId: $listingId)
}
    `;
export type AddFavouriteListingMutationFn = Apollo.MutationFunction<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>;

/**
 * __useAddFavouriteListingMutation__
 *
 * To run a mutation, you first call `useAddFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavouriteListingMutation, { data, loading, error }] = useAddFavouriteListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useAddFavouriteListingMutation(baseOptions?: Apollo.MutationHookOptions<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>(AddFavouriteListingDocument, options);
      }
export type AddFavouriteListingMutationHookResult = ReturnType<typeof useAddFavouriteListingMutation>;
export type AddFavouriteListingMutationResult = Apollo.MutationResult<AddFavouriteListingMutation>;
export type AddFavouriteListingMutationOptions = Apollo.BaseMutationOptions<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>;
export const GetAuthModalStateDocument = gql`
    query GetAuthModalState {
  authModalState @client {
    isModalOpen
    modalVariant
    callbackUrl
    categoryId
  }
}
    `;

/**
 * __useGetAuthModalStateQuery__
 *
 * To run a query within a React component, call `useGetAuthModalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthModalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthModalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthModalStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>(GetAuthModalStateDocument, options);
      }
export function useGetAuthModalStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>(GetAuthModalStateDocument, options);
        }
export type GetAuthModalStateQueryHookResult = ReturnType<typeof useGetAuthModalStateQuery>;
export type GetAuthModalStateLazyQueryHookResult = ReturnType<typeof useGetAuthModalStateLazyQuery>;
export type GetAuthModalStateQueryResult = Apollo.QueryResult<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>;
export const GetSeoUrlDocument = gql`
    query GetSeoUrl($input: SearchUrlInput!) {
  searchUrl(input: $input)
}
    `;

/**
 * __useGetSeoUrlQuery__
 *
 * To run a query within a React component, call `useGetSeoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSeoUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSeoUrlQuery, GetSeoUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoUrlQuery, GetSeoUrlQueryVariables>(GetSeoUrlDocument, options);
      }
export function useGetSeoUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoUrlQuery, GetSeoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoUrlQuery, GetSeoUrlQueryVariables>(GetSeoUrlDocument, options);
        }
export type GetSeoUrlQueryHookResult = ReturnType<typeof useGetSeoUrlQuery>;
export type GetSeoUrlLazyQueryHookResult = ReturnType<typeof useGetSeoUrlLazyQuery>;
export type GetSeoUrlQueryResult = Apollo.QueryResult<GetSeoUrlQuery, GetSeoUrlQueryVariables>;
export const GetSearchResultsPageByUrlDocument = gql`
    query GetSearchResultsPageByUrl($searchResultsByUrlInput: SearchResultsByUrlInput!, $pagination: PaginationInputV2!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    controls {
      ...SearchControlsFields
    }
    pagination {
      ...PaginationFields
    }
    searchQuery {
      ...SearchQueryFields
    }
    results {
      topListings {
        ...Listing
      }
      mainListings(pagination: $pagination) {
        ...Listing
      }
      clusters {
        ...ClustersFields
      }
    }
  }
}
    ${SearchControlsFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}
${SearchQueryFieldsFragmentDoc}
${ListingFragmentDoc}
${ClustersFieldsFragmentDoc}`;

/**
 * __useGetSearchResultsPageByUrlQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsPageByUrlQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetSearchResultsPageByUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>(GetSearchResultsPageByUrlDocument, options);
      }
export function useGetSearchResultsPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>(GetSearchResultsPageByUrlDocument, options);
        }
export type GetSearchResultsPageByUrlQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlQuery>;
export type GetSearchResultsPageByUrlLazyQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlLazyQuery>;
export type GetSearchResultsPageByUrlQueryResult = Apollo.QueryResult<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>;
export const GetSearchResultsPageByUrlWithSeoDocument = gql`
    query GetSearchResultsPageByUrlWithSeo($searchResultsByUrlInput: SearchResultsByUrlInput!, $pagination: PaginationInputV2!, $searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    controls {
      ...SearchControlsFields
    }
    pagination {
      ...PaginationFields
    }
    searchQuery {
      ...SearchQueryFields
    }
    results {
      topListings {
        ...Listing
      }
      mainListings(pagination: $pagination) {
        ...Listing
      }
      clusters {
        ...ClustersFields
      }
    }
  }
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    ${SearchControlsFieldsFragmentDoc}
${PaginationFieldsFragmentDoc}
${SearchQueryFieldsFragmentDoc}
${ListingFragmentDoc}
${ClustersFieldsFragmentDoc}`;

/**
 * __useGetSearchResultsPageByUrlWithSeoQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsPageByUrlWithSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsPageByUrlWithSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsPageByUrlWithSeoQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *      pagination: // value for 'pagination'
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetSearchResultsPageByUrlWithSeoQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>(GetSearchResultsPageByUrlWithSeoDocument, options);
      }
export function useGetSearchResultsPageByUrlWithSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>(GetSearchResultsPageByUrlWithSeoDocument, options);
        }
export type GetSearchResultsPageByUrlWithSeoQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlWithSeoQuery>;
export type GetSearchResultsPageByUrlWithSeoLazyQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlWithSeoLazyQuery>;
export type GetSearchResultsPageByUrlWithSeoQueryResult = Apollo.QueryResult<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>;
export const GetBreadcrumbsBySearchPageUrlDocument = gql`
    query GetBreadcrumbsBySearchPageUrl($searchResultsByUrlInput: SearchResultsByUrlInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    searchQuery {
      ...BreadcrumbsSearchQuery
    }
  }
}
    ${BreadcrumbsSearchQueryFragmentDoc}`;

/**
 * __useGetBreadcrumbsBySearchPageUrlQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbsBySearchPageUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbsBySearchPageUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbsBySearchPageUrlQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *   },
 * });
 */
export function useGetBreadcrumbsBySearchPageUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>(GetBreadcrumbsBySearchPageUrlDocument, options);
      }
export function useGetBreadcrumbsBySearchPageUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>(GetBreadcrumbsBySearchPageUrlDocument, options);
        }
export type GetBreadcrumbsBySearchPageUrlQueryHookResult = ReturnType<typeof useGetBreadcrumbsBySearchPageUrlQuery>;
export type GetBreadcrumbsBySearchPageUrlLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbsBySearchPageUrlLazyQuery>;
export type GetBreadcrumbsBySearchPageUrlQueryResult = Apollo.QueryResult<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($categoryId: Int!) {
  category(id: $categoryId) {
    id
    localizedName
    parentId
    categoryPaths {
      id
      localizedName
      parentId
    }
    attributes {
      id
      canonicalName
      localizedFields {
        canonicalValue
        seoSlug
        value
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetUserFavouritesListDocument = gql`
    query GetUserFavouritesList {
  favouriteListingsIds
}
    `;

/**
 * __useGetUserFavouritesListQuery__
 *
 * To run a query within a React component, call `useGetUserFavouritesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavouritesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavouritesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFavouritesListQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>(GetUserFavouritesListDocument, options);
      }
export function useGetUserFavouritesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>(GetUserFavouritesListDocument, options);
        }
export type GetUserFavouritesListQueryHookResult = ReturnType<typeof useGetUserFavouritesListQuery>;
export type GetUserFavouritesListLazyQueryHookResult = ReturnType<typeof useGetUserFavouritesListLazyQuery>;
export type GetUserFavouritesListQueryResult = Apollo.QueryResult<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>;
export const GetFilterDrawerStateDocument = gql`
    query GetFilterDrawerState {
  srp @client {
    isFilterDrawerOpen
    selectedAccordionItems
  }
}
    `;

/**
 * __useGetFilterDrawerStateQuery__
 *
 * To run a query within a React component, call `useGetFilterDrawerStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterDrawerStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterDrawerStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterDrawerStateQuery(baseOptions?: Apollo.QueryHookOptions<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>(GetFilterDrawerStateDocument, options);
      }
export function useGetFilterDrawerStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>(GetFilterDrawerStateDocument, options);
        }
export type GetFilterDrawerStateQueryHookResult = ReturnType<typeof useGetFilterDrawerStateQuery>;
export type GetFilterDrawerStateLazyQueryHookResult = ReturnType<typeof useGetFilterDrawerStateLazyQuery>;
export type GetFilterDrawerStateQueryResult = Apollo.QueryResult<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>;
export const GetListingsDrawerStateDocument = gql`
    query GetListingsDrawerState {
  srp @client {
    isListingsDrawerOpen
  }
}
    `;

/**
 * __useGetListingsDrawerStateQuery__
 *
 * To run a query within a React component, call `useGetListingsDrawerStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingsDrawerStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingsDrawerStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListingsDrawerStateQuery(baseOptions?: Apollo.QueryHookOptions<GetListingsDrawerStateQuery, GetListingsDrawerStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingsDrawerStateQuery, GetListingsDrawerStateQueryVariables>(GetListingsDrawerStateDocument, options);
      }
export function useGetListingsDrawerStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingsDrawerStateQuery, GetListingsDrawerStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingsDrawerStateQuery, GetListingsDrawerStateQueryVariables>(GetListingsDrawerStateDocument, options);
        }
export type GetListingsDrawerStateQueryHookResult = ReturnType<typeof useGetListingsDrawerStateQuery>;
export type GetListingsDrawerStateLazyQueryHookResult = ReturnType<typeof useGetListingsDrawerStateLazyQuery>;
export type GetListingsDrawerStateQueryResult = Apollo.QueryResult<GetListingsDrawerStateQuery, GetListingsDrawerStateQueryVariables>;
export const GetMapSearchResultsPageStateDocument = gql`
    query GetMapSearchResultsPageState {
  mapSrp @client {
    shouldUpdateLocationRef
  }
}
    `;

/**
 * __useGetMapSearchResultsPageStateQuery__
 *
 * To run a query within a React component, call `useGetMapSearchResultsPageStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapSearchResultsPageStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapSearchResultsPageStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMapSearchResultsPageStateQuery(baseOptions?: Apollo.QueryHookOptions<GetMapSearchResultsPageStateQuery, GetMapSearchResultsPageStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapSearchResultsPageStateQuery, GetMapSearchResultsPageStateQueryVariables>(GetMapSearchResultsPageStateDocument, options);
      }
export function useGetMapSearchResultsPageStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapSearchResultsPageStateQuery, GetMapSearchResultsPageStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapSearchResultsPageStateQuery, GetMapSearchResultsPageStateQueryVariables>(GetMapSearchResultsPageStateDocument, options);
        }
export type GetMapSearchResultsPageStateQueryHookResult = ReturnType<typeof useGetMapSearchResultsPageStateQuery>;
export type GetMapSearchResultsPageStateLazyQueryHookResult = ReturnType<typeof useGetMapSearchResultsPageStateLazyQuery>;
export type GetMapSearchResultsPageStateQueryResult = Apollo.QueryResult<GetMapSearchResultsPageStateQuery, GetMapSearchResultsPageStateQueryVariables>;
export const GetOrganicListingsDocument = gql`
    query GetOrganicListings($input: SearchResultsInput!, $pagination: PaginationInputV2!) {
  searchResultsPageUpdate(input: $input) {
    results {
      mainListings(pagination: $pagination) {
        id
        title
        description
        imageCount
        imageUrls
        categoryId
        url
        activationDate
        sortingDate
        adSource
        location {
          id
          name
          address
          distance
          nearestIntersection
        }
        price {
          type
          ... on StandardAmountPrice {
            amount
            originalAmount
          }
          ... on AutosDealerAmountPrice {
            amount
            originalAmount
            msrp
            surcharges
          }
        }
        attributes {
          all {
            canonicalName
            canonicalValues
          }
        }
        flags {
          categorySpecificBadge
          priceDrop
          showcase
          topAd
          highlight
          shippedBySeller
          isPromotionProvTopAd
          isPromotionTopAd
          ... on RealEstateListingFlags {
            virtualTour
          }
        }
        posterInfo {
          posterId
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganicListingsQuery__
 *
 * To run a query within a React component, call `useGetOrganicListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganicListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganicListingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetOrganicListingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>(GetOrganicListingsDocument, options);
      }
export function useGetOrganicListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>(GetOrganicListingsDocument, options);
        }
export type GetOrganicListingsQueryHookResult = ReturnType<typeof useGetOrganicListingsQuery>;
export type GetOrganicListingsLazyQueryHookResult = ReturnType<typeof useGetOrganicListingsLazyQuery>;
export type GetOrganicListingsQueryResult = Apollo.QueryResult<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>;
export const GetPopularRelatedKeywordsDocument = gql`
    query GetPopularRelatedKeywords($searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    `;

/**
 * __useGetPopularRelatedKeywordsQuery__
 *
 * To run a query within a React component, call `useGetPopularRelatedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularRelatedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularRelatedKeywordsQuery({
 *   variables: {
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetPopularRelatedKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>(GetPopularRelatedKeywordsDocument, options);
      }
export function useGetPopularRelatedKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>(GetPopularRelatedKeywordsDocument, options);
        }
export type GetPopularRelatedKeywordsQueryHookResult = ReturnType<typeof useGetPopularRelatedKeywordsQuery>;
export type GetPopularRelatedKeywordsLazyQueryHookResult = ReturnType<typeof useGetPopularRelatedKeywordsLazyQuery>;
export type GetPopularRelatedKeywordsQueryResult = Apollo.QueryResult<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>;
export const GetSearchLoadingStateDocument = gql`
    query GetSearchLoadingState {
  srp @client {
    loadingFilters
    loadingResults
  }
}
    `;

/**
 * __useGetSearchLoadingStateQuery__
 *
 * To run a query within a React component, call `useGetSearchLoadingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchLoadingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchLoadingStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchLoadingStateQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>(GetSearchLoadingStateDocument, options);
      }
export function useGetSearchLoadingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>(GetSearchLoadingStateDocument, options);
        }
export type GetSearchLoadingStateQueryHookResult = ReturnType<typeof useGetSearchLoadingStateQuery>;
export type GetSearchLoadingStateLazyQueryHookResult = ReturnType<typeof useGetSearchLoadingStateLazyQuery>;
export type GetSearchLoadingStateQueryResult = Apollo.QueryResult<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>;
export const GetPendingSearchInputDocument = gql`
    query GetPendingSearchInput {
  srp @client {
    pendingSearchInput {
      keywords
      by
      direction
      offset
      additionalFlagFilters
      attributeFilters {
        filterName
        values
      }
      rangeFilters {
        filterName
        minValue
        maxValue
      }
      dateRangeFilters {
        filterName
        start
        end
      }
      dateFilters {
        filterName
        value
      }
      toggleFilters {
        filterName
        toggleValue
      }
    }
  }
}
    `;

/**
 * __useGetPendingSearchInputQuery__
 *
 * To run a query within a React component, call `useGetPendingSearchInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingSearchInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingSearchInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingSearchInputQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>(GetPendingSearchInputDocument, options);
      }
export function useGetPendingSearchInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>(GetPendingSearchInputDocument, options);
        }
export type GetPendingSearchInputQueryHookResult = ReturnType<typeof useGetPendingSearchInputQuery>;
export type GetPendingSearchInputLazyQueryHookResult = ReturnType<typeof useGetPendingSearchInputLazyQuery>;
export type GetPendingSearchInputQueryResult = Apollo.QueryResult<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>;
export const GetVipUrlDocument = gql`
    query GetVipUrl($adId: ID!) {
  listingUrl(id: $adId)
}
    `;

/**
 * __useGetVipUrlQuery__
 *
 * To run a query within a React component, call `useGetVipUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVipUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVipUrlQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useGetVipUrlQuery(baseOptions: Apollo.QueryHookOptions<GetVipUrlQuery, GetVipUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVipUrlQuery, GetVipUrlQueryVariables>(GetVipUrlDocument, options);
      }
export function useGetVipUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVipUrlQuery, GetVipUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVipUrlQuery, GetVipUrlQueryVariables>(GetVipUrlDocument, options);
        }
export type GetVipUrlQueryHookResult = ReturnType<typeof useGetVipUrlQuery>;
export type GetVipUrlLazyQueryHookResult = ReturnType<typeof useGetVipUrlLazyQuery>;
export type GetVipUrlQueryResult = Apollo.QueryResult<GetVipUrlQuery, GetVipUrlQueryVariables>;
export const RemoveFavouriteListingDocument = gql`
    mutation RemoveFavouriteListing($listingId: ID!) {
  removeFavouriteListing(listingId: $listingId)
}
    `;
export type RemoveFavouriteListingMutationFn = Apollo.MutationFunction<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>;

/**
 * __useRemoveFavouriteListingMutation__
 *
 * To run a mutation, you first call `useRemoveFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavouriteListingMutation, { data, loading, error }] = useRemoveFavouriteListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useRemoveFavouriteListingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>(RemoveFavouriteListingDocument, options);
      }
export type RemoveFavouriteListingMutationHookResult = ReturnType<typeof useRemoveFavouriteListingMutation>;
export type RemoveFavouriteListingMutationResult = Apollo.MutationResult<RemoveFavouriteListingMutation>;
export type RemoveFavouriteListingMutationOptions = Apollo.BaseMutationOptions<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>;
export const GetPosterOtherAdsDocument = gql`
    query GetPosterOtherAds($sort: ProfileSortInput!, $pagination: PaginationInputV2!, $profileId: ID!) {
  profile(id: $profileId) {
    id
    name
    listings(sort: $sort, pagination: $pagination) {
      title
      adSource
      categoryId
      imageUrls
      id
      url
      location {
        id
        name
      }
      price {
        type
        ... on StandardAmountPrice {
          amount
        }
        ... on AutosDealerAmountPrice {
          amount
        }
      }
    }
  }
}
    `;

/**
 * __useGetPosterOtherAdsQuery__
 *
 * To run a query within a React component, call `useGetPosterOtherAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosterOtherAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosterOtherAdsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetPosterOtherAdsQuery(baseOptions: Apollo.QueryHookOptions<GetPosterOtherAdsQuery, GetPosterOtherAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosterOtherAdsQuery, GetPosterOtherAdsQueryVariables>(GetPosterOtherAdsDocument, options);
      }
export function useGetPosterOtherAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosterOtherAdsQuery, GetPosterOtherAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosterOtherAdsQuery, GetPosterOtherAdsQueryVariables>(GetPosterOtherAdsDocument, options);
        }
export type GetPosterOtherAdsQueryHookResult = ReturnType<typeof useGetPosterOtherAdsQuery>;
export type GetPosterOtherAdsLazyQueryHookResult = ReturnType<typeof useGetPosterOtherAdsLazyQuery>;
export type GetPosterOtherAdsQueryResult = Apollo.QueryResult<GetPosterOtherAdsQuery, GetPosterOtherAdsQueryVariables>;
export const GetPromotedUrlsDocument = gql`
    query GetPromotedUrls($input: GetPromotedUrlsInput!) {
  getPromotedUrls(input: $input) {
    promotedUrls {
      url
      keywords
      categoryId
      locationId
    }
  }
}
    `;

/**
 * __useGetPromotedUrlsQuery__
 *
 * To run a query within a React component, call `useGetPromotedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotedUrlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPromotedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetPromotedUrlsQuery, GetPromotedUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotedUrlsQuery, GetPromotedUrlsQueryVariables>(GetPromotedUrlsDocument, options);
      }
export function useGetPromotedUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotedUrlsQuery, GetPromotedUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotedUrlsQuery, GetPromotedUrlsQueryVariables>(GetPromotedUrlsDocument, options);
        }
export type GetPromotedUrlsQueryHookResult = ReturnType<typeof useGetPromotedUrlsQuery>;
export type GetPromotedUrlsLazyQueryHookResult = ReturnType<typeof useGetPromotedUrlsLazyQuery>;
export type GetPromotedUrlsQueryResult = Apollo.QueryResult<GetPromotedUrlsQuery, GetPromotedUrlsQueryVariables>;
export const GetRequestViewingModalStateDocument = gql`
    query GetRequestViewingModalState {
  requestViewingState @client {
    isModalOpen
    notification
    mode
  }
}
    `;

/**
 * __useGetRequestViewingModalStateQuery__
 *
 * To run a query within a React component, call `useGetRequestViewingModalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestViewingModalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestViewingModalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequestViewingModalStateQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestViewingModalStateQuery, GetRequestViewingModalStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestViewingModalStateQuery, GetRequestViewingModalStateQueryVariables>(GetRequestViewingModalStateDocument, options);
      }
export function useGetRequestViewingModalStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestViewingModalStateQuery, GetRequestViewingModalStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestViewingModalStateQuery, GetRequestViewingModalStateQueryVariables>(GetRequestViewingModalStateDocument, options);
        }
export type GetRequestViewingModalStateQueryHookResult = ReturnType<typeof useGetRequestViewingModalStateQuery>;
export type GetRequestViewingModalStateLazyQueryHookResult = ReturnType<typeof useGetRequestViewingModalStateLazyQuery>;
export type GetRequestViewingModalStateQueryResult = Apollo.QueryResult<GetRequestViewingModalStateQuery, GetRequestViewingModalStateQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Account": [
      "PersonalAccount"
    ],
    "Ad": [
      "MoveAd",
      "OrganicAd"
    ],
    "AdCommon": [
      "MoveAd",
      "OrganicAd"
    ],
    "AmountPrice": [
      "AutosDealerAmountPrice",
      "StandardAmountPrice"
    ],
    "AppliedFilter": [
      "AppliedAdditionalFlagsFilter",
      "AppliedAttributeFilter",
      "AppliedDateFilter",
      "AppliedDateRangeFilter",
      "AppliedRangeFilter",
      "AppliedToggleFilter"
    ],
    "AutosInstantCashUnion": [
      "AutosInstantCashEstimate",
      "AutosInstantCashOffer"
    ],
    "BaseListing": [
      "FeedItem",
      "RecentlyViewedListings",
      "SRPListing"
    ],
    "ContentModule": [
      "BrowseHeroModule"
    ],
    "FeedResults": [
      "BrandedCategoryItem",
      "FeedItem",
      "PopularCategoryItem"
    ],
    "Filter": [
      "AttributeFilter",
      "DateFilter",
      "RangeFilter",
      "ToggleFilter"
    ],
    "FullListing": [
      "AutosListing",
      "RealEstateListing",
      "StandardListing"
    ],
    "LandingPageModule": [
      "BrowseHeroModule",
      "LPBillboardModule",
      "LPBrowseModule",
      "LPHeroModule",
      "LPLeaderboardModule"
    ],
    "Listing": [
      "AutosListing",
      "CoreListing",
      "RealEstateListing",
      "StandardListing"
    ],
    "ListingAttributes": [
      "AutosListingAttributes",
      "RealEstateListingAttributes",
      "StandardListingAttributes"
    ],
    "ListingFlags": [
      "AutosListingFlags",
      "RealEstateListingFlags",
      "StandardListingFlags"
    ],
    "ListingLocationInterface": [
      "ListingLocation",
      "RealEstateListingLocation"
    ],
    "ListingPrice": [
      "AutosDealerAmountPrice",
      "NonAmountPrice",
      "StandardAmountPrice"
    ],
    "Notification": [
      "EasyPriceDropNotification",
      "StandardNotification",
      "UserEligibleToReviewNotification",
      "UserReviewCreatedNotification",
      "UserReviewPublishedNotification"
    ],
    "ProfileV2": [
      "CommercialProfileV2",
      "StandardProfileV2"
    ],
    "RangeControlValues": [
      "MinMax",
      "StartEndDate"
    ]
  }
};
      export default result;
    